export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: any; output: any };
  JSON: { input: any; output: any };
};

export type Ablation = {
  __typename?: 'Ablation';
  ablationPrimaryProcedure?: Maybe<Scalars['String']['output']>;
  ablationType?: Maybe<Scalars['String']['output']>;
  admin7DayReadmission?: Maybe<Scalars['String']['output']>;
  admin7DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin14DayReadmission?: Maybe<Scalars['String']['output']>;
  admin14DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin30DayReadmission?: Maybe<Scalars['String']['output']>;
  admin30DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  adminInOutCode?: Maybe<Scalars['String']['output']>;
  adminMatch?: Maybe<Scalars['Float']['output']>;
  admissionUnit?: Maybe<Scalars['String']['output']>;
  admitSourceName?: Maybe<Scalars['String']['output']>;
  admitType?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  arrhythmiaType?: Maybe<Scalars['String']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  bedDays?: Maybe<Scalars['Float']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomePayor?: Maybe<Scalars['String']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  clinicianAFirstName?: Maybe<Scalars['String']['output']>;
  clinicianALastName?: Maybe<Scalars['String']['output']>;
  clinicianName?: Maybe<Scalars['String']['output']>;
  cmi?: Maybe<Scalars['String']['output']>;
  conditionGrouperL2?: Maybe<Scalars['String']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  dischargeMDName?: Maybe<Scalars['String']['output']>;
  dischargeUnit?: Maybe<Scalars['String']['output']>;
  drgCodeName?: Maybe<Scalars['String']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  elixhauserIndex?: Maybe<Scalars['Int']['output']>;
  encounterId?: Maybe<Scalars['Float']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  icdDxCodeCategory?: Maybe<Scalars['String']['output']>;
  icuDaysNumerator?: Maybe<Scalars['Int']['output']>;
  inDirectCost?: Maybe<Scalars['Float']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  laao?: Maybe<Scalars['String']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mortality?: Maybe<Scalars['Int']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  multiVisit?: Maybe<Scalars['Int']['output']>;
  netRevenue?: Maybe<Scalars['Float']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  principalDiagnosisICDCodeName?: Maybe<Scalars['String']['output']>;
  principalProcedureICDCodeName?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  procedureMDName?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  rawAdmitSourceName?: Maybe<Scalars['String']['output']>;
  rawDischargeStatus?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  readmissionWithWithout?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
  visitsPerEpisode?: Maybe<Scalars['Int']['output']>;
};

export enum AccessCategory {
  All = 'All',
  Biome = 'Biome',
  None = 'None',
}

export enum AccessChangeEvent {
  AdminPolicyChange = 'ADMIN_POLICY_CHANGE',
  CasePolicyChange = 'CASE_POLICY_CHANGE',
  ClinicianPolicyChange = 'CLINICIAN_POLICY_CHANGE',
  DashboardPolicyChange = 'DASHBOARD_POLICY_CHANGE',
  DistributionListChange = 'DISTRIBUTION_LIST_CHANGE',
  DsmPolicyChange = 'DSM_POLICY_CHANGE',
  EntityPolicyChange = 'ENTITY_POLICY_CHANGE',
  FilePolicyChange = 'File_POLICY_CHANGE',
  GeneralPolicyChange = 'GENERAL_POLICY_CHANGE',
  InitiativePolicyChange = 'INITIATIVE_POLICY_CHANGE',
  PatientListPolicyChange = 'PATIENT_LIST_POLICY_CHANGE',
  RoleChange = 'ROLE_CHANGE',
  StrategyBoardPolicyChange = 'STRATEGY_BOARD_POLICY_CHANGE',
  UserChange = 'USER_CHANGE',
  UserPolicyChange = 'USER_POLICY_CHANGE',
}

export type AccessHistory = {
  __typename?: 'AccessHistory';
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  current?: Maybe<Scalars['JSON']['output']>;
  distributionList?: Maybe<DistributionList>;
  distributionListId: Scalars['String']['output'];
  distributionListUserIds: Array<Scalars['String']['output']>;
  event?: Maybe<AccessChangeEvent>;
  id: Scalars['ID']['output'];
  previous?: Maybe<Scalars['JSON']['output']>;
  role?: Maybe<Role>;
  roleId: Scalars['String']['output'];
  roleUserIds?: Maybe<Array<Scalars['String']['output']>>;
  subject?: Maybe<Subject>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

export enum Action {
  Approve = 'Approve',
  Create = 'Create',
  Delete = 'Delete',
  Download = 'Download',
  Everything = 'Everything',
  ProvisionUsers = 'ProvisionUsers',
  Read = 'Read',
  ReadAllTenantPresentations = 'ReadAllTenantPresentations',
  ReadInternalRoles = 'ReadInternalRoles',
  Request = 'Request',
  SendToWorkflow = 'SendToWorkflow',
  SwitchUsers = 'SwitchUsers',
  Update = 'Update',
}

export type ActivityLog = {
  __typename?: 'ActivityLog';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  relatedData?: Maybe<Scalars['JSON']['output']>;
  type: ActivityLogType;
};

export enum ActivityLogType {
  ArchiveInitiative = 'ARCHIVE_INITIATIVE',
  ClientDataMartsCleanup = 'CLIENT_DATA_MARTS_CLEANUP',
  ContentAccess = 'CONTENT_ACCESS',
  CreateSubmission = 'CREATE_SUBMISSION',
  CrosswalkApplicationOverride = 'CROSSWALK_APPLICATION_OVERRIDE',
  CrosswalkLoadOverride = 'CROSSWALK_LOAD_OVERRIDE',
  DataframeIgnoreMaskerWarnings = 'DATAFRAME_IGNORE_MASKER_WARNINGS',
  DataframeManualOverride = 'DATAFRAME_MANUAL_OVERRIDE',
  DeleteInitiative = 'DELETE_INITIATIVE',
  DeleteOdinUser = 'DELETE_ODIN_USER',
  DeleteSubmission = 'DELETE_SUBMISSION',
  EditSubmission = 'EDIT_SUBMISSION',
  FileDownload = 'FILE_DOWNLOAD',
  FileShareWithMessage = 'FILE_SHARE_WITH_MESSAGE',
  MaskedDataCleanup = 'MASKED_DATA_CLEANUP',
  NonPhiFileCleanup = 'NON_PHI_FILE_CLEANUP',
  OdinDataCleanup = 'ODIN_DATA_CLEANUP',
  OeValidationOverride = 'OE_VALIDATION_OVERRIDE',
  OffboardingValidation = 'OFFBOARDING_VALIDATION',
  PatientListDisclaimerConfirmation = 'PATIENT_LIST_DISCLAIMER_CONFIRMATION',
  PatientListDownload = 'PATIENT_LIST_DOWNLOAD',
  PatientListRead = 'PATIENT_LIST_READ',
  PhiDataCleanup = 'PHI_DATA_CLEANUP',
  PhiFileDownloadDenied = 'PHI_FILE_DOWNLOAD_DENIED',
  PipelineDataCleanup = 'PIPELINE_DATA_CLEANUP',
  PostetlValidationOverride = 'POSTETL_VALIDATION_OVERRIDE',
  PreetlValidationOverride = 'PREETL_VALIDATION_OVERRIDE',
  PublicFileAccess = 'PUBLIC_FILE_ACCESS',
  PublicFileDownload = 'PUBLIC_FILE_DOWNLOAD',
  ReceivedFileCleanup = 'RECEIVED_FILE_CLEANUP',
  RunstatsCleanup = 'RUNSTATS_CLEANUP',
  SubmissionInquiry = 'SUBMISSION_INQUIRY',
  TenantOffboardingApproved = 'TENANT_OFFBOARDING_APPROVED',
  TenantOffboardingCancelled = 'TENANT_OFFBOARDING_CANCELLED',
  TenantOffboardingCascaded = 'TENANT_OFFBOARDING_CASCADED',
  TenantOffboardingDiscoveryStarted = 'TENANT_OFFBOARDING_DISCOVERY_STARTED',
  TenantOffboardingDryrunComplete = 'TENANT_OFFBOARDING_DRYRUN_COMPLETE',
  TenantOffboardingDryrunFailed = 'TENANT_OFFBOARDING_DRYRUN_FAILED',
  TenantOffboardingFailed = 'TENANT_OFFBOARDING_FAILED',
  TenantOffboardingRejected = 'TENANT_OFFBOARDING_REJECTED',
  TenantOffboardingRequested = 'TENANT_OFFBOARDING_REQUESTED',
  TenantOffboardingSuccessful = 'TENANT_OFFBOARDING_SUCCESSFUL',
  TenantOffboardingValidationFailed = 'TENANT_OFFBOARDING_VALIDATION_FAILED',
}

export type AdminPolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  eft?: InputMaybe<Scalars['String']['input']>;
  objectType: Scalars['String']['input'];
  resource: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type Afib = {
  __typename?: 'Afib';
  ablationStrategies?: Maybe<Scalars['String']['output']>;
  ablationStrategiesTruncated?: Maybe<Scalars['String']['output']>;
  ablationStrategyCount?: Maybe<Scalars['Int']['output']>;
  adjunctiveAblationLesions?: Maybe<Scalars['String']['output']>;
  adjunctiveAblationLesionsCount?: Maybe<Scalars['Int']['output']>;
  adjunctiveAblationLesionsTruncated?: Maybe<Scalars['String']['output']>;
  adjunctiveAblationLesionsYN?: Maybe<Scalars['String']['output']>;
  adminMatch?: Maybe<Scalars['Float']['output']>;
  admitDayOfWeek?: Maybe<Scalars['String']['output']>;
  admitSourceName?: Maybe<Scalars['String']['output']>;
  afibSurgicalAblation?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  atrialFibrillationClassification?: Maybe<Scalars['String']['output']>;
  atrialFlutter?: Maybe<Scalars['String']['output']>;
  biomeConditionGroup?: Maybe<Scalars['String']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomePayor?: Maybe<Scalars['String']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  chronicLungDisease?: Maybe<Scalars['String']['output']>;
  clinicianALastName?: Maybe<Scalars['String']['output']>;
  complicationList?: Maybe<Scalars['String']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  distance?: Maybe<Scalars['String']['output']>;
  distanceInMilesBucket?: Maybe<Scalars['String']['output']>;
  drgCode?: Maybe<Scalars['String']['output']>;
  drgName?: Maybe<Scalars['String']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  guidanceMethods?: Maybe<Scalars['String']['output']>;
  guidanceMethodsTruncated?: Maybe<Scalars['String']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  modality?: Maybe<Scalars['String']['output']>;
  modalityTruncated?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  primaryInsGroupDescription?: Maybe<Scalars['String']['output']>;
  principalProcedureName?: Maybe<Scalars['String']['output']>;
  priorAblationStrategyTruncated?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  procedureEndDate?: Maybe<Scalars['DateTime']['output']>;
  procedureEndTime?: Maybe<Scalars['String']['output']>;
  procedureStartDate?: Maybe<Scalars['DateTime']['output']>;
  procedureStartTime?: Maybe<Scalars['String']['output']>;
  procedureStatus?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  transseptalCatheterization?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
};

export type AggregateBeat = {
  __typename?: 'AggregateBeat';
  actionTaken?: Maybe<Scalars['Boolean']['output']>;
  actionable?: Maybe<Scalars['Boolean']['output']>;
  beats: Array<Beat>;
  careEntity: CareEntity;
  careEntityId: Scalars['String']['output'];
  children?: Maybe<Array<AggregateBeat>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModuleId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  matchRate?: Maybe<Scalars['Float']['output']>;
  month: Month;
  parent?: Maybe<AggregateBeat>;
  state: BeatState;
  triggerJiraReleaseTicket?: Maybe<Scalars['Boolean']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
  year: Scalars['Int']['output'];
};

export enum AggregationRollupMode {
  Gated = 'Gated',
  Rolling = 'Rolling',
}

export type Ami = {
  __typename?: 'Ami';
  admin7DayReadmission?: Maybe<Scalars['String']['output']>;
  admin7DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin14DayReadmission?: Maybe<Scalars['String']['output']>;
  admin14DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin30DayReadmission?: Maybe<Scalars['String']['output']>;
  admin30DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  adminInOutCode?: Maybe<Scalars['String']['output']>;
  adminMatch?: Maybe<Scalars['Float']['output']>;
  admissionUnit?: Maybe<Scalars['String']['output']>;
  admitDayOfWeek?: Maybe<Scalars['String']['output']>;
  admitSourceName?: Maybe<Scalars['String']['output']>;
  admitType?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  ageGroup?: Maybe<Scalars['String']['output']>;
  amiPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  anyVADProcedure?: Maybe<Scalars['String']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  attribute?: Maybe<Scalars['String']['output']>;
  bedDays?: Maybe<Scalars['Float']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomePayor?: Maybe<Scalars['String']['output']>;
  cardiacArrest?: Maybe<Scalars['String']['output']>;
  cardiacUS?: Maybe<Scalars['String']['output']>;
  cardioMEMS?: Maybe<Scalars['String']['output']>;
  cardioShock?: Maybe<Scalars['String']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  cath?: Maybe<Scalars['String']['output']>;
  chfAcute?: Maybe<Scalars['String']['output']>;
  chfAcuteOnChronic?: Maybe<Scalars['String']['output']>;
  chfChronicUspec?: Maybe<Scalars['String']['output']>;
  ckdStageIVorV?: Maybe<Scalars['String']['output']>;
  clinicianAFirstName?: Maybe<Scalars['String']['output']>;
  clinicianALastName?: Maybe<Scalars['String']['output']>;
  clinicianName?: Maybe<Scalars['String']['output']>;
  cmi?: Maybe<Scalars['String']['output']>;
  conditionGrouperL2?: Maybe<Scalars['String']['output']>;
  ctScan?: Maybe<Scalars['String']['output']>;
  daysToReadmission?: Maybe<Scalars['String']['output']>;
  daysToReadmissionBins?: Maybe<Scalars['String']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDayOfWeek?: Maybe<Scalars['String']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  dischargeMDName?: Maybe<Scalars['String']['output']>;
  dischargeStatus?: Maybe<Scalars['String']['output']>;
  dischargeUnit?: Maybe<Scalars['String']['output']>;
  distanceFromHospital?: Maybe<Scalars['String']['output']>;
  distanceInMilesBucket?: Maybe<Scalars['String']['output']>;
  drgCodeName?: Maybe<Scalars['String']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  elixhauserIndex?: Maybe<Scalars['Int']['output']>;
  elixhauserRiskBuckets?: Maybe<Scalars['String']['output']>;
  encounterId?: Maybe<Scalars['Float']['output']>;
  endStageRenal?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  heartTransplant?: Maybe<Scalars['String']['output']>;
  heartTransplantType?: Maybe<Scalars['String']['output']>;
  hypovolShock?: Maybe<Scalars['String']['output']>;
  icdDxCodeCategory?: Maybe<Scalars['String']['output']>;
  icuDaysNumerator?: Maybe<Scalars['Int']['output']>;
  icuUtilizationAny?: Maybe<Scalars['String']['output']>;
  inDirectCost?: Maybe<Scalars['Float']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  losLess1?: Maybe<Scalars['String']['output']>;
  losLess2?: Maybe<Scalars['String']['output']>;
  mdcName?: Maybe<Scalars['String']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  medicare?: Maybe<Scalars['String']['output']>;
  mitraClip?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mortality?: Maybe<Scalars['Int']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  multiVisit?: Maybe<Scalars['Int']['output']>;
  netRevenue?: Maybe<Scalars['Float']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  otherShock?: Maybe<Scalars['String']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  overall?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  primaryProcPostLOSMore2?: Maybe<Scalars['String']['output']>;
  primaryProcPreLOSLess1?: Maybe<Scalars['String']['output']>;
  principalDiagnosisICDCodeName?: Maybe<Scalars['String']['output']>;
  principalProcedureICDCodeName?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  procedureMDName?: Maybe<Scalars['String']['output']>;
  pulmonaryEmbol?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  rawAdmitSourceName?: Maybe<Scalars['String']['output']>;
  rawDischargeStatus?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionAdmitDayOfWeek?: Maybe<Scalars['String']['output']>;
  readmissionAdmitSourceName?: Maybe<Scalars['String']['output']>;
  readmissionAdmitType?: Maybe<Scalars['String']['output']>;
  readmissionConditionGrouperL2?: Maybe<Scalars['String']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDischargeStatus?: Maybe<Scalars['String']['output']>;
  readmissionDrgName?: Maybe<Scalars['String']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  readmissionICDPrimaryProcedure?: Maybe<Scalars['String']['output']>;
  readmissionInOutCode?: Maybe<Scalars['String']['output']>;
  readmissionReason?: Maybe<Scalars['String']['output']>;
  readmissionSummaryPayorClass?: Maybe<Scalars['String']['output']>;
  readmissionWithWithout?: Maybe<Scalars['String']['output']>;
  referringMDRole?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  renalFailAcute?: Maybe<Scalars['String']['output']>;
  respArrest?: Maybe<Scalars['String']['output']>;
  respFailAcute?: Maybe<Scalars['String']['output']>;
  sepsis?: Maybe<Scalars['String']['output']>;
  tavr?: Maybe<Scalars['String']['output']>;
  transplantType?: Maybe<Scalars['String']['output']>;
  vadPoa?: Maybe<Scalars['String']['output']>;
  vadProcedureType?: Maybe<Scalars['String']['output']>;
  ventrFibrillation?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
  visitsPerEpisode?: Maybe<Scalars['Int']['output']>;
};

export type AngioscopeMeasure = {
  __typename?: 'AngioscopeMeasure';
  alignmentStrength: Scalars['String']['output'];
  alignmentStrengthCode: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  dsm: Scalars['String']['output'];
  measureId: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  reasoning: Scalars['String']['output'];
};

export type Application = {
  __typename?: 'Application';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type ApplicationNotice = {
  __typename?: 'ApplicationNotice';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description: Scalars['String']['output'];
  downtime?: Maybe<Scalars['Boolean']['output']>;
  downtimeDescription?: Maybe<Scalars['String']['output']>;
  downtimeEnd?: Maybe<Scalars['DateTime']['output']>;
  downtimeName?: Maybe<Scalars['String']['output']>;
  downtimeStart?: Maybe<Scalars['DateTime']['output']>;
  downtimeTitle?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  startTime: Scalars['DateTime']['output'];
  tenants?: Maybe<Array<Tenant>>;
  title: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type Arrhythmia = {
  __typename?: 'Arrhythmia';
  ablation?: Maybe<Scalars['String']['output']>;
  admin7DayReadmission?: Maybe<Scalars['String']['output']>;
  admin7DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin14DayReadmission?: Maybe<Scalars['String']['output']>;
  admin14DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin30DayReadmission?: Maybe<Scalars['String']['output']>;
  admin30DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  adminInOutCode?: Maybe<Scalars['String']['output']>;
  adminMatch?: Maybe<Scalars['Float']['output']>;
  admissionUnit?: Maybe<Scalars['String']['output']>;
  admitDayOfWeek?: Maybe<Scalars['String']['output']>;
  admitSourceName?: Maybe<Scalars['String']['output']>;
  admitType?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  ageGroup?: Maybe<Scalars['String']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  arrhythmiaPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  attribute?: Maybe<Scalars['String']['output']>;
  bedDays?: Maybe<Scalars['Float']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomePayor?: Maybe<Scalars['String']['output']>;
  cardiacArrest?: Maybe<Scalars['String']['output']>;
  cardiacUS?: Maybe<Scalars['String']['output']>;
  cardioMEMS?: Maybe<Scalars['String']['output']>;
  cardioShock?: Maybe<Scalars['String']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  cath?: Maybe<Scalars['String']['output']>;
  chfAcute?: Maybe<Scalars['String']['output']>;
  chfAcuteOnChronic?: Maybe<Scalars['String']['output']>;
  chfChronicUspec?: Maybe<Scalars['String']['output']>;
  ckdStageIVorV?: Maybe<Scalars['String']['output']>;
  clinicianAFirstName?: Maybe<Scalars['String']['output']>;
  clinicianALastName?: Maybe<Scalars['String']['output']>;
  clinicianName?: Maybe<Scalars['String']['output']>;
  cmi?: Maybe<Scalars['String']['output']>;
  conditionGrouperL2?: Maybe<Scalars['String']['output']>;
  ctScan?: Maybe<Scalars['String']['output']>;
  daysToReadmission?: Maybe<Scalars['String']['output']>;
  daysToReadmissionBins?: Maybe<Scalars['String']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDayOfWeek?: Maybe<Scalars['String']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  dischargeMDName?: Maybe<Scalars['String']['output']>;
  dischargeStatus?: Maybe<Scalars['String']['output']>;
  dischargeUnit?: Maybe<Scalars['String']['output']>;
  distanceFromHospital?: Maybe<Scalars['String']['output']>;
  distanceInMilesBucket?: Maybe<Scalars['String']['output']>;
  drgCodeName?: Maybe<Scalars['String']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  elixhauserIndex?: Maybe<Scalars['Int']['output']>;
  elixhauserRiskBuckets?: Maybe<Scalars['String']['output']>;
  encounterId?: Maybe<Scalars['Float']['output']>;
  endStageRenal?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hypovolShock?: Maybe<Scalars['String']['output']>;
  icd?: Maybe<Scalars['String']['output']>;
  icdDxCodeCategory?: Maybe<Scalars['String']['output']>;
  icuDaysNumerator?: Maybe<Scalars['Int']['output']>;
  icuUtilizationAny?: Maybe<Scalars['String']['output']>;
  inDirectCost?: Maybe<Scalars['Float']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  leadExtraction?: Maybe<Scalars['String']['output']>;
  losLess1?: Maybe<Scalars['String']['output']>;
  losLess2?: Maybe<Scalars['String']['output']>;
  mdcName?: Maybe<Scalars['String']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  medicare?: Maybe<Scalars['String']['output']>;
  mitraClip?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mortality?: Maybe<Scalars['Int']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  multiVisit?: Maybe<Scalars['Int']['output']>;
  netRevenue?: Maybe<Scalars['Float']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  otherShock?: Maybe<Scalars['String']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  overall?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  ppm?: Maybe<Scalars['String']['output']>;
  primaryProcPostLOSMore2?: Maybe<Scalars['String']['output']>;
  primaryProcPreLOSLess1?: Maybe<Scalars['String']['output']>;
  principalDiagnosisICDCodeName?: Maybe<Scalars['String']['output']>;
  principalProcedureICDCodeName?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  procedureMDName?: Maybe<Scalars['String']['output']>;
  pulmonaryEmbol?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  rawAdmitSourceName?: Maybe<Scalars['String']['output']>;
  rawDischargeStatus?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionAdmitDayOfWeek?: Maybe<Scalars['String']['output']>;
  readmissionAdmitSourceName?: Maybe<Scalars['String']['output']>;
  readmissionAdmitType?: Maybe<Scalars['String']['output']>;
  readmissionConditionGrouperL2?: Maybe<Scalars['String']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDischargeStatus?: Maybe<Scalars['String']['output']>;
  readmissionDrgName?: Maybe<Scalars['String']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  readmissionICDPrimaryProcedure?: Maybe<Scalars['String']['output']>;
  readmissionInOutCode?: Maybe<Scalars['String']['output']>;
  readmissionReason?: Maybe<Scalars['String']['output']>;
  readmissionSummaryPayorClass?: Maybe<Scalars['String']['output']>;
  readmissionWithWithout?: Maybe<Scalars['String']['output']>;
  referringMDRole?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  renalFailAcute?: Maybe<Scalars['String']['output']>;
  respArrest?: Maybe<Scalars['String']['output']>;
  respFailAcute?: Maybe<Scalars['String']['output']>;
  sepsis?: Maybe<Scalars['String']['output']>;
  tavr?: Maybe<Scalars['String']['output']>;
  tempPacer?: Maybe<Scalars['String']['output']>;
  ventrFibrillation?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
  visitsPerEpisode?: Maybe<Scalars['Int']['output']>;
};

export type AscendOutput = {
  __typename?: 'AscendOutput';
  componentId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataflowRun: DataflowRun;
  dataflowRunId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  originalLocation: AscendOutputLocation;
  state: AscendOutputState;
  storedLocation: AscendOutputLocation;
  type: AscendOutputType;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
};

export type AscendOutputLocation = {
  __typename?: 'AscendOutputLocation';
  location?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum AscendOutputState {
  Done = 'Done',
  Error = 'Error',
  Pending = 'Pending',
}

export enum AscendOutputType {
  DataFeed = 'DataFeed',
  PseudoWriteTransform = 'PseudoWriteTransform',
  WriteConnector = 'WriteConnector',
}

export type AuditFlagStatus = {
  __typename?: 'AuditFlagStatus';
  count: Scalars['Int']['output'];
  status: RiskAuditTrailStatus;
};

export type AuditFlagSummary = {
  __typename?: 'AuditFlagSummary';
  riskValue: Scalars['String']['output'];
  statuses: Array<AuditFlagStatus>;
  totalCount: Scalars['Int']['output'];
};

export enum AuditourCategory {
  PostEtl = 'PostETL',
  PreEtl = 'PreETL',
  Raw = 'Raw',
}

export type AuditourReport = {
  __typename?: 'AuditourReport';
  category: AuditourCategory;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataflowRequest: DataflowRequest;
  dataflowRequestId: Scalars['String']['output'];
  dataflowRun: DataflowRun;
  dataflowRunId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  oePipelineRun: OePipelineRun;
  oePipelineRunId: Scalars['String']['output'];
  reportId?: Maybe<Scalars['Int']['output']>;
  state: ValidationStatus;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
};

export type Beat = {
  __typename?: 'Beat';
  actionTaken?: Maybe<Scalars['Boolean']['output']>;
  actionable?: Maybe<Scalars['Boolean']['output']>;
  aggregateBeats?: Maybe<Array<AggregateBeat>>;
  careEntity: CareEntity;
  careEntityId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  datasetInstances: Array<DatasetInstance>;
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModuleId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastEventId?: Maybe<Scalars['String']['output']>;
  lifelineEvents?: Maybe<Array<LifelineEvent>>;
  month: Month;
  requestedDate?: Maybe<Scalars['DateTime']['output']>;
  requiresCrosswalk?: Maybe<Scalars['Boolean']['output']>;
  state: BeatState;
  submissions?: Maybe<Array<Submission>>;
  triggerJiraReleaseTicket?: Maybe<Scalars['Boolean']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
  year: Scalars['Int']['output'];
};

export enum BeatState {
  Complete = 'COMPLETE',
  Inprogress = 'INPROGRESS',
  Unfilled = 'UNFILLED',
}

export enum BiomeUserRegion {
  Pk = 'PK',
  Us = 'US',
}

export type Bookmark = {
  __typename?: 'Bookmark';
  category: BookmarkCategory;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  /** Description of the bookmark */
  description?: Maybe<Scalars['String']['output']>;
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  url: Scalars['String']['output'];
  user?: Maybe<User>;
  users?: Maybe<Array<User>>;
};

export enum BookmarkCategory {
  Dashboard = 'DASHBOARD',
  Homepage = 'HOMEPAGE',
}

export type BulkSlidesInput = {
  order?: InputMaybe<Scalars['Float']['input']>;
  shareableLink?: InputMaybe<Scalars['String']['input']>;
  slideTemplate?: InputMaybe<SlideTemplate>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CachedMeasureMetadata = {
  __typename?: 'CachedMeasureMetadata';
  commonMeasureDisplayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum CardinalityType {
  OneToN = 'OneToN',
  OneToOne = 'OneToOne',
  ZeroToN = 'ZeroToN',
  ZeroToOne = 'ZeroToOne',
  ZeroToZero = 'ZeroToZero',
}

export type Cardiogenicshock = {
  __typename?: 'Cardiogenicshock';
  admin7DayReadmission?: Maybe<Scalars['String']['output']>;
  admin7DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin14DayReadmission?: Maybe<Scalars['String']['output']>;
  admin14DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin30DayReadmission?: Maybe<Scalars['String']['output']>;
  admin30DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  adminInOutCode?: Maybe<Scalars['String']['output']>;
  adminMatch?: Maybe<Scalars['Float']['output']>;
  admissionUnit?: Maybe<Scalars['String']['output']>;
  admitDayOfWeek?: Maybe<Scalars['String']['output']>;
  admitSourceName?: Maybe<Scalars['String']['output']>;
  admitType?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  ageGroup?: Maybe<Scalars['String']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  anyVADProcedure?: Maybe<Scalars['String']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  attribute?: Maybe<Scalars['String']['output']>;
  bedDays?: Maybe<Scalars['Float']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomePayor?: Maybe<Scalars['String']['output']>;
  cardiacArrest?: Maybe<Scalars['String']['output']>;
  cardiacUS?: Maybe<Scalars['String']['output']>;
  cardioMEMS?: Maybe<Scalars['String']['output']>;
  cardioShock?: Maybe<Scalars['String']['output']>;
  cardiogenicShockPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  cath?: Maybe<Scalars['String']['output']>;
  chfAcute?: Maybe<Scalars['String']['output']>;
  chfAcuteOnChronic?: Maybe<Scalars['String']['output']>;
  chfChronicUspec?: Maybe<Scalars['String']['output']>;
  ckdStageIVorV?: Maybe<Scalars['String']['output']>;
  clinicianAFirstName?: Maybe<Scalars['String']['output']>;
  clinicianALastName?: Maybe<Scalars['String']['output']>;
  clinicianName?: Maybe<Scalars['String']['output']>;
  cmi?: Maybe<Scalars['String']['output']>;
  conditionGrouperL2?: Maybe<Scalars['String']['output']>;
  ctScan?: Maybe<Scalars['String']['output']>;
  daysToReadmission?: Maybe<Scalars['String']['output']>;
  daysToReadmissionBins?: Maybe<Scalars['String']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDayOfWeek?: Maybe<Scalars['String']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  dischargeMDName?: Maybe<Scalars['String']['output']>;
  dischargeStatus?: Maybe<Scalars['String']['output']>;
  dischargeUnit?: Maybe<Scalars['String']['output']>;
  distanceFromHospital?: Maybe<Scalars['String']['output']>;
  distanceInMilesBucket?: Maybe<Scalars['String']['output']>;
  drgCodeName?: Maybe<Scalars['String']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  elixhauserIndex?: Maybe<Scalars['Int']['output']>;
  elixhauserRiskBuckets?: Maybe<Scalars['String']['output']>;
  encounterId?: Maybe<Scalars['Float']['output']>;
  endStageRenal?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  heartTransplant?: Maybe<Scalars['String']['output']>;
  heartTransplantType?: Maybe<Scalars['String']['output']>;
  hypovolShock?: Maybe<Scalars['String']['output']>;
  icdDxCodeCategory?: Maybe<Scalars['String']['output']>;
  icuDaysNumerator?: Maybe<Scalars['Int']['output']>;
  icuUtilizationAny?: Maybe<Scalars['String']['output']>;
  inDirectCost?: Maybe<Scalars['Float']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  losLess1?: Maybe<Scalars['String']['output']>;
  losLess2?: Maybe<Scalars['String']['output']>;
  mdcName?: Maybe<Scalars['String']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  medicare?: Maybe<Scalars['String']['output']>;
  mitraClip?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mortality?: Maybe<Scalars['Int']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  multiVisit?: Maybe<Scalars['Int']['output']>;
  netRevenue?: Maybe<Scalars['Float']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  otherShock?: Maybe<Scalars['String']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  overall?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  primaryProcPostLOSMore2?: Maybe<Scalars['String']['output']>;
  primaryProcPreLOSLess1?: Maybe<Scalars['String']['output']>;
  principalDiagnosisICDCodeName?: Maybe<Scalars['String']['output']>;
  principalProcedureICDCodeName?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  procedureMDName?: Maybe<Scalars['String']['output']>;
  pulmonaryEmbol?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  rawAdmitSourceName?: Maybe<Scalars['String']['output']>;
  rawDischargeStatus?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionAdmitDayOfWeek?: Maybe<Scalars['String']['output']>;
  readmissionAdmitSourceName?: Maybe<Scalars['String']['output']>;
  readmissionAdmitType?: Maybe<Scalars['String']['output']>;
  readmissionConditionGrouperL2?: Maybe<Scalars['String']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDischargeStatus?: Maybe<Scalars['String']['output']>;
  readmissionDrgName?: Maybe<Scalars['String']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  readmissionICDPrimaryProcedure?: Maybe<Scalars['String']['output']>;
  readmissionInOutCode?: Maybe<Scalars['String']['output']>;
  readmissionReason?: Maybe<Scalars['String']['output']>;
  readmissionSummaryPayorClass?: Maybe<Scalars['String']['output']>;
  readmissionWithWithout?: Maybe<Scalars['String']['output']>;
  referringMDRole?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  renalFailAcute?: Maybe<Scalars['String']['output']>;
  respArrest?: Maybe<Scalars['String']['output']>;
  respFailAcute?: Maybe<Scalars['String']['output']>;
  sepsis?: Maybe<Scalars['String']['output']>;
  tavr?: Maybe<Scalars['String']['output']>;
  transplantType?: Maybe<Scalars['String']['output']>;
  vadPoa?: Maybe<Scalars['String']['output']>;
  vadProcedureType?: Maybe<Scalars['String']['output']>;
  ventrFibrillation?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
  visitsPerEpisode?: Maybe<Scalars['Int']['output']>;
};

export type CareEntity = {
  __typename?: 'CareEntity';
  active: Scalars['Boolean']['output'];
  aggregateBeats: Array<AggregateBeat>;
  aggregated: Scalars['Boolean']['output'];
  alternateNames?: Maybe<Array<Scalars['String']['output']>>;
  anonymousCode?: Maybe<Scalars['String']['output']>;
  /** Archived DSMs this care entity participates in, which `diseaseStateModules` leaves out. */
  archivedDiseaseStateModules: Array<DiseaseStateModule>;
  beats: Array<Beat>;
  business?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<CareEntity>>;
  city?: Maybe<Scalars['String']['output']>;
  cmsId?: Maybe<Scalars['String']['output']>;
  cmsIdNotAvailable: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataframes: Array<DataFrame>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  diseaseStateModules: Array<DiseaseStateModule>;
  echoFollowupOptions: Array<EchoFindingFollowupOption>;
  excludedDsms: Array<DiseaseStateModule>;
  id: Scalars['ID']['output'];
  ids?: Maybe<Array<Scalars['String']['output']>>;
  includeInBenchmarks: Scalars['Boolean']['output'];
  invoiceMonth?: Maybe<Scalars['Int']['output']>;
  isEngagementEntity: Scalars['Boolean']['output'];
  /** Per-member DSM scoping for this aggregate. A member absent from this list contributes all of its own DSMs. On the parent because a care entity can have several parents, so the value is undefined without knowing which parent is asking. */
  memberDsms: Array<CareEntityMemberDsm>;
  monthlySponsorTouchbase: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  noOfBeds?: Maybe<Scalars['Int']['output']>;
  onboardingCompletedOn?: Maybe<Scalars['DateTime']['output']>;
  parents?: Maybe<Array<CareEntity>>;
  physicianChampion?: Maybe<Scalars['String']['output']>;
  projectSponsor?: Maybe<Scalars['String']['output']>;
  pushOnlyDsms: Array<DiseaseStateModule>;
  reasonForNoCmsId?: Maybe<Scalars['String']['output']>;
  reviewDsms: Array<DiseaseStateModule>;
  roles?: Maybe<Array<Role>>;
  shortDisplayName?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  submissions: Array<Submission>;
  supportedApps?: Maybe<Array<SupportedApps>>;
  teaching: Scalars['Boolean']['output'];
  tenants: Array<Tenant>;
  type: CareEntityType;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  usGeoRegion?: Maybe<UsGeoRegion>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type CareEntityDsmPair = {
  __typename?: 'CareEntityDsmPair';
  careEntityId: Scalars['ID']['output'];
  dsmId: Scalars['Int']['output'];
};

export type CareEntityMemberDsm = {
  __typename?: 'CareEntityMemberDsm';
  childId: Scalars['ID']['output'];
  diseaseStateModules: Array<DiseaseStateModule>;
};

export type CareEntityMemberDsmInput = {
  childId: Scalars['ID']['input'];
  /** An empty array unscopes the edge: it then participates for all of the child's DSMs. */
  diseaseStateModules: Array<UpdateDiseaseStateModuleInput>;
};

export enum CareEntityType {
  Campus = 'Campus',
  Clinic = 'Clinic',
  Hospital = 'Hospital',
  Region = 'Region',
  System = 'System',
}

export type CareEntityUpdateImpact = {
  __typename?: 'CareEntityUpdateImpact';
  childrenAdditionImpact?: Maybe<Array<Scalars['String']['output']>>;
  childrenRemovalImpact?: Maybe<Array<Role>>;
  dsmAdditionImpact?: Maybe<DsmAdditionImpact>;
  dsmRemovalImpact?: Maybe<DsmRemovalImpact>;
  memberDsmImpact?: Maybe<Array<Scalars['String']['output']>>;
  usersImpacted?: Maybe<Array<User>>;
};

export type CasePolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  eft?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  resource: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type CaseStudyStatus = {
  __typename?: 'CaseStudyStatus';
  displayRank: Scalars['Float']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type CathAudit = {
  __typename?: 'CathAudit';
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  auditFlagSource?: Maybe<Scalars['String']['output']>;
  auditId: Scalars['Float']['output'];
  biomeETLVersion?: Maybe<Scalars['String']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomeUpdateDt?: Maybe<Scalars['DateTime']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityCode?: Maybe<Scalars['String']['output']>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  careEntityName?: Maybe<Scalars['String']['output']>;
  diagnosisPOACodeList?: Maybe<Scalars['String']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDate?: Maybe<Scalars['DateTime']['output']>;
  dischargeQuarter?: Maybe<Scalars['String']['output']>;
  dischargeYear?: Maybe<Scalars['String']['output']>;
  diseaseStateModule?: Maybe<DiseaseStateModule>;
  diseaseStateModuleId?: Maybe<Scalars['String']['output']>;
  drgCode?: Maybe<Scalars['String']['output']>;
  encounterId?: Maybe<Scalars['String']['output']>;
  etlRefresh?: Maybe<Scalars['DateTime']['output']>;
  flagType?: Maybe<FlagType>;
  icd10TriggerCode?: Maybe<Scalars['String']['output']>;
  keyField?: Maybe<Scalars['String']['output']>;
  keyFieldValue?: Maybe<Scalars['String']['output']>;
  mrn?: Maybe<Scalars['String']['output']>;
  mrnOriginal?: Maybe<Scalars['String']['output']>;
  netRevenue?: Maybe<Scalars['Float']['output']>;
  pciIndication?: Maybe<Scalars['String']['output']>;
  pciStatus?: Maybe<Scalars['String']['output']>;
  physician?: Maybe<Scalars['String']['output']>;
  procedure?: Maybe<Scalars['String']['output']>;
  procedureDate?: Maybe<Scalars['DateTime']['output']>;
  procedureGroup?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  reviewTriggerDescription?: Maybe<Scalars['String']['output']>;
  riskReview?: Maybe<Scalars['String']['output']>;
  riskValue?: Maybe<Scalars['String']['output']>;
  surgicalQuarter?: Maybe<Scalars['String']['output']>;
  surgicalYear?: Maybe<Scalars['String']['output']>;
  tenantCode?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  trails: Array<CathAuditTrail>;
  visitId?: Maybe<Scalars['Float']['output']>;
  visitTiming?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

export type CathAuditTrail = {
  __typename?: 'CathAuditTrail';
  auditTask?: Maybe<CathAudit>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  diseaseStateModuleId: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  latestStudyOnRecord: Scalars['Boolean']['output'];
  notes: Scalars['String']['output'];
  /** Tracks the status of audit trail */
  status: RiskAuditTrailStatus;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type CathPci = {
  __typename?: 'CathPci';
  accessAndClosure?: Maybe<Scalars['String']['output']>;
  accessSite?: Maybe<Scalars['String']['output']>;
  adminMatch?: Maybe<Scalars['Float']['output']>;
  admitSourceName?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  ageGroup?: Maybe<Scalars['String']['output']>;
  akiWithWithout?: Maybe<Scalars['String']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  anyCardiacArrest?: Maybe<Scalars['String']['output']>;
  arrivalDayOfWeek?: Maybe<Scalars['String']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  biomeConditionGroup?: Maybe<Scalars['String']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  cadPresentation?: Maybe<Scalars['String']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  clinicalACSProc?: Maybe<Scalars['String']['output']>;
  clinicalPCIProcedureGroup?: Maybe<Scalars['String']['output']>;
  clinicianAFirstName?: Maybe<Scalars['String']['output']>;
  clinicianALastName?: Maybe<Scalars['String']['output']>;
  complicationList?: Maybe<Scalars['String']['output']>;
  cto?: Maybe<Scalars['String']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  diagCathCompleted?: Maybe<Scalars['Int']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDayOfWeek?: Maybe<Scalars['String']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  dischargeLocation?: Maybe<Scalars['String']['output']>;
  drgCode?: Maybe<Scalars['Int']['output']>;
  drgName?: Maybe<Scalars['String']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  fullAKIRisk?: Maybe<Scalars['Float']['output']>;
  fullBleedingRisk?: Maybe<Scalars['Float']['output']>;
  fullMortalityRisk?: Maybe<Scalars['Float']['output']>;
  fullMortalityRiskBucket?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  los?: Maybe<Scalars['Float']['output']>;
  losAp?: Maybe<Scalars['Float']['output']>;
  losPd?: Maybe<Scalars['Float']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mortality?: Maybe<Scalars['String']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  multiVesselDisease?: Maybe<Scalars['String']['output']>;
  netRevenue?: Maybe<Scalars['Float']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  otherProcedure?: Maybe<Scalars['String']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  pciAdmitStatus?: Maybe<Scalars['String']['output']>;
  pciBleedEventList?: Maybe<Scalars['String']['output']>;
  pciIndication?: Maybe<Scalars['String']['output']>;
  pciProcedureType?: Maybe<Scalars['String']['output']>;
  preProcCreatinine?: Maybe<Scalars['String']['output']>;
  primaryPayor?: Maybe<Scalars['String']['output']>;
  procedureDayOfWeek?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  readmissionType?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  summaryPayorClass?: Maybe<Scalars['String']['output']>;
  uncomplicatedSTEMICorrect?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
  withWithoutPPE?: Maybe<Scalars['String']['output']>;
};

export type Certificate = {
  __typename?: 'Certificate';
  active: Scalars['Boolean']['output'];
  certificateString?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identityProvider?: Maybe<IdentityProvider>;
  identityProviderId: Scalars['String']['output'];
  issuer?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  signatureAlgorithm?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  validityNotAfter?: Maybe<Scalars['DateTime']['output']>;
  validityNotBefore?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type Cied = {
  __typename?: 'Cied';
  admin7DayReadmission?: Maybe<Scalars['String']['output']>;
  admin7DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin14DayReadmission?: Maybe<Scalars['String']['output']>;
  admin14DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin30DayReadmission?: Maybe<Scalars['String']['output']>;
  admin30DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  adminInOutCode?: Maybe<Scalars['String']['output']>;
  adminMatch?: Maybe<Scalars['Float']['output']>;
  admissionUnit?: Maybe<Scalars['String']['output']>;
  admitDayOfWeek?: Maybe<Scalars['String']['output']>;
  admitSourceName?: Maybe<Scalars['String']['output']>;
  admitType?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  ageGroup?: Maybe<Scalars['String']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  attribute?: Maybe<Scalars['String']['output']>;
  bedDays?: Maybe<Scalars['Float']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomePayor?: Maybe<Scalars['String']['output']>;
  cardiacArrest?: Maybe<Scalars['String']['output']>;
  cardiacUS?: Maybe<Scalars['String']['output']>;
  cardioMEMS?: Maybe<Scalars['String']['output']>;
  cardioShock?: Maybe<Scalars['String']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  cath?: Maybe<Scalars['String']['output']>;
  chfAcute?: Maybe<Scalars['String']['output']>;
  chfAcuteOnChronic?: Maybe<Scalars['String']['output']>;
  chfChronicUspec?: Maybe<Scalars['String']['output']>;
  ciedPrimaryProcedure?: Maybe<Scalars['String']['output']>;
  ckdStageIVorV?: Maybe<Scalars['String']['output']>;
  clinicianAFirstName?: Maybe<Scalars['String']['output']>;
  clinicianALastName?: Maybe<Scalars['String']['output']>;
  clinicianName?: Maybe<Scalars['String']['output']>;
  cmi?: Maybe<Scalars['String']['output']>;
  conditionGrouperL2?: Maybe<Scalars['String']['output']>;
  ctScan?: Maybe<Scalars['String']['output']>;
  daysToReadmission?: Maybe<Scalars['String']['output']>;
  daysToReadmissionBins?: Maybe<Scalars['String']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDayOfWeek?: Maybe<Scalars['String']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  dischargeMDName?: Maybe<Scalars['String']['output']>;
  dischargeStatus?: Maybe<Scalars['String']['output']>;
  dischargeUnit?: Maybe<Scalars['String']['output']>;
  distanceFromHospital?: Maybe<Scalars['String']['output']>;
  distanceInMilesBucket?: Maybe<Scalars['String']['output']>;
  drgCodeName?: Maybe<Scalars['String']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  elixhauserIndex?: Maybe<Scalars['Int']['output']>;
  elixhauserRiskBuckets?: Maybe<Scalars['String']['output']>;
  encounterId?: Maybe<Scalars['Float']['output']>;
  endStageRenal?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hypovolShock?: Maybe<Scalars['String']['output']>;
  icdDxCodeCategory?: Maybe<Scalars['String']['output']>;
  icuDaysNumerator?: Maybe<Scalars['Int']['output']>;
  icuUtilizationAny?: Maybe<Scalars['String']['output']>;
  inDirectCost?: Maybe<Scalars['Float']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  losLess1?: Maybe<Scalars['String']['output']>;
  losLess2?: Maybe<Scalars['String']['output']>;
  mdcName?: Maybe<Scalars['String']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  medicare?: Maybe<Scalars['String']['output']>;
  mitraClip?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mortality?: Maybe<Scalars['Int']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  multiVisit?: Maybe<Scalars['Int']['output']>;
  netRevenue?: Maybe<Scalars['Float']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  otherShock?: Maybe<Scalars['String']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  overall?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  primaryProcPostLOSMore2?: Maybe<Scalars['String']['output']>;
  primaryProcPreLOSLess1?: Maybe<Scalars['String']['output']>;
  principalDiagnosisICDCodeName?: Maybe<Scalars['String']['output']>;
  principalProcedureICDCodeName?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  procedureMDName?: Maybe<Scalars['String']['output']>;
  pulmonaryEmbol?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  rawAdmitSourceName?: Maybe<Scalars['String']['output']>;
  rawDischargeStatus?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionAdmitDayOfWeek?: Maybe<Scalars['String']['output']>;
  readmissionAdmitSourceName?: Maybe<Scalars['String']['output']>;
  readmissionAdmitType?: Maybe<Scalars['String']['output']>;
  readmissionConditionGrouperL2?: Maybe<Scalars['String']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDischargeStatus?: Maybe<Scalars['String']['output']>;
  readmissionDrgName?: Maybe<Scalars['String']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  readmissionICDPrimaryProcedure?: Maybe<Scalars['String']['output']>;
  readmissionInOutCode?: Maybe<Scalars['String']['output']>;
  readmissionReason?: Maybe<Scalars['String']['output']>;
  readmissionSummaryPayorClass?: Maybe<Scalars['String']['output']>;
  readmissionWithWithout?: Maybe<Scalars['String']['output']>;
  referringMDRole?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  renalFailAcute?: Maybe<Scalars['String']['output']>;
  respArrest?: Maybe<Scalars['String']['output']>;
  respFailAcute?: Maybe<Scalars['String']['output']>;
  sepsis?: Maybe<Scalars['String']['output']>;
  tavr?: Maybe<Scalars['String']['output']>;
  ventrFibrillation?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
  visitsPerEpisode?: Maybe<Scalars['Int']['output']>;
};

export type CitationDashboard = {
  __typename?: 'CitationDashboard';
  id: Scalars['Int']['output'];
  measureId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  outcomeType?: Maybe<MeasureOutcomeType>;
  summaryCohortId?: Maybe<Scalars['Float']['output']>;
  volumeMeasure?: Maybe<Scalars['Boolean']['output']>;
  workbookName?: Maybe<Scalars['String']['output']>;
};

export type CitationDashboardInput = {
  diseaseStateModuleId: Scalars['Int']['input'];
  /** Absent for tools that emit no measure, e.g. case-mix */
  measureId?: InputMaybe<Scalars['Int']['input']>;
  /** Restricts to dashboards of the workbooks linked to the tenant with this code */
  tenantCode?: InputMaybe<Scalars['String']['input']>;
  toolKind: CitationToolKind;
};

export enum CitationToolKind {
  CaseMix = 'CaseMix',
  Measures = 'Measures',
  Pareto = 'Pareto',
}

export type ClientDataFile = {
  __typename?: 'ClientDataFile';
  blobUrl?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<ClientDataFile>>;
  clientDataFileFamily?: Maybe<ClientDataFileFamily>;
  clientDataFileFamilyId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataframes?: Maybe<Array<DataFrame>>;
  deletedAt: Scalars['DateTime']['output'];
  extensionType: ExtensionType;
  id: Scalars['ID']['output'];
  ingestedAt?: Maybe<Scalars['DateTime']['output']>;
  ingestionFileId?: Maybe<Scalars['Float']['output']>;
  ingestionState: IngestionState;
  isProcessed: Scalars['Boolean']['output'];
  jiraIssueId?: Maybe<Scalars['String']['output']>;
  jiraIssues?: Maybe<Array<JiraIssue>>;
  lastEventId?: Maybe<Scalars['String']['output']>;
  lifelineActionErrors?: Maybe<Array<LifelineActionError>>;
  lifelineEvents: Array<LifelineEvent>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<ClientDataFile>;
  parentId?: Maybe<Scalars['String']['output']>;
  rootTriggerId?: Maybe<Scalars['String']['output']>;
  size: Scalars['Int']['output'];
  submissions: Submission;
  submittedAt: Scalars['DateTime']['output'];
  submittedBy?: Maybe<User>;
  submittedById?: Maybe<Scalars['String']['output']>;
  supersedesId?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['String']['output']>;
  trails?: Maybe<Array<ClientDataFileTrail>>;
  triggerId?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type ClientDataFileFamily = {
  __typename?: 'ClientDataFileFamily';
  clientDataFiles: Array<ClientDataFile>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  deletedAt: Scalars['DateTime']['output'];
  expectedCount: Scalars['Float']['output'];
  expectedFiles?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  lastEventId?: Maybe<Scalars['String']['output']>;
  lifelineEvents?: Maybe<Array<LifelineEvent>>;
  rootTriggerId?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export enum ClientDataFileState {
  ClientFollowupInitiated = 'ClientFollowupInitiated',
  ClientFollowupRequired = 'ClientFollowupRequired',
  FileAssessmentRequired = 'FileAssessmentRequired',
  FurtherDataOpsRequired = 'FurtherDataOpsRequired',
  Ignore = 'Ignore',
  InvestigationRequired = 'InvestigationRequired',
  New = 'New',
  OnHold = 'OnHold',
  Planned = 'Planned',
  ReviewRequired = 'ReviewRequired',
}

export type ClientDataFileTrail = {
  __typename?: 'ClientDataFileTrail';
  clientDataFile: ClientDataFile;
  clientDataFileId: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isLatest: Scalars['Boolean']['output'];
  jiraRelease?: Maybe<Scalars['String']['output']>;
  noticeSentDate?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<ClientDataFileState>;
  supportEmail?: Maybe<SupportEmail>;
  supportEmailId?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type ClientSubmissionStatus = {
  __typename?: 'ClientSubmissionStatus';
  careEntity: CareEntity;
  dataset: Dataset;
  deadline?: Maybe<Scalars['DateTime']['output']>;
  requestedData?: Maybe<Scalars['String']['output']>;
  status: SubmissionStatusValue;
  submitter: User;
};

export type ClinicalProgram = {
  __typename?: 'ClinicalProgram';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description: Scalars['String']['output'];
  diseaseStateModules?: Maybe<Array<DiseaseStateModule>>;
  id: Scalars['Int']['output'];
  isAdmin: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type ClinicianPolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['String']['input'];
  eft?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type CodeBasedAttributeCriteriaDto = {
  __typename?: 'CodeBasedAttributeCriteriaDTO';
  attribute: Scalars['String']['output'];
  criteria: Scalars['String']['output'];
  description: Scalars['String']['output'];
  dsm?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
};

export type Comment = {
  __typename?: 'Comment';
  children: Array<Comment>;
  /** The comment content */
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  /** Mark comment as internal/private (internal) or everyone (public) */
  internal: Scalars['Boolean']['output'];
  /** Track if comment was edited */
  isEdited: Scalars['Boolean']['output'];
  /** True if parent comment was deleted but this comment was preserved */
  isOrphaned: Scalars['Boolean']['output'];
  parent?: Maybe<Comment>;
  /** Parent comment ID for nested replies */
  parentId?: Maybe<Scalars['String']['output']>;
  reactions: Array<CommentReaction>;
  reactionsCount?: Maybe<Scalars['Int']['output']>;
  repliesCount?: Maybe<Scalars['Int']['output']>;
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
  thread: Thread;
  /** Thread ID this comment belongs to */
  threadId: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
};

export type CommentReaction = {
  __typename?: 'CommentReaction';
  comment: Comment;
  commentId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  /** Type of reaction (emoji) */
  reactionType: Scalars['String']['output'];
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
  user: User;
  userId: Scalars['String']['output'];
};

export enum CompassSortBy {
  BedDays = 'BedDays',
  PatientsImpacted = 'PatientsImpacted',
  Roi = 'Roi',
}

export type ConfluencePage = {
  __typename?: 'ConfluencePage';
  body?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  relatedPages?: Maybe<Array<ConfluencePage>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Cpmi = {
  __typename?: 'Cpmi';
  accessSite?: Maybe<Scalars['String']['output']>;
  adminMatch?: Maybe<Scalars['Float']['output']>;
  admitDayofWeek?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  biomeConditionGroup?: Maybe<Scalars['String']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomePatientType?: Maybe<Scalars['String']['output']>;
  caOutHospital?: Maybe<Scalars['String']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  clinicianAFirstName?: Maybe<Scalars['String']['output']>;
  clinicianALastName?: Maybe<Scalars['String']['output']>;
  clinicianName?: Maybe<Scalars['String']['output']>;
  complicationList?: Maybe<Scalars['String']['output']>;
  complications?: Maybe<Scalars['Int']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  dischargeLocation?: Maybe<Scalars['String']['output']>;
  dischargeStatus?: Maybe<Scalars['String']['output']>;
  drgCodeName?: Maybe<Scalars['String']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mortality?: Maybe<Scalars['String']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  multiVisit?: Maybe<Scalars['Int']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  pciIndication?: Maybe<Scalars['String']['output']>;
  procedureDayOfWeek?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  procedureGroup?: Maybe<Scalars['String']['output']>;
  procedureStartTimeBucket?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  stemiORSTEMIEquivalent?: Maybe<Scalars['String']['output']>;
  tranOutsideFac?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
  visitsPerEpisode?: Maybe<Scalars['Int']['output']>;
};

export type CreateActivityLogInput = {
  createdBy?: InputMaybe<UpdateUserInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  relatedData?: InputMaybe<Scalars['JSON']['input']>;
  type: ActivityLogType;
};

export type CreateAggregateSubmissionsInput = {
  cadence: Scalars['String']['input'];
  careEntity: UpdateCareEntityInput;
  ccEmails?: InputMaybe<Scalars['String']['input']>;
  childrenCareEntities: Array<UpdateCareEntityInput>;
  comment: Scalars['String']['input'];
  dataset: UpdateDatasetInput;
  daysAfterDeadline: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
  mrnCrosswalkRequired: Scalars['Boolean']['input'];
  mrnHarvestRequired: Scalars['Boolean']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  sendReminders: Scalars['Boolean']['input'];
  submitNationalReport: Scalars['Boolean']['input'];
  user?: InputMaybe<UpdateUserInput>;
};

export type CreateApplicationInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateBookmarkInput = {
  category: BookmarkCategory;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  url: Scalars['String']['input'];
  users?: InputMaybe<Array<UpdateUserInput>>;
};

export type CreateBulkCareEntityInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  aggregated?: InputMaybe<Scalars['Boolean']['input']>;
  alternateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  anonymousCode?: InputMaybe<Scalars['String']['input']>;
  business?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cmsId?: InputMaybe<Scalars['String']['input']>;
  cmsIdNotAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  includeInBenchmarks?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceMonth?: InputMaybe<Scalars['Int']['input']>;
  isEngagementEntity?: InputMaybe<Scalars['Boolean']['input']>;
  monthlySponsorTouchbase?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noOfBeds?: InputMaybe<Scalars['Int']['input']>;
  onboardingCompletedOn?: InputMaybe<Scalars['DateTime']['input']>;
  parents?: InputMaybe<Array<UpdateCareEntityInput>>;
  physicianChampion?: InputMaybe<Scalars['String']['input']>;
  projectSponsor?: InputMaybe<Scalars['String']['input']>;
  reasonForNoCmsId?: InputMaybe<Scalars['String']['input']>;
  shortDisplayName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  supportedApps?: InputMaybe<Array<SupportedApps>>;
  teaching?: InputMaybe<Scalars['Boolean']['input']>;
  tenants?: InputMaybe<Array<UpdateTenantInput>>;
  type?: InputMaybe<CareEntityType>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  usGeoRegion?: InputMaybe<UsGeoRegion>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCareEntityInput = {
  active: Scalars['Boolean']['input'];
  aggregated: Scalars['Boolean']['input'];
  alternateNames: Array<Scalars['String']['input']>;
  anonymousCode?: InputMaybe<Scalars['String']['input']>;
  business?: InputMaybe<Scalars['String']['input']>;
  children?: InputMaybe<Array<UpdateCareEntityInput>>;
  city?: InputMaybe<Scalars['String']['input']>;
  cmsId?: InputMaybe<Scalars['String']['input']>;
  cmsIdNotAvailable: Scalars['Boolean']['input'];
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  datasets?: InputMaybe<Array<UpdateDatasetInput>>;
  description: Scalars['String']['input'];
  diseaseStateModules?: InputMaybe<Array<UpdateDiseaseStateModuleInput>>;
  /** DSMs this care entity participates in but neither reviews nor pushes. Absent leaves existing exclusions untouched; empty clears them; present is authoritative. */
  excludedDsms?: InputMaybe<Array<UpdateDiseaseStateModuleInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  includeInBenchmarks: Scalars['Boolean']['input'];
  invoiceMonth?: InputMaybe<Scalars['Int']['input']>;
  isEngagementEntity?: InputMaybe<Scalars['Boolean']['input']>;
  monthlySponsorTouchbase?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  noOfBeds?: InputMaybe<Scalars['Int']['input']>;
  onboardingCompletedOn?: InputMaybe<Scalars['DateTime']['input']>;
  parents?: InputMaybe<Array<UpdateCareEntityInput>>;
  physicianChampion?: InputMaybe<Scalars['String']['input']>;
  projectSponsor?: InputMaybe<Scalars['String']['input']>;
  pushOnlyDsms?: InputMaybe<Array<UpdateDiseaseStateModuleInput>>;
  reasonForNoCmsId?: InputMaybe<Scalars['String']['input']>;
  reviewDsms?: InputMaybe<Array<UpdateDiseaseStateModuleInput>>;
  shortDisplayName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  submissions?: InputMaybe<Array<SubmissionInput>>;
  supportedApps?: InputMaybe<Array<SupportedApps>>;
  teaching: Scalars['Boolean']['input'];
  tenants: Array<UpdateTenantInput>;
  type: CareEntityType;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  usGeoRegion?: InputMaybe<UsGeoRegion>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClinicalProgramInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateCommentInput = {
  /** The comment content */
  content: Scalars['String']['input'];
  createdById: Scalars['String']['input'];
  /** Mark comment as internal/private */
  internal?: Scalars['Boolean']['input'];
  /** Parent comment ID for nested replies */
  parentId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
  /** Thread ID this comment belongs to */
  threadId: Scalars['String']['input'];
};

export type CreateCommentReactionInput = {
  /** Comment ID this reaction belongs to */
  commentId: Scalars['String']['input'];
  /** Type of reaction (emoji) */
  reactionType: Scalars['String']['input'];
  /** Tenant ID for multi-tenancy */
  tenantId: Scalars['String']['input'];
  /** User ID who created the reaction */
  userId: Scalars['String']['input'];
};

export type CreateDatasetInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  crosswalkRequired?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isCrosswalkSource?: InputMaybe<Scalars['Boolean']['input']>;
  isDropAndLoad?: InputMaybe<Scalars['Boolean']['input']>;
  isRegistry: Scalars['Boolean']['input'];
  isTenantLevel?: InputMaybe<Scalars['Boolean']['input']>;
  managingSociety: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /** Indicates if the dataset supports the report builder feature. */
  supportsReportBuilder?: InputMaybe<Scalars['Boolean']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateDatasetVersionFieldInput = {
  datasetVersion: UpdateDatasetVersionInput;
  fieldId: Scalars['Int']['input'];
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateDatasetVersionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dataset: UpdateDatasetInput;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  versionNumber: Scalars['Float']['input'];
};

export type CreateDeadlineInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dataset: UpdateDatasetInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  monthIncluded?: InputMaybe<Scalars['String']['input']>;
  monthSubmissionDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  quarterIncluded?: InputMaybe<Scalars['String']['input']>;
  quarterSubmissionDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateDefinitionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  definition?: InputMaybe<Scalars['String']['input']>;
  element: UpdateElementInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateDevelopmentDimensionInput = {
  aeQualifying: Scalars['Boolean']['input'];
  allMeasures: Scalars['Boolean']['input'];
  class: Scalars['String']['input'];
  codeVersion?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensionId?: InputMaybe<Scalars['Int']['input']>;
  diseaseStateModule: UpdateDiseaseStateModuleInput;
  documentation?: InputMaybe<Scalars['JSON']['input']>;
  excludeValues?: InputMaybe<Array<Scalars['String']['input']>>;
  fieldName: Scalars['String']['input'];
  hideFromReports?: Scalars['Boolean']['input'];
  isGlobal: Scalars['Boolean']['input'];
  jiraLink?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  legacyDescription?: InputMaybe<Scalars['String']['input']>;
  multiProcTableId?: InputMaybe<Scalars['String']['input']>;
  oeQualifying: Scalars['Boolean']['input'];
  pipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  requirements?: InputMaybe<Scalars['String']['input']>;
  sortOrder: Scalars['Int']['input'];
  sourceContinuousField?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<EntityState>;
  stateHistory?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EntityStatus>;
  type: DimensionType;
  updateBy?: InputMaybe<UpdateUserInput>;
  valueMap?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateDevelopmentMeasureInput = {
  accessCategory: AccessCategory;
  adjustment?: InputMaybe<Array<Scalars['String']['input']>>;
  aggregationFn?: InputMaybe<Array<Scalars['String']['input']>>;
  aggregationType?: InputMaybe<SummaryCalculationType>;
  annualMeasureBaseId?: InputMaybe<Scalars['String']['input']>;
  benchmarkExtraction: Scalars['Boolean']['input'];
  codeVersion?: InputMaybe<Scalars['String']['input']>;
  commonMeasureDisplayName: Scalars['String']['input'];
  commonMeasureQualifying?: InputMaybe<Scalars['Boolean']['input']>;
  costComponentMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dataTypeRequired?: InputMaybe<MeasureInputDataType>;
  denominatorColumnName?: InputMaybe<Scalars['String']['input']>;
  denominatorDocumentation?: InputMaybe<Scalars['JSON']['input']>;
  denominatorPipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  developedOn?: InputMaybe<Scalars['DateTime']['input']>;
  diseaseStateModule: UpdateDiseaseStateModuleInput;
  excludedCohortIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  family?: InputMaybe<MeasureFamily>;
  hideFromReports?: Scalars['Boolean']['input'];
  higherIsBetter?: InputMaybe<Scalars['Boolean']['input']>;
  includeColumnName?: InputMaybe<Scalars['String']['input']>;
  includeDocumentation?: InputMaybe<Scalars['JSON']['input']>;
  includePipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  isBenchmark?: InputMaybe<Scalars['Boolean']['input']>;
  jiraLink?: InputMaybe<Scalars['String']['input']>;
  losROIQualifying?: InputMaybe<Scalars['Boolean']['input']>;
  measureId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  ncdrMeasureName?: InputMaybe<Scalars['String']['input']>;
  numeratorColumnName?: InputMaybe<Scalars['String']['input']>;
  numeratorDocumentation?: InputMaybe<Scalars['JSON']['input']>;
  numeratorPipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  numeratorUnit: Scalars['String']['input'];
  opportunityType: Array<OpportunityType>;
  outcomeType?: InputMaybe<MeasureOutcomeType>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  publicationSource?: InputMaybe<Array<PublicationSource>>;
  rareEvent: Scalars['Boolean']['input'];
  registryMeasureId?: InputMaybe<Scalars['Int']['input']>;
  reportRowId?: InputMaybe<Scalars['Int']['input']>;
  requirements?: InputMaybe<Scalars['String']['input']>;
  riskAdjusted?: Scalars['Boolean']['input'];
  riskMetricDocumentation?: InputMaybe<Scalars['JSON']['input']>;
  riskMetricId?: InputMaybe<Scalars['String']['input']>;
  riskMetricPipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  roiCalcType?: InputMaybe<SummaryCalculationType>;
  /** Requires family and must differ from it; cleared when family is cleared. */
  secondaryFamily?: InputMaybe<MeasureFamily>;
  state?: InputMaybe<EntityState>;
  stateHistory?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EntityStatus>;
  summaryCohortId?: InputMaybe<Scalars['Float']['input']>;
  summaryInitiativeMeasure: Scalars['Boolean']['input'];
  tableName?: InputMaybe<Scalars['String']['input']>;
  testCapture?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  validationSource?: InputMaybe<Scalars['String']['input']>;
  volumeMeasure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateDevelopmentRoiMetricInput = {
  codeVersion?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  diseaseStateModule: UpdateDiseaseStateModuleInput;
  documentation?: InputMaybe<Scalars['JSON']['input']>;
  fieldName: Scalars['String']['input'];
  higherIsBetter: Scalars['Boolean']['input'];
  jiraLink?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  legacyDescription?: InputMaybe<Scalars['String']['input']>;
  pipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  roiMetricId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<EntityState>;
  stateHistory?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EntityStatus>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateDictionaryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dataFeed?: InputMaybe<CreateDictionaryInput>;
  dataset: UpdateDatasetInput;
  feedDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  sections?: InputMaybe<Array<CreateSectionInput>>;
  tenants?: InputMaybe<Array<UpdateTenantInput>>;
  type: DictionaryType;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  version: Scalars['String']['input'];
};

export type CreateDimensionInput = {
  aeQualifying: Scalars['Boolean']['input'];
  allMeasures: Scalars['Boolean']['input'];
  class: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensionValueSortOrder?: InputMaybe<
    Array<UpdateNestedDimensionValueSortOrderInput>
  >;
  diseaseStateModule: UpdateDiseaseStateModuleInput;
  excludeValues?: InputMaybe<Array<Scalars['String']['input']>>;
  fieldName: Scalars['String']['input'];
  hideFromReports?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isGlobal: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  legacyDescription?: InputMaybe<Scalars['String']['input']>;
  multiProcTableId?: InputMaybe<Scalars['String']['input']>;
  oeQualifying: Scalars['Boolean']['input'];
  pipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  requirements?: InputMaybe<Scalars['String']['input']>;
  sortOrder: Scalars['Int']['input'];
  sortType: SortType;
  sourceContinuousField?: InputMaybe<Scalars['String']['input']>;
  type: DimensionType;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  valueMap?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateDiseaseStateModuleInput = {
  adjustment?: InputMaybe<Array<Scalars['String']['input']>>;
  aggregationFn?: InputMaybe<Array<Scalars['String']['input']>>;
  careEntities?: InputMaybe<Array<UpdateCareEntityInput>>;
  clinicalProgram: UpdateClinicalProgramInput;
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  criticalDatasets?: InputMaybe<Array<UpdateDatasetInput>>;
  datasets?: InputMaybe<Array<UpdateDatasetInput>>;
  description: Scalars['String']['input'];
  hideRiskAuditCharts?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  multiProcTables?: InputMaybe<Array<DiseaseStateModuleMultiProcTableInput>>;
  name: Scalars['String']['input'];
  riskMetrics?: InputMaybe<Array<DiseaseStateModuleRiskMetricInput>>;
  summaryCohortId?: InputMaybe<Scalars['Float']['input']>;
  supportedApps?: InputMaybe<Array<SupportedApps>>;
  tableName?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateDistributionListInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  tenant: UpdateTenantInput;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  users?: InputMaybe<Array<UpdateUserInput>>;
};

export type CreateElementInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeSystemName?: InputMaybe<Scalars['String']['input']>;
  codingInstructions?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['DateTime']['input'];
  createdBy?: InputMaybe<UpdateUserInput>;
  dataSource?: InputMaybe<ElementDataSourceType>;
  dataType?: InputMaybe<ElementDataType>;
  dbDataType?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  definition?: InputMaybe<CreateDefinitionInput>;
  elementReference: Scalars['String']['input'];
  hideFromReports?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isBaseElement: Scalars['Boolean']['input'];
  isDynamicList?: InputMaybe<Scalars['Boolean']['input']>;
  isFollowupElement: Scalars['Boolean']['input'];
  isHarvested?: InputMaybe<Scalars['Boolean']['input']>;
  isIdentifier: Scalars['Boolean']['input'];
  missingData?: InputMaybe<ElementMissingDataAction>;
  name: Scalars['String']['input'];
  parentChildValidations?: InputMaybe<Array<CreateParentChildValidationInput>>;
  phi?: InputMaybe<Scalars['Boolean']['input']>;
  precision?: InputMaybe<Scalars['String']['input']>;
  ranges?: InputMaybe<Array<CreateRangeInput>>;
  role?: InputMaybe<Scalars['String']['input']>;
  section: UpdateSectionInput;
  sectionId: Scalars['String']['input'];
  selectionType?: InputMaybe<ElementSelectionType>;
  selections?: InputMaybe<Array<CreateSelectionInput>>;
  shortName: Scalars['String']['input'];
  targetValue?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  updateAt: Scalars['DateTime']['input'];
  updateBy?: InputMaybe<UpdateUserInput>;
  vendorInstruction?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGridViewInput = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  columnModel: Scalars['JSON']['input'];
  default?: InputMaybe<Scalars['Boolean']['input']>;
  externalFilters?: InputMaybe<Scalars['JSON']['input']>;
  filterModel: Scalars['JSON']['input'];
  gridId: Scalars['String']['input'];
  moduleId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  scope: Scope;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateHomepageSectionInput = {
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateMeasureMetadataInput = {
  accessCategory: AccessCategory;
  adjustment?: InputMaybe<Array<Scalars['String']['input']>>;
  aggregationFn?: InputMaybe<Array<Scalars['String']['input']>>;
  aggregationType?: InputMaybe<SummaryCalculationType>;
  annualMeasureBaseId?: InputMaybe<Scalars['String']['input']>;
  benchmarkExtraction: Scalars['Boolean']['input'];
  commonMeasureDisplayName: Scalars['String']['input'];
  commonMeasureQualifying?: InputMaybe<Scalars['Boolean']['input']>;
  costComponentMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dataTypeRequired?: InputMaybe<MeasureInputDataType>;
  denominatorColumnName?: InputMaybe<Scalars['String']['input']>;
  denominatorPipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  developedOn?: InputMaybe<Scalars['DateTime']['input']>;
  dimensionSets?: InputMaybe<Array<CreateNestedDimensionSetInput>>;
  diseaseStateModule: UpdateDiseaseStateModuleInput;
  excludedCohortIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  family?: InputMaybe<MeasureFamily>;
  hideFromReports?: InputMaybe<Scalars['Boolean']['input']>;
  higherIsBetter?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeColumnName?: InputMaybe<Scalars['String']['input']>;
  includePipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  isBenchmark?: InputMaybe<Scalars['Boolean']['input']>;
  losROIQualifying?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  ncdrMeasureName?: InputMaybe<Scalars['String']['input']>;
  numeratorColumnName?: InputMaybe<Scalars['String']['input']>;
  numeratorPipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  numeratorUnit: Scalars['String']['input'];
  objects?: InputMaybe<Array<CreateObjectMeasureInput>>;
  opportunityType: Array<OpportunityType>;
  outcomeType?: InputMaybe<MeasureOutcomeType>;
  publicationSource?: InputMaybe<Array<PublicationSource>>;
  rareEvent: Scalars['Boolean']['input'];
  registryMeasureId?: InputMaybe<Scalars['Int']['input']>;
  reportRowId?: InputMaybe<Scalars['Int']['input']>;
  requirements?: InputMaybe<Scalars['String']['input']>;
  riskAdjusted?: InputMaybe<Scalars['Boolean']['input']>;
  riskMetricId?: InputMaybe<Scalars['String']['input']>;
  riskMetricPipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  roiCalcType?: InputMaybe<SummaryCalculationType>;
  roiMetrics?: InputMaybe<Array<UpdateRoiMetricInput>>;
  /** Requires family and must differ from it; cleared when family is cleared. */
  secondaryFamily?: InputMaybe<MeasureFamily>;
  subjects?: InputMaybe<Array<CreateSubjectMeasureInput>>;
  summaryCohortId?: InputMaybe<Scalars['Float']['input']>;
  summaryInitiativeMeasure: Scalars['Boolean']['input'];
  tableName?: InputMaybe<Scalars['String']['input']>;
  tableauViews?: InputMaybe<Array<CreateMeasureTableauViewInput>>;
  testCapture?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  validationSource?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  volumeMeasure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateMeasureTableauViewInput = {
  isPrimary: Scalars['Boolean']['input'];
  tableauViewId: Scalars['Int']['input'];
};

export type CreateNestedDimensionSetInput = {
  dimensions?: InputMaybe<Array<UpdateDimensionInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  measure?: InputMaybe<UpdateMeasureMetadataInput>;
};

export type CreateNotificationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  type: NotificationType;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  users?: InputMaybe<Array<UpdateUserInput>>;
};

export type CreateObjectMeasureInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<MeasureLinkType>;
  objectMeasure?: InputMaybe<UpdateMeasureMetadataInput>;
  processMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  subjectMeasure?: InputMaybe<UpdateMeasureMetadataInput>;
};

export type CreateObjectiveInput = {
  attachStrategyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  careEntity?: InputMaybe<UpdateCareEntityInput>;
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  cohortIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  diseaseStateModuleId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Source: Perf Api initiative list */
  initiativeId?: InputMaybe<Scalars['Float']['input']>;
  measures?: InputMaybe<Array<UpdateMeasureMetadataInput>>;
  /** Title of the objective, populate based on measure & cohort in case of Opportunity objective */
  name: Scalars['String']['input'];
  /** The Objective Template this Objective was created from, if any */
  objectiveTemplateId?: InputMaybe<Scalars['ID']['input']>;
  participants?: InputMaybe<Array<CreateObjectiveParticipantInput>>;
  strategies?: InputMaybe<Array<CreateObjectiveStrategyInput>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tenant: UpdateTenantInput;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateObjectiveParticipantInput = {
  /** Free text username/email for external participants not in User table */
  externalUsername?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  role: ParticipantRole;
  /** Reference to existing user in the system */
  user?: InputMaybe<UpdateUserInput>;
};

export type CreateObjectiveStrategyInput = {
  associations?: InputMaybe<Scalars['String']['input']>;
  checkpointDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  objective: UpdateObjectiveInput;
  participants?: InputMaybe<Array<CreateObjectiveParticipantInput>>;
  physicianChampions?: InputMaybe<Array<CreateObjectiveParticipantInput>>;
  processSponsors?: InputMaybe<Array<CreateObjectiveParticipantInput>>;
  resources?: InputMaybe<Array<CreateStrategyResourceInput>>;
  showInPerformanceMonitor?: InputMaybe<Scalars['Boolean']['input']>;
  status: ObjectiveStrategyStatus;
  template?: InputMaybe<UpdateObjectiveStrategyTemplateInput>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateObjectiveStrategyTemplateInput = {
  allDiseaseStateModules: Scalars['Boolean']['input'];
  allMeasures: Scalars['Boolean']['input'];
  /** Saved strategy whose attachments are copied onto the new template */
  copyAttachmentsFromStrategyId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  diseaseStateModuleId?: InputMaybe<Scalars['Int']['input']>;
  /** uuid as primary key */
  id?: InputMaybe<Scalars['ID']['input']>;
  measures?: InputMaybe<Array<UpdateMeasureMetadataInput>>;
  name: Scalars['String']['input'];
  resources?: InputMaybe<Array<CreateStrategyResourceInput>>;
  strategies?: InputMaybe<Array<UpdateObjectiveStrategyInput>>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateObjectiveTemplateInput = {
  cohortIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  diseaseStateModuleId?: InputMaybe<Scalars['Int']['input']>;
  /** uuid as primary key */
  id?: InputMaybe<Scalars['ID']['input']>;
  measures?: InputMaybe<Array<UpdateMeasureMetadataInput>>;
  name: Scalars['String']['input'];
  newStrategyTemplates?: InputMaybe<
    Array<CreateObjectiveStrategyTemplateInput>
  >;
  strategyTemplateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateParentChildValidationInput = {
  createdAt: Scalars['DateTime']['input'];
  createdBy?: InputMaybe<UpdateUserInput>;
  element: UpdateElementInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  parent: UpdateElementInput;
  parentElementReference: Scalars['String']['input'];
  parentElementSelectionName: Scalars['String']['input'];
  parentSelection: UpdateSelectionInput;
  updateAt: Scalars['DateTime']['input'];
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreatePerformanceManagerStrategyInput = {
  careEntity: Scalars['String']['input'];
  checkpointDate: Scalars['DateTime']['input'];
  cohort: Scalars['Float']['input'];
  configuringCareEntity: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  initiativeId: Scalars['Float']['input'];
  measure: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  physicianChampions: Array<CreateObjectiveParticipantInput>;
  processSponsors: Array<CreateObjectiveParticipantInput>;
  registry: Scalars['String']['input'];
};

export type CreatePresentationInput = {
  clonedFor?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  cropConfig: Scalars['JSON']['input'];
  description: Scalars['String']['input'];
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  diseaseStateModuleId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  latestJobId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  presentationType?: InputMaybe<PresentationType>;
  tenant: UpdateTenantInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreatePresentationSubmissionInput = {
  careEntity?: InputMaybe<UpdateCareEntityInput>;
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  presentation?: InputMaybe<UpdatePresentationInput>;
  presentationId?: InputMaybe<Scalars['String']['input']>;
  quarter: Scalars['String']['input'];
  tenant?: InputMaybe<UpdateTenantInput>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRangeInput = {
  createdAt: Scalars['DateTime']['input'];
  createdBy?: InputMaybe<UpdateUserInput>;
  element: UpdateElementInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  updateAt: Scalars['DateTime']['input'];
  updateBy?: InputMaybe<UpdateUserInput>;
  usualRangeMax?: InputMaybe<Scalars['Float']['input']>;
  usualRangeMin?: InputMaybe<Scalars['Float']['input']>;
  validRangeMax?: InputMaybe<Scalars['Float']['input']>;
  validRangeMin?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateRecentTableauViewInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  tableauView: UpdateTableauViewInput;
  /** Tenant the dashboard was viewed in */
  tenantId: Scalars['String']['input'];
  viewedAt?: InputMaybe<Scalars['DateTime']['input']>;
  viewedBy?: InputMaybe<UpdateUserInput>;
};

export type CreateRoiMetricInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  diseaseStateModule: UpdateDiseaseStateModuleInput;
  fieldName: Scalars['String']['input'];
  higherIsBetter: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
  legacyDescription?: InputMaybe<Scalars['String']['input']>;
  pipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateRoleInput = {
  code: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  tenant: UpdateTenantInput;
  type: RoleType;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  users?: InputMaybe<Array<UpdateUserInput>>;
};

export type CreateSectionInput = {
  cardinality: CardinalityType;
  containerClass?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dictionary?: InputMaybe<UpdateDictionaryInput>;
  elements?: InputMaybe<Array<CreateElementInput>>;
  hideFromReports?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  parent?: InputMaybe<SectionInput>;
  parentSection?: InputMaybe<Scalars['String']['input']>;
  sectionCode: Scalars['String']['input'];
  sectionDisplayName: Scalars['String']['input'];
  sectionType: SectionType;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateSelectionInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeSystemName?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['DateTime']['input'];
  createdBy?: InputMaybe<UpdateUserInput>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  element: UpdateElementInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  selectionDefinition?: InputMaybe<Scalars['String']['input']>;
  selectionName: Scalars['String']['input'];
  updateAt: Scalars['DateTime']['input'];
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateSlideInput = {
  configuredDashboard?: InputMaybe<UpdateTableauViewInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  defaultCropConfig: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<UpdateFileInput>;
  imageConfig?: InputMaybe<ImageConfigInput>;
  imageFetchedAt?: InputMaybe<Scalars['DateTime']['input']>;
  imageStatus?: InputMaybe<SlideImageStatus>;
  isNative?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  presentation: UpdatePresentationInput;
  presentationId?: InputMaybe<Scalars['String']['input']>;
  shareableLink?: InputMaybe<Scalars['String']['input']>;
  slideType: SlideType;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateStrategyResourceInput = {
  displayText?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type CreateSubjectMeasureInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<MeasureLinkType>;
  objectMeasure?: InputMaybe<UpdateMeasureMetadataInput>;
  processMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  subjectMeasure?: InputMaybe<UpdateMeasureMetadataInput>;
};

export type CreateSubmissionInput = {
  aggregate?: Scalars['Boolean']['input'];
  cadence: Scalars['String']['input'];
  careEntity: UpdateCareEntityInput;
  ccEmails?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dataset: UpdateDatasetInput;
  daysAfterDeadline: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  mrnCrosswalkRequired: Scalars['Boolean']['input'];
  mrnHarvestRequired: Scalars['Boolean']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  sendReminders: Scalars['Boolean']['input'];
  submitNationalReport: Scalars['Boolean']['input'];
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  user?: InputMaybe<UpdateUserInput>;
};

export type CreateTableauViewInput = {
  active: Scalars['Boolean']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  primaryMeasureIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  renderInMenu: Scalars['Boolean']['input'];
  secondaryMeasureIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortOrder: Scalars['Float']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  workbook: UpdateWorkbookInput;
};

export type CreateTenantInput = {
  active: Scalars['Boolean']['input'];
  aggregationTenant?: InputMaybe<Scalars['Boolean']['input']>;
  banner?: InputMaybe<FileInput>;
  careEntities?: InputMaybe<Array<UpdateCareEntityInput>>;
  casesSchema?: InputMaybe<Scalars['String']['input']>;
  clinicalOnly: Scalars['Boolean']['input'];
  code: Scalars['String']['input'];
  contractedDisplayPHI: Scalars['Boolean']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  deliverableBlinded?: InputMaybe<Scalars['Boolean']['input']>;
  disableBiomedataLogin?: InputMaybe<Scalars['Boolean']['input']>;
  disableHomepage?: InputMaybe<Scalars['Boolean']['input']>;
  documents?: InputMaybe<Array<FileInput>>;
  echoModules?: InputMaybe<Array<UpdateEchoModuleInput>>;
  encryptionKeys: Array<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** IT contact email for the tenant. */
  itContact?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileInput>;
  name: Scalars['String']['input'];
  organizationalUnit?: InputMaybe<Scalars['String']['input']>;
  projectSponsor?: InputMaybe<UpdateUserInput>;
  projectSponsorId?: InputMaybe<Scalars['String']['input']>;
  rollupMode?: InputMaybe<AggregationRollupMode>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  usesAnubisUpload?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateThreadInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  isPrivate?: Scalars['Boolean']['input'];
  tenantId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateTransformationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  delimiter: Scalars['String']['input'];
  derivative?: InputMaybe<UpdateElementInput>;
  derivativeCode?: InputMaybe<Scalars['String']['input']>;
  derivativeValue?: InputMaybe<Scalars['String']['input']>;
  derivativeValueCode?: InputMaybe<Scalars['String']['input']>;
  exactMatch?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  reference: UpdateElementInput;
  referenceCode: Scalars['String']['input'];
  translation: UpdateTranslationInput;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  valueMap?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateTransformationPayloadInput = {
  delimiter: Scalars['String']['input'];
  derivativeField?: InputMaybe<Scalars['String']['input']>;
  derivativeFieldCode: Scalars['String']['input'];
  derivativeValue?: InputMaybe<Scalars['String']['input']>;
  derivativeValueCode?: InputMaybe<Scalars['String']['input']>;
  exactMatch?: InputMaybe<Scalars['Boolean']['input']>;
  referenceField: Scalars['String']['input'];
  referenceFieldCode: Scalars['String']['input'];
  valueMap?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateTranslationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  id: Scalars['ID']['input'];
  source?: InputMaybe<UpdateElementInput>;
  target: UpdateElementInput;
  transformation?: InputMaybe<CreateTransformationInput>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  valueMap?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateTranslationPayloadInput = {
  source?: InputMaybe<Scalars['String']['input']>;
  target: Scalars['String']['input'];
  transformation?: InputMaybe<CreateTransformationPayloadInput>;
  valueMap?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateTranslatorConfigInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dataFeed?: InputMaybe<CreateTranslatorConfigPayloadInput>;
  feedDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  source: UpdateDictionaryInput;
  target: UpdateDictionaryInput;
  translations: Array<CreateTranslationInput>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  version: Scalars['String']['input'];
};

export type CreateTranslatorConfigPayloadInput = {
  createdBy?: InputMaybe<UpdateUserInput>;
  dataset: UpdateDatasetInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  source: UpdateDictionaryPayloadInput;
  target: UpdateDictionaryPayloadInput;
  translations: Array<CreateTranslationPayloadInput>;
  updateBy?: InputMaybe<UpdateUserInput>;
  version: Scalars['String']['input'];
};

export type CreateUserInput = {
  adGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  careEntityCode?: InputMaybe<Scalars['String']['input']>;
  ccOnboardingEmail?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<CreateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  disableBiomedataLogin?: InputMaybe<Scalars['Boolean']['input']>;
  distributionLists?: InputMaybe<Array<UpdateDistributionListInput>>;
  email: Scalars['String']['input'];
  enableSftp?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Time when the user was enabled. This is used to keep certain items on the UI disabled until this change is synced to Azure AD. */
  enabledTime?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  homepage?: InputMaybe<CreateBookmarkInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName: Scalars['String']['input'];
  notifications?: InputMaybe<Array<UpdateNotificationInput>>;
  organizationalUnit?: InputMaybe<Scalars['String']['input']>;
  otherEmails?: InputMaybe<Array<OtherEmailInput>>;
  passwordNeverExpires?: InputMaybe<Scalars['Boolean']['input']>;
  permanentAccount?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<UpdateRoleInput>>;
  root?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<UserStatus>;
  submitsData?: InputMaybe<Scalars['Boolean']['input']>;
  tenant?: InputMaybe<UpdateTenantInput>;
  tenantPolicies?: InputMaybe<Array<TenantPolicyInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  twoFactor?: InputMaybe<Scalars['Boolean']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<CreateUserInput>;
  /** Unique username */
  username: Scalars['String']['input'];
};

export type CreateWorkbookGroupInput = {
  active: Scalars['Boolean']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description: Scalars['String']['input'];
  diseaseStateModule: UpdateDiseaseStateModuleInput;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  renderAsLink: Scalars['Boolean']['input'];
  renderInMenu: Scalars['Boolean']['input'];
  sortOrder: Scalars['Float']['input'];
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  workbooks?: InputMaybe<Array<CreateWorkbookInput>>;
};

export type CreateWorkbookInput = {
  active: Scalars['Boolean']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description: Scalars['String']['input'];
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  measureIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  name: Scalars['String']['input'];
  sortOrder: Scalars['Float']['input'];
  tableauUri: Scalars['String']['input'];
  tags?: InputMaybe<Array<Tags>>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  workbookGroup?: InputMaybe<UpdateWorkbookGroupInput>;
};

export enum CrosswalkState {
  CompletedWithWarnings = 'COMPLETED_WITH_WARNINGS',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  ManualOverride = 'MANUAL_OVERRIDE',
  NotRequired = 'NOT_REQUIRED',
  Pending = 'PENDING',
  Success = 'SUCCESS',
}

export type CvImaging = {
  __typename?: 'CvImaging';
  admin7DayReadmission?: Maybe<Scalars['String']['output']>;
  admin7DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin14DayReadmission?: Maybe<Scalars['String']['output']>;
  admin14DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin30DayReadmission?: Maybe<Scalars['String']['output']>;
  admin30DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  adminInOutCode?: Maybe<Scalars['String']['output']>;
  adminMatch?: Maybe<Scalars['Float']['output']>;
  admissionUnit?: Maybe<Scalars['String']['output']>;
  admitDayOfWeek?: Maybe<Scalars['String']['output']>;
  admitSourceName?: Maybe<Scalars['String']['output']>;
  admitType?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  ageGroup?: Maybe<Scalars['String']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  anyVADProcedure?: Maybe<Scalars['String']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  attribute?: Maybe<Scalars['String']['output']>;
  bedDays?: Maybe<Scalars['Float']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomePayor?: Maybe<Scalars['String']['output']>;
  cardiacArrest?: Maybe<Scalars['String']['output']>;
  cardiacBloodPool?: Maybe<Scalars['String']['output']>;
  cardiacMRI?: Maybe<Scalars['String']['output']>;
  cardiacStressTest?: Maybe<Scalars['String']['output']>;
  cardiacUS?: Maybe<Scalars['String']['output']>;
  cardioMEMS?: Maybe<Scalars['String']['output']>;
  cardioShock?: Maybe<Scalars['String']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  cath?: Maybe<Scalars['String']['output']>;
  chfAcute?: Maybe<Scalars['String']['output']>;
  chfAcuteOnChronic?: Maybe<Scalars['String']['output']>;
  chfChronicUspec?: Maybe<Scalars['String']['output']>;
  ckdStageIVorV?: Maybe<Scalars['String']['output']>;
  clinicianAFirstName?: Maybe<Scalars['String']['output']>;
  clinicianALastName?: Maybe<Scalars['String']['output']>;
  clinicianName?: Maybe<Scalars['String']['output']>;
  cmi?: Maybe<Scalars['String']['output']>;
  conditionGrouperL2?: Maybe<Scalars['String']['output']>;
  coronaryIntervention?: Maybe<Scalars['String']['output']>;
  ctScan?: Maybe<Scalars['String']['output']>;
  cta?: Maybe<Scalars['String']['output']>;
  cvImagingProcedure?: Maybe<Scalars['String']['output']>;
  daysToReadmission?: Maybe<Scalars['String']['output']>;
  daysToReadmissionBins?: Maybe<Scalars['String']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  diagnosticAndCoronaryIntervention?: Maybe<Scalars['String']['output']>;
  diagnosticCath?: Maybe<Scalars['String']['output']>;
  diagnosticCathType?: Maybe<Scalars['String']['output']>;
  diagnosticOrCoronaryIntervention?: Maybe<Scalars['String']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDayOfWeek?: Maybe<Scalars['String']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  dischargeMDName?: Maybe<Scalars['String']['output']>;
  dischargeStatus?: Maybe<Scalars['String']['output']>;
  dischargeUnit?: Maybe<Scalars['String']['output']>;
  distanceFromHospital?: Maybe<Scalars['String']['output']>;
  distanceInMilesBucket?: Maybe<Scalars['String']['output']>;
  drgCodeName?: Maybe<Scalars['String']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  echoTest?: Maybe<Scalars['String']['output']>;
  elixhauserIndex?: Maybe<Scalars['Int']['output']>;
  elixhauserRiskBuckets?: Maybe<Scalars['String']['output']>;
  encounterId?: Maybe<Scalars['Float']['output']>;
  endStageRenal?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  heartTransplant?: Maybe<Scalars['String']['output']>;
  heartTransplantType?: Maybe<Scalars['String']['output']>;
  hypovolShock?: Maybe<Scalars['String']['output']>;
  icdDxCodeCategory?: Maybe<Scalars['String']['output']>;
  icuDaysNumerator?: Maybe<Scalars['Int']['output']>;
  icuUtilizationAny?: Maybe<Scalars['String']['output']>;
  inDirectCost?: Maybe<Scalars['Float']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  losLess1?: Maybe<Scalars['String']['output']>;
  losLess2?: Maybe<Scalars['String']['output']>;
  mdcName?: Maybe<Scalars['String']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  medicare?: Maybe<Scalars['String']['output']>;
  miImaging?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mortality?: Maybe<Scalars['Int']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  multiVisit?: Maybe<Scalars['Int']['output']>;
  netRevenue?: Maybe<Scalars['Float']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  otherShock?: Maybe<Scalars['String']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  overall?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  pet?: Maybe<Scalars['String']['output']>;
  primaryProcPostLOSMore2?: Maybe<Scalars['String']['output']>;
  primaryProcPreLOSLess1?: Maybe<Scalars['String']['output']>;
  principalDiagnosisICDCodeName?: Maybe<Scalars['String']['output']>;
  principalProcedureICDCodeName?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  procedureMDName?: Maybe<Scalars['String']['output']>;
  pulmonaryEmbol?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  rawAdmitSourceName?: Maybe<Scalars['String']['output']>;
  rawDischargeStatus?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionAdmitDayOfWeek?: Maybe<Scalars['String']['output']>;
  readmissionAdmitSourceName?: Maybe<Scalars['String']['output']>;
  readmissionAdmitType?: Maybe<Scalars['String']['output']>;
  readmissionConditionGrouperL2?: Maybe<Scalars['String']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDischargeStatus?: Maybe<Scalars['String']['output']>;
  readmissionDrgName?: Maybe<Scalars['String']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  readmissionICDPrimaryProcedure?: Maybe<Scalars['String']['output']>;
  readmissionInOutCode?: Maybe<Scalars['String']['output']>;
  readmissionReason?: Maybe<Scalars['String']['output']>;
  readmissionSummaryPayorClass?: Maybe<Scalars['String']['output']>;
  readmissionWithWithout?: Maybe<Scalars['String']['output']>;
  referringMDRole?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  renalFailAcute?: Maybe<Scalars['String']['output']>;
  respArrest?: Maybe<Scalars['String']['output']>;
  respFailAcute?: Maybe<Scalars['String']['output']>;
  sepsis?: Maybe<Scalars['String']['output']>;
  stressTest?: Maybe<Scalars['String']['output']>;
  transplantType?: Maybe<Scalars['String']['output']>;
  vadPoa?: Maybe<Scalars['String']['output']>;
  vadProcedureType?: Maybe<Scalars['String']['output']>;
  vascularUS?: Maybe<Scalars['String']['output']>;
  ventrFibrillation?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
  visitsPerEpisode?: Maybe<Scalars['Int']['output']>;
};

export enum DagsterTrigger {
  MoveToProd = 'MoveToProd',
}

export enum DagsterTriggerPipelineType {
  CaseLists = 'CaseLists',
  EchoNlp = 'EchoNLP',
  Mcl = 'MCL',
  Measures = 'Measures',
  Oe = 'OE',
  Pm = 'PM',
  RiskAudits = 'RiskAudits',
  Unmasker = 'Unmasker',
  VisitLevelFields = 'VisitLevelFields',
}

export type DashboardPolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['String']['input'];
  eft?: InputMaybe<Scalars['String']['input']>;
  objectType: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  workbookGroupId: Scalars['String']['input'];
  workbookId: Scalars['String']['input'];
};

export type DataFrame = {
  __typename?: 'DataFrame';
  auditorId?: Maybe<Scalars['String']['output']>;
  availableToETL: EtlAvailability;
  careEntities?: Maybe<Array<CareEntity>>;
  clientDataFile?: Maybe<ClientDataFile>;
  clientDataFileId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  crosswalkApplicationState?: Maybe<CrosswalkState>;
  crosswalkAppliedPercentage?: Maybe<Scalars['Float']['output']>;
  crosswalkLoadState?: Maybe<CrosswalkState>;
  crosswalkLoadedPercentage?: Maybe<Scalars['Float']['output']>;
  crosswalkLocation?: Maybe<Scalars['String']['output']>;
  dataframeMclChunks?: Maybe<Array<DataframeMclChunk>>;
  dataset?: Maybe<Dataset>;
  datasetId?: Maybe<Scalars['Int']['output']>;
  datasetInstances: Array<DatasetInstance>;
  deletedAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastEventId?: Maybe<Scalars['String']['output']>;
  lifelineEvents: Array<LifelineEvent>;
  location: Scalars['String']['output'];
  maskAt?: Maybe<Scalars['DateTime']['output']>;
  maskDataFrameName?: Maybe<Scalars['String']['output']>;
  maskLocation?: Maybe<Scalars['String']['output']>;
  maskState: MaskState;
  maskedAt?: Maybe<Scalars['DateTime']['output']>;
  maskedDataFrameLocation?: Maybe<Scalars['String']['output']>;
  maskedDataFrameName?: Maybe<Scalars['String']['output']>;
  maskedLocations?: Maybe<Array<MaskedDataframeLocations>>;
  maskerState: MaskerState;
  mclStatus: DataframeMclStatus;
  name: Scalars['String']['output'];
  phiEnrichedLocation?: Maybe<Scalars['String']['output']>;
  phiEnrichmentState: PhiEnrichmentState;
  redactedAt?: Maybe<Scalars['DateTime']['output']>;
  redactorState: MaskerState;
  registrySubsetName?: Maybe<Scalars['String']['output']>;
  rowCount: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  subsetId?: Maybe<Scalars['Float']['output']>;
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['String']['output']>;
  trails?: Maybe<Array<DataframeTrail>>;
  unknownCareEntities?: Maybe<Array<Scalars['String']['output']>>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  validation: DataframeValidationStatus;
};

export enum DataPlatform {
  AscendGen1 = 'AscendGen1',
  AscendGen3 = 'AscendGen3',
  Dagster = 'Dagster',
}

export type Dataflow = {
  __typename?: 'Dataflow';
  components?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataFeedInputs?: Maybe<Array<Scalars['String']['output']>>;
  dataFeedOutputs?: Maybe<Array<Scalars['String']['output']>>;
  dataServiceName?: Maybe<Scalars['String']['output']>;
  datafeedTransforms?: Maybe<Array<Scalars['String']['output']>>;
  dataflowRuns: Array<DataflowRun>;
  deployment?: Maybe<Scalars['String']['output']>;
  diseaseStateModules?: Maybe<Array<DiseaseStateModule>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  platform: DataPlatform;
  project?: Maybe<Scalars['String']['output']>;
  pseudoWriteTransforms?: Maybe<Array<Scalars['String']['output']>>;
  readConnectors?: Maybe<Array<Scalars['String']['output']>>;
  requests: Array<DataflowRequest>;
  type: DataflowType;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  writeConnectors?: Maybe<Array<Scalars['String']['output']>>;
};

export type DataflowRequest = {
  __typename?: 'DataflowRequest';
  auditourReports: Array<AuditourReport>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataflow?: Maybe<Dataflow>;
  dataflowRun?: Maybe<DataflowRun>;
  id: Scalars['String']['output'];
  oePipelineRuns?: Maybe<Array<OePipelineRun>>;
  selectedDsms?: Maybe<Array<DiseaseStateModule>>;
  status: DataflowRequestStatus;
  tenant?: Maybe<Tenant>;
  triggerablePipeline?: Maybe<TriggerablePipeline>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export enum DataflowRequestStatus {
  AuditourFailed = 'AuditourFailed',
  AuditourInProgress = 'AuditourInProgress',
  Completed = 'Completed',
  Error = 'Error',
  Pending = 'Pending',
  PipelineInProgress = 'PipelineInProgress',
}

export type DataflowRun = {
  __typename?: 'DataflowRun';
  allowExpiration: Scalars['Boolean']['output'];
  auditourReports: Array<AuditourReport>;
  codeVersion?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataFrames: Array<DataflowRunDataFrame>;
  dataflow: Dataflow;
  dataflowId: Scalars['String']['output'];
  dataflowRunUUID?: Maybe<Scalars['String']['output']>;
  datasetInstances?: Maybe<Array<DatasetInstance>>;
  deployment?: Maybe<Scalars['String']['output']>;
  durationSeconds?: Maybe<Scalars['Float']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['JSON']['output']>;
  etlRiskAudits: Array<DataflowRun>;
  id: Scalars['String']['output'];
  inputFilesListed?: Maybe<Scalars['Int']['output']>;
  inputFilesMatched?: Maybe<Scalars['Int']['output']>;
  inputFilesUnidentified?: Maybe<Scalars['Int']['output']>;
  inputRuns: Array<DataflowRunInputRun>;
  inputTracking: InputTrackingStatus;
  inputTrackingAt?: Maybe<Scalars['DateTime']['output']>;
  inputTrackingError?: Maybe<Scalars['JSON']['output']>;
  milestones: Array<DataflowRunMilestone>;
  movedToProd: MovedToProdStatus;
  movedToProdAt?: Maybe<Scalars['DateTime']['output']>;
  oePipelineRuns: Array<OePipelineRun>;
  outputs: Array<AscendOutput>;
  path: Scalars['String']['output'];
  release?: Maybe<Scalars['String']['output']>;
  request?: Maybe<DataflowRequest>;
  requestId?: Maybe<Scalars['String']['output']>;
  riskAuditInput?: Maybe<DataflowRun>;
  riskAuditInputId?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['DateTime']['output'];
  status: DataflowRunStatus;
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['String']['output']>;
  unidentifiedInputs: Array<DataflowRunUnidentifiedInput>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  validation: DataflowValidationStatus;
};

export type DataflowRunDataFrame = {
  __typename?: 'DataflowRunDataFrame';
  createdAt: Scalars['DateTime']['output'];
  dataFrame: DataFrame;
  dataFrameId: Scalars['String']['output'];
  dataflowRun?: Maybe<DataflowRun>;
  dataflowRunId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sourceName: Scalars['String']['output'];
};

export enum DataflowRunInputResolvedVia {
  MovedToProdQuery = 'MovedToProdQuery',
  PromotedRunstats = 'PromotedRunstats',
  Unresolved = 'Unresolved',
}

export enum DataflowRunInputRole {
  Admin = 'Admin',
  MeasuresOutput = 'MeasuresOutput',
}

export type DataflowRunInputRun = {
  __typename?: 'DataflowRunInputRun';
  createdAt: Scalars['DateTime']['output'];
  dataflowRun?: Maybe<DataflowRun>;
  dataflowRunId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inputDataflowRun?: Maybe<DataflowRun>;
  inputDataflowRunId?: Maybe<Scalars['String']['output']>;
  inputRunUUID?: Maybe<Scalars['String']['output']>;
  inputTenant?: Maybe<Tenant>;
  inputTenantId: Scalars['String']['output'];
  leaves?: Maybe<Array<Scalars['String']['output']>>;
  promotedPath: Scalars['String']['output'];
  registry: Scalars['String']['output'];
  resolvedVia: DataflowRunInputResolvedVia;
  role: DataflowRunInputRole;
};

export type DataflowRunMilestone = {
  __typename?: 'DataflowRunMilestone';
  adlsPath?: Maybe<Scalars['String']['output']>;
  assetKey: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dataflowRun: DataflowRun;
  dataflowRunId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  materializationId?: Maybe<Scalars['Int']['output']>;
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  rowCount?: Maybe<Scalars['Int']['output']>;
  sinkTable: Scalars['String']['output'];
};

export enum DataflowRunStatus {
  Cancelled = 'Cancelled',
  Complete = 'Complete',
  Error = 'Error',
  InProgress = 'InProgress',
  Incomplete = 'Incomplete',
}

export type DataflowRunUnidentifiedInput = {
  __typename?: 'DataflowRunUnidentifiedInput';
  containerPath: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dataflowRun?: Maybe<DataflowRun>;
  dataflowRunId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sourceName: Scalars['String']['output'];
  unidentifiedCount: Scalars['Int']['output'];
  unidentifiedNames: Array<Scalars['String']['output']>;
};

export enum DataflowType {
  AppInsights = 'AppInsights',
  Benchmarks = 'Benchmarks',
  CaseLists = 'CaseLists',
  Drp = 'DRP',
  DemoData = 'DemoData',
  Derivatives = 'Derivatives',
  EchoNlp = 'EchoNLP',
  InformationSchema = 'InformationSchema',
  Mcl = 'MCL',
  Measures = 'Measures',
  Oe = 'OE',
  Pm = 'PM',
  PlatformMaintenance = 'PlatformMaintenance',
  Risk = 'Risk',
  Unmasker = 'Unmasker',
  VisitLevelFields = 'VisitLevelFields',
}

export enum DataflowValidationStatus {
  Failed = 'Failed',
  ManualOverride = 'ManualOverride',
  Pending = 'Pending',
  Success = 'Success',
}

export enum DataframeLocationType {
  Adl = 'ADL',
  MySql = 'MySQL',
  Parquet = 'Parquet',
  ParquetLocation = 'ParquetLocation',
}

/** Dataframe Chunks that have been loaded in mcl */
export type DataframeMclChunk = {
  __typename?: 'DataframeMclChunk';
  casesAdded: Scalars['Float']['output'];
  chunkNumber: Scalars['Float']['output'];
  dataframe: DataFrame;
  dataframeId: Scalars['String']['output'];
  elapsedTime: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  rootTriggerId: Scalars['String']['output'];
};

export enum DataframeMclStatus {
  DataLoadedInMcl = 'DataLoadedInMcl',
  DataLoadedInMclWithWarnings = 'DataLoadedInMclWithWarnings',
  DataSubmittedToMcl = 'DataSubmittedToMcl',
  DataSubmittedToMclWithWarnings = 'DataSubmittedToMclWithWarnings',
  Failed = 'Failed',
  Inprogress = 'Inprogress',
  Pending = 'Pending',
}

export type DataframeTrail = {
  __typename?: 'DataframeTrail';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  dataframe: DataFrame;
  dataframeId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isLatest: Scalars['Boolean']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export enum DataframeValidationStatus {
  Error = 'Error',
  Failed = 'Failed',
  ManualOverride = 'ManualOverride',
  Pending = 'Pending',
  Success = 'Success',
}

export type Dataset = {
  __typename?: 'Dataset';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  criticalDiseaseStateModules?: Maybe<Array<DiseaseStateModule>>;
  crosswalkRequired: Scalars['Boolean']['output'];
  datasetDictionaries?: Maybe<Array<Dictionary>>;
  datasetVersions?: Maybe<Array<DatasetVersion>>;
  deadlines?: Maybe<Array<Deadline>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  diseaseStateModules?: Maybe<Array<DiseaseStateModule>>;
  id: Scalars['Int']['output'];
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isCrosswalkSource: Scalars['Boolean']['output'];
  /** Indicates if past submissions should be dropped from the data pipeline when new data for an overlapping time period is provided. If this is marked "yes" old data is removed and replaced entirely by the new submission */
  isDropAndLoad?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates that this dataset holds follow-up assessments for a registry rather than the base visit. Report Builder treats the one non-follow-up clinical dataset of a disease state module as the anchor: it is the dataset the care-entity and date filters apply to, and the only one carrying visitid. Follow-up datasets correlate to it on biomeencounterid. */
  isFollowUp: Scalars['Boolean']['output'];
  isRegistry: Scalars['Boolean']['output'];
  /** Indicates if submissions request should be sent on tenant-level or care-entity level. If this is marked "yes" submission-request will contain tenant-code otherwise it will contain care-entities list. */
  isTenantLevel?: Maybe<Scalars['Boolean']['output']>;
  managingSociety: Scalars['String']['output'];
  name: Scalars['String']['output'];
  primaryDiseaseStateModules?: Maybe<Array<DiseaseStateModule>>;
  submissions?: Maybe<Array<Submission>>;
  /** Indicates if the dataset supports the report builder feature. */
  supportsReportBuilder?: Maybe<Scalars['Boolean']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type DatasetInstance = {
  __typename?: 'DatasetInstance';
  beats?: Maybe<Array<Beat>>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  caseCount?: Maybe<Scalars['Float']['output']>;
  coverage: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataflowRuns?: Maybe<Array<DataflowRun>>;
  dataframes?: Maybe<Array<DataFrame>>;
  dataset?: Maybe<Dataset>;
  datasetId?: Maybe<Scalars['Int']['output']>;
  enrichedCaseCount?: Maybe<Scalars['Float']['output']>;
  enrichedLocation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isLatest: Scalars['Boolean']['output'];
  isReady: Scalars['Boolean']['output'];
  lastEventId?: Maybe<Scalars['String']['output']>;
  lifelineEvents?: Maybe<Array<LifelineEvent>>;
  maskCaseCount?: Maybe<Scalars['Float']['output']>;
  maskLocation?: Maybe<Scalars['String']['output']>;
  maskedCaseCount?: Maybe<Scalars['Float']['output']>;
  maskedLocation?: Maybe<Scalars['String']['output']>;
  matches?: Maybe<Scalars['Float']['output']>;
  month: Month;
  pastYearMean?: Maybe<Scalars['Float']['output']>;
  pastYearStdDev?: Maybe<Scalars['Float']['output']>;
  rowCount?: Maybe<Scalars['Float']['output']>;
  submittedAt: Scalars['String']['output'];
  unmaskedCaseCount?: Maybe<Scalars['Float']['output']>;
  unmaskedLocation?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type DatasetVersion = {
  __typename?: 'DatasetVersion';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataset: Dataset;
  datasetId: Scalars['Int']['output'];
  datasetVersionFields?: Maybe<Array<DatasetVersionField>>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  versionNumber: Scalars['Float']['output'];
};

export type DatasetVersionField = {
  __typename?: 'DatasetVersionField';
  datasetVersion: DatasetVersion;
  datasetVersionId: Scalars['ID']['output'];
  fieldId: Scalars['Int']['output'];
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
};

export enum DateRangeTypes {
  CustomDateRange = 'CustomDateRange',
  CustomQuarters = 'CustomQuarters',
  Last3Months = 'Last3Months',
  Last4Quarters = 'Last4Quarters',
  LastMonth = 'LastMonth',
  LastQuarter = 'LastQuarter',
  LastWeek = 'LastWeek',
}

export type Deadline = {
  __typename?: 'Deadline';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataset: Dataset;
  datasetId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  monthIncluded?: Maybe<Scalars['String']['output']>;
  monthSubmissionDeadline?: Maybe<Scalars['DateTime']['output']>;
  quarterIncluded?: Maybe<Scalars['String']['output']>;
  quarterSubmissionDeadline?: Maybe<Scalars['DateTime']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type Definition = {
  __typename?: 'Definition';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  definition: Scalars['String']['output'];
  element: Element;
  id: Scalars['ID']['output'];
  source?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
};

export type DeleteTenantOffboardingInput = {
  id: Scalars['String']['input'];
  /** Entries not to delete; application records cannot be kept */
  keptSources: Array<KeptSourceInput>;
  /** Typed by the caller to confirm */
  tenantCode: Scalars['String']['input'];
  /** The approved version the caller reviewed */
  version: Scalars['Int']['input'];
};

export type DevelopmentDimension = {
  __typename?: 'DevelopmentDimension';
  active: Scalars['Boolean']['output'];
  aeQualifying: Scalars['Boolean']['output'];
  allMeasures: Scalars['Boolean']['output'];
  class: Scalars['String']['output'];
  codeVersion?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dimensionId: Scalars['Int']['output'];
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModuleId: Scalars['Int']['output'];
  documentation?: Maybe<Scalars['JSON']['output']>;
  excludeValues?: Maybe<Array<Scalars['String']['output']>>;
  fieldName: Scalars['String']['output'];
  hideFromReports: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isGlobal: Scalars['Boolean']['output'];
  jiraLink?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  legacyDescription?: Maybe<Scalars['String']['output']>;
  multiProcTable?: Maybe<MultiProcTable>;
  multiProcTableId?: Maybe<Scalars['String']['output']>;
  oeQualifying: Scalars['Boolean']['output'];
  pipelineElement?: Maybe<PipelineElement>;
  pipelineElementId?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  requirements?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
  sourceContinuousField?: Maybe<Scalars['String']['output']>;
  state: EntityState;
  stateHistory?: Maybe<Scalars['JSON']['output']>;
  status: EntityStatus;
  type: DimensionType;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
  valueMap?: Maybe<Scalars['JSON']['output']>;
};

export type DevelopmentEntityFilterInput = {
  diseaseStateModuleId?: InputMaybe<Scalars['Int']['input']>;
  includeDisposed?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<EntityState>;
  status?: InputMaybe<EntityStatus>;
};

export type DevelopmentMeasure = {
  __typename?: 'DevelopmentMeasure';
  accessCategory: AccessCategory;
  active: Scalars['Boolean']['output'];
  adjustment?: Maybe<Array<Scalars['String']['output']>>;
  aggregationFn?: Maybe<Array<Scalars['String']['output']>>;
  aggregationType?: Maybe<SummaryCalculationType>;
  annualMeasureBaseId?: Maybe<Scalars['String']['output']>;
  benchmarkExtraction: Scalars['Boolean']['output'];
  codeVersion?: Maybe<Scalars['String']['output']>;
  commonMeasureDisplayName: Scalars['String']['output'];
  commonMeasureQualifying?: Maybe<Scalars['Boolean']['output']>;
  costComponentMeasure?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  dataTypeRequired?: Maybe<MeasureInputDataType>;
  denominatorColumnName?: Maybe<Scalars['String']['output']>;
  denominatorDocumentation?: Maybe<Scalars['JSON']['output']>;
  denominatorLegacyDescription?: Maybe<Scalars['String']['output']>;
  denominatorPipelineElement?: Maybe<PipelineElement>;
  denominatorPipelineElementId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  developedOn?: Maybe<Scalars['DateTime']['output']>;
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModuleId: Scalars['Int']['output'];
  excludedCohortIds?: Maybe<Array<Scalars['Float']['output']>>;
  family?: Maybe<MeasureFamily>;
  hideFromReports: Scalars['Boolean']['output'];
  higherIsBetter?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  includeColumnName?: Maybe<Scalars['String']['output']>;
  includeDocumentation?: Maybe<Scalars['JSON']['output']>;
  includePipelineElement?: Maybe<PipelineElement>;
  includePipelineElementId?: Maybe<Scalars['String']['output']>;
  isBenchmark?: Maybe<Scalars['Boolean']['output']>;
  jiraLink?: Maybe<Scalars['String']['output']>;
  losROIQualifying?: Maybe<Scalars['Boolean']['output']>;
  measureId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  ncdrMeasureName?: Maybe<Scalars['String']['output']>;
  numeratorColumnName?: Maybe<Scalars['String']['output']>;
  numeratorDocumentation?: Maybe<Scalars['JSON']['output']>;
  numeratorLegacyDescription?: Maybe<Scalars['String']['output']>;
  numeratorPipelineElement?: Maybe<PipelineElement>;
  numeratorPipelineElementId?: Maybe<Scalars['String']['output']>;
  numeratorUnit: Scalars['String']['output'];
  opportunityType: Array<OpportunityType>;
  outcomeType?: Maybe<MeasureOutcomeType>;
  parentId?: Maybe<Scalars['Int']['output']>;
  publicationSource?: Maybe<Array<PublicationSource>>;
  rareEvent: Scalars['Boolean']['output'];
  registryMeasureId?: Maybe<Scalars['Int']['output']>;
  reportRowId?: Maybe<Scalars['Int']['output']>;
  requirements?: Maybe<Scalars['String']['output']>;
  riskAdjusted: Scalars['Boolean']['output'];
  riskMetric?: Maybe<RiskMetric>;
  riskMetricDocumentation?: Maybe<Scalars['JSON']['output']>;
  riskMetricId?: Maybe<Scalars['String']['output']>;
  riskMetricPipelineElement?: Maybe<PipelineElement>;
  riskMetricPipelineElementId?: Maybe<Scalars['String']['output']>;
  roiCalcType?: Maybe<SummaryCalculationType>;
  secondaryFamily?: Maybe<MeasureFamily>;
  state: EntityState;
  stateHistory?: Maybe<Scalars['JSON']['output']>;
  status: EntityStatus;
  summaryCohortId?: Maybe<Scalars['Float']['output']>;
  summaryInitiativeMeasure: Scalars['Boolean']['output'];
  tableName?: Maybe<Scalars['String']['output']>;
  testCapture?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
  validationSource?: Maybe<Scalars['String']['output']>;
  volumeMeasure?: Maybe<Scalars['Boolean']['output']>;
};

export type DevelopmentRoiMetric = {
  __typename?: 'DevelopmentRoiMetric';
  active: Scalars['Boolean']['output'];
  codeVersion?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModuleId: Scalars['Int']['output'];
  documentation?: Maybe<Scalars['JSON']['output']>;
  fieldName: Scalars['String']['output'];
  higherIsBetter: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  jiraLink?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  legacyDescription?: Maybe<Scalars['String']['output']>;
  pipelineElement?: Maybe<PipelineElement>;
  pipelineElementId?: Maybe<Scalars['String']['output']>;
  roiMetricId: Scalars['ID']['output'];
  state: EntityState;
  stateHistory?: Maybe<Scalars['JSON']['output']>;
  status: EntityStatus;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
};

export type Dictionary = {
  __typename?: 'Dictionary';
  allTenants: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataFeed?: Maybe<Scalars['JSON']['output']>;
  dataset: Dataset;
  id: Scalars['ID']['output'];
  sections?: Maybe<Array<Section>>;
  tenants?: Maybe<Array<Tenant>>;
  type: DictionaryType;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export enum DictionaryType {
  Biome = 'Biome',
  Vendor = 'Vendor',
}

export enum DimType {
  Procedure = 'Procedure',
  SubGroup = 'SubGroup',
  Summary = 'Summary',
}

export type Dimension = {
  __typename?: 'Dimension';
  aeQualifying: Scalars['Boolean']['output'];
  allMeasures: Scalars['Boolean']['output'];
  class: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dimensionSets: Array<DimensionSet>;
  dimensionValueSortOrder?: Maybe<Array<DimensionValueSortOrder>>;
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModuleId: Scalars['Int']['output'];
  excludeValues?: Maybe<Array<Scalars['String']['output']>>;
  fieldName: Scalars['String']['output'];
  hideFromReports: Scalars['Boolean']['output'];
  history: Array<DimensionHistory>;
  id: Scalars['Int']['output'];
  isGlobal: Scalars['Boolean']['output'];
  kbFieldId?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  legacyDescription?: Maybe<Scalars['String']['output']>;
  multiProcTable?: Maybe<MultiProcTable>;
  multiProcTableId?: Maybe<Scalars['String']['output']>;
  oeQualifying: Scalars['Boolean']['output'];
  pipelineElement?: Maybe<PipelineElement>;
  pipelineElementId?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  requirements?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
  sortType: SortType;
  sourceContinuousField?: Maybe<Scalars['String']['output']>;
  type: DimensionType;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  valueMap?: Maybe<Scalars['JSON']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type DimensionFilter = {
  procedureDimensionId?: InputMaybe<Scalars['Float']['input']>;
  procedureDimensionValue?: InputMaybe<Scalars['String']['input']>;
  subGroupDimensionId?: InputMaybe<Scalars['Float']['input']>;
  subGroupDimensionValue?: InputMaybe<Scalars['String']['input']>;
};

export type DimensionHistory = {
  __typename?: 'DimensionHistory';
  aeQualifying: Scalars['Boolean']['output'];
  allMeasures: Scalars['Boolean']['output'];
  class: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  dimensionId: Scalars['Int']['output'];
  diseaseStateModuleId: Scalars['Int']['output'];
  excludeValues?: Maybe<Array<Scalars['String']['output']>>;
  fieldName: Scalars['String']['output'];
  hideFromReports: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isGlobal: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  legacyDescription?: Maybe<Scalars['String']['output']>;
  multiProcTableName?: Maybe<Scalars['String']['output']>;
  oeQualifying: Scalars['Boolean']['output'];
  pipelineElementId?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  requirements?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
  sourceContinuousField?: Maybe<Scalars['String']['output']>;
  type: DimensionType;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  valueMap?: Maybe<Scalars['JSON']['output']>;
  version: Scalars['String']['output'];
};

export type DimensionSet = {
  __typename?: 'DimensionSet';
  dimensions: Array<Dimension>;
  id: Scalars['ID']['output'];
  measure: MeasureMetadata;
  measureId: Scalars['Float']['output'];
};

export enum DimensionType {
  Procedure = 'Procedure',
  SubGroup = 'SubGroup',
  Summary = 'Summary',
}

export type DimensionValueSortOrder = {
  __typename?: 'DimensionValueSortOrder';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dimension: Dimension;
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  valueLabel: Scalars['String']['output'];
};

export type DiseaseStateModule = {
  __typename?: 'DiseaseStateModule';
  adjustment?: Maybe<Array<Scalars['String']['output']>>;
  aggregateBeats: Array<AggregateBeat>;
  aggregationFn?: Maybe<Array<Scalars['String']['output']>>;
  beats: Array<Beat>;
  careEntities?: Maybe<Array<CareEntity>>;
  clinicalProgram: ClinicalProgram;
  clinicalProgramId: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  criticalDatasets?: Maybe<Array<Dataset>>;
  datasets?: Maybe<Array<Dataset>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  hideRiskAuditCharts?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  multiProcTables?: Maybe<Array<MultiProcTable>>;
  name: Scalars['String']['output'];
  notificationLogs?: Maybe<Array<NotificationLogs>>;
  primaryDataset?: Maybe<Dataset>;
  primaryDatasetId?: Maybe<Scalars['Int']['output']>;
  riskMetrics?: Maybe<Array<RiskMetric>>;
  roles?: Maybe<Array<Role>>;
  strategyTemplates?: Maybe<Array<ObjectiveStrategyTemplate>>;
  summaryCohortId?: Maybe<Scalars['Float']['output']>;
  supportedApps?: Maybe<Array<SupportedApps>>;
  supportsMultipleProcedures: Scalars['Boolean']['output'];
  tableName?: Maybe<Scalars['String']['output']>;
  type: DsmType;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  workbookGroups?: Maybe<Array<WorkbookGroup>>;
  workbooks?: Maybe<Array<Workbook>>;
};

export type DiseaseStateModuleMultiProcTableInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  tableName: Scalars['String']['input'];
};

export type DiseaseStateModuleRiskMetricInput = {
  columnName: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Distribution List */
export type DistributionList = {
  __typename?: 'DistributionList';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description: Scalars['String']['output'];
  files?: Maybe<Array<File>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  users?: Maybe<Array<User>>;
};

export type Documentation = {
  dependencies: Array<Documentation>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  shortName: Scalars['String']['input'];
};

export type DsmAdditionImpact = {
  __typename?: 'DsmAdditionImpact';
  affectedRoles?: Maybe<Array<Role>>;
  newRoles?: Maybe<Array<Scalars['String']['output']>>;
};

export type DsmPolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['String']['input'];
  eft?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type DsmRemovalImpact = {
  __typename?: 'DsmRemovalImpact';
  affectedParentRoles?: Maybe<Array<Role>>;
  removedRoles?: Maybe<Array<Role>>;
  submissions?: Maybe<Array<Submission>>;
};

export enum DsmType {
  AdvancedClinical = 'AdvancedClinical',
  Foundational = 'Foundational',
}

export type EchoAttributes = {
  __typename?: 'EchoAttributes';
  careEntityId: Scalars['String']['output'];
  caseListModuleName: Scalars['String']['output'];
  count: Scalars['Float']['output'];
  echoLatestRefreshDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  maxStudyDate: Scalars['DateTime']['output'];
};

export enum EchoFieldCategory {
  AorticValve = 'AORTIC_VALVE',
  AsdVsd = 'ASD_VSD',
  Biome = 'BIOME',
  Cardiomyopathy = 'CARDIOMYOPATHY',
  Contrast = 'CONTRAST',
  La = 'LA',
  LvFunction = 'LV_FUNCTION',
  MitralValve = 'MITRAL_VALVE',
  Mmode = 'MMODE',
  PatientStudyDemographics = 'PATIENT_STUDY_DEMOGRAPHICS',
  PatientTracking = 'PATIENT_TRACKING',
  Pericardial = 'PERICARDIAL',
  PulmonicValve = 'PULMONIC_VALVE',
  Ra = 'RA',
  RightVentricle = 'RIGHT_VENTRICLE',
  RvFunction = 'RV_FUNCTION',
  StrainImaging = 'STRAIN_IMAGING',
  Symptoms = 'SYMPTOMS',
  Thrombi = 'THROMBI',
  Tricuspid = 'TRICUSPID',
}

export type EchoFinding = {
  __typename?: 'EchoFinding';
  age?: Maybe<Scalars['Float']['output']>;
  avRegurgitation?: Maybe<Scalars['String']['output']>;
  avStenosis?: Maybe<Scalars['String']['output']>;
  avStenosisText?: Maybe<Scalars['String']['output']>;
  biomeCaseUid?: Maybe<Scalars['String']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomeImportDt?: Maybe<Scalars['DateTime']['output']>;
  biomePatientUid?: Maybe<Scalars['String']['output']>;
  biomeUpdateDt?: Maybe<Scalars['DateTime']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  careEntityName?: Maybe<Scalars['String']['output']>;
  caseId: Scalars['String']['output'];
  caselistModule: EchoFindingModule;
  caselistModuleName: Scalars['String']['output'];
  echoResultText?: Maybe<Scalars['String']['output']>;
  followups: Array<EchoFindingFollowup>;
  gender?: Maybe<Scalars['String']['output']>;
  latestStudyOnRecord?: Maybe<Scalars['Boolean']['output']>;
  mrn?: Maybe<Scalars['String']['output']>;
  mvRegurgitation?: Maybe<Scalars['String']['output']>;
  mvStenosis?: Maybe<Scalars['String']['output']>;
  orderDt?: Maybe<Scalars['DateTime']['output']>;
  otherValveDisease?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  pvStenosis?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  tvRegurgitation?: Maybe<Scalars['String']['output']>;
  tvStenosis?: Maybe<Scalars['String']['output']>;
};

export type EchoFindingField = {
  __typename?: 'EchoFindingField';
  caselistModule: EchoFindingModule;
  caselistModuleName: Scalars['String']['output'];
  category: EchoFieldCategory;
  common: Scalars['Boolean']['output'];
  computed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  displayRank: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phi: Scalars['Boolean']['output'];
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['String']['output']>;
  tenantName?: Maybe<Scalars['String']['output']>;
  trained: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  visibility: VisibilityType;
};

export type EchoFindingFollowup = {
  __typename?: 'EchoFindingFollowup';
  biomeCaseUid: Scalars['String']['output'];
  biomePatientUid: Scalars['String']['output'];
  caselistModuleName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  finding?: Maybe<EchoFinding>;
  id: Scalars['ID']['output'];
  latestStudyOnRecord: Scalars['Boolean']['output'];
  notes: Scalars['String']['output'];
  statusId: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type EchoFindingFollowupInput = {
  biomeCaseUid: Scalars['String']['input'];
  biomePatientUid: Scalars['String']['input'];
  caselistModuleName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  finding: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  latestStudyOnRecord?: Scalars['Boolean']['input'];
  notes: Scalars['String']['input'];
  statusId: Scalars['String']['input'];
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  version?: Scalars['Int']['input'];
};

export type EchoFindingFollowupOption = {
  __typename?: 'EchoFindingFollowupOption';
  careEntities?: Maybe<Array<CareEntity>>;
  caselistModule: EchoFindingModule;
  caselistModuleName: Scalars['String']['output'];
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  displayRank: Scalars['Float']['output'];
  hide: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  scope: FollowupOptionScope;
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['String']['output']>;
  tenantName?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type EchoFindingModule = {
  __typename?: 'EchoFindingModule';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  displayRank: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tenants?: Maybe<Array<Tenant>>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type EchoFollowupOptionInput = {
  careEntities?: InputMaybe<Array<UpdateCareEntityInput>>;
  caselistModule: UpdateEchoModuleInput;
  caselistModuleName?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  displayRank?: InputMaybe<Scalars['Float']['input']>;
  hide: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  scope: FollowupOptionScope;
  tenant?: InputMaybe<UpdateTenantInput>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantName?: InputMaybe<Scalars['String']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  updateById?: InputMaybe<Scalars['String']['input']>;
};

export type EchoMessageTemplate = {
  __typename?: 'EchoMessageTemplate';
  common: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  hide: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  template: Scalars['String']['output'];
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type EchoMessageTemplateInput = {
  common: Scalars['Boolean']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  hide: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  template: Scalars['String']['input'];
  tenant?: InputMaybe<UpdateTenantInput>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  updateById?: InputMaybe<Scalars['String']['input']>;
};

export type EchoPatientVolume = {
  __typename?: 'EchoPatientVolume';
  month: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type EchoQuantifiedSeverity = {
  __typename?: 'EchoQuantifiedSeverity';
  name: Scalars['String']['output'];
  y: Scalars['Float']['output'];
};

export type EchoReferringProvider = {
  __typename?: 'EchoReferringProvider';
  contact?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Boolean']['output'];
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['String']['output']>;
};

export type Echocardiogram = {
  __typename?: 'Echocardiogram';
  adminMatch?: Maybe<Scalars['Float']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  ageGroup?: Maybe<Scalars['String']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  avInsufficiency?: Maybe<Scalars['String']['output']>;
  avStenosis?: Maybe<Scalars['String']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  caseId?: Maybe<Scalars['String']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  indication?: Maybe<Scalars['String']['output']>;
  lvFunction?: Maybe<Scalars['String']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  mvRegurgitation?: Maybe<Scalars['String']['output']>;
  mvStenosis?: Maybe<Scalars['String']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  orderDayType?: Maybe<Scalars['String']['output']>;
  orderDayofWeek?: Maybe<Scalars['String']['output']>;
  orderHour?: Maybe<Scalars['String']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  procedureDayOfWeek?: Maybe<Scalars['String']['output']>;
  procedureDayType?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  procedureHour?: Maybe<Scalars['String']['output']>;
  procedureName?: Maybe<Scalars['String']['output']>;
  procedureQuarter?: Maybe<Scalars['String']['output']>;
  procedureStatus?: Maybe<Scalars['String']['output']>;
  pvRegurgitation?: Maybe<Scalars['String']['output']>;
  pvStenosis?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  readingProvider?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  referringProvider?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  resultSignedDayOfWeek?: Maybe<Scalars['String']['output']>;
  resultSignedDayType?: Maybe<Scalars['String']['output']>;
  resultSignedHour?: Maybe<Scalars['String']['output']>;
  sonographer?: Maybe<Scalars['String']['output']>;
  tvRegurgitation?: Maybe<Scalars['String']['output']>;
  tvStenosis?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
  visitType?: Maybe<Scalars['String']['output']>;
};

export type Ecmo = {
  __typename?: 'Ecmo';
  admin7DayReadmission?: Maybe<Scalars['String']['output']>;
  admin7DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin14DayReadmission?: Maybe<Scalars['String']['output']>;
  admin14DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin30DayReadmission?: Maybe<Scalars['String']['output']>;
  admin30DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  adminInOutCode?: Maybe<Scalars['String']['output']>;
  adminMatch?: Maybe<Scalars['Float']['output']>;
  admissionUnit?: Maybe<Scalars['String']['output']>;
  admitSourceName?: Maybe<Scalars['String']['output']>;
  admitType?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  bedDays?: Maybe<Scalars['Float']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomePayor?: Maybe<Scalars['String']['output']>;
  cardiacArrest?: Maybe<Scalars['String']['output']>;
  cardioShock?: Maybe<Scalars['String']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  clinicianAFirstName?: Maybe<Scalars['String']['output']>;
  clinicianALastName?: Maybe<Scalars['String']['output']>;
  clinicianName?: Maybe<Scalars['String']['output']>;
  cmi?: Maybe<Scalars['String']['output']>;
  conditionGrouperL2?: Maybe<Scalars['String']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  dischargeMDName?: Maybe<Scalars['String']['output']>;
  dischargeUnit?: Maybe<Scalars['String']['output']>;
  drgCodeName?: Maybe<Scalars['String']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  ecmoType?: Maybe<Scalars['String']['output']>;
  elixhauserIndex?: Maybe<Scalars['Int']['output']>;
  encounterId?: Maybe<Scalars['Float']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  icdDxCodeCategory?: Maybe<Scalars['String']['output']>;
  icuDaysNumerator?: Maybe<Scalars['Int']['output']>;
  inDirectCost?: Maybe<Scalars['Float']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mortality?: Maybe<Scalars['Int']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  multiVisit?: Maybe<Scalars['Int']['output']>;
  netRevenue?: Maybe<Scalars['Float']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  principalDiagnosisICDCodeName?: Maybe<Scalars['String']['output']>;
  principalProcedureICDCodeName?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  procedureMDName?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  rawAdmitSourceName?: Maybe<Scalars['String']['output']>;
  rawDischargeStatus?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  readmissionWithWithout?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
  visitsPerEpisode?: Maybe<Scalars['Int']['output']>;
};

export type Element = {
  __typename?: 'Element';
  code?: Maybe<Scalars['String']['output']>;
  codeSystem?: Maybe<Scalars['String']['output']>;
  codeSystemName?: Maybe<Scalars['String']['output']>;
  codingInstructions?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataSource?: Maybe<ElementDataSourceType>;
  dataType?: Maybe<ElementDataType>;
  dbDataType?: Maybe<Scalars['String']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  definition?: Maybe<Definition>;
  derivativeTransformations?: Maybe<Array<Transformation>>;
  elementReference: Scalars['String']['output'];
  hideFromReports: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isBaseElement: Scalars['Boolean']['output'];
  isDynamicList?: Maybe<Scalars['Boolean']['output']>;
  isFollowupElement: Scalars['Boolean']['output'];
  isHarvested?: Maybe<Scalars['Boolean']['output']>;
  isIdentifier: Scalars['Boolean']['output'];
  missingData?: Maybe<ElementMissingDataAction>;
  name: Scalars['String']['output'];
  parentChildValidations?: Maybe<Array<ParentChildValidation>>;
  phi?: Maybe<Scalars['Boolean']['output']>;
  pipelineElements: Array<PipelineElement>;
  precision?: Maybe<Scalars['String']['output']>;
  ranges?: Maybe<Array<Range>>;
  referenceTransformations?: Maybe<Array<Transformation>>;
  reports: Array<Report>;
  role?: Maybe<Scalars['String']['output']>;
  section: Section;
  sectionId: Scalars['String']['output'];
  selectionType?: Maybe<ElementSelectionType>;
  selections?: Maybe<Array<Selection>>;
  shortName: Scalars['String']['output'];
  sourceMappings?: Maybe<Array<Translation>>;
  targetMappings?: Maybe<Array<Translation>>;
  targetValue?: Maybe<Scalars['String']['output']>;
  unitOfMeasure?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  vendorInstruction?: Maybe<Scalars['String']['output']>;
};

export enum ElementDataSourceType {
  Automatic = 'Automatic',
  Computed = 'Computed',
  Lookup = 'Lookup',
  User = 'User',
  UserOrAutomatic = 'UserOrAutomatic',
  UserOrComputed = 'UserOrComputed',
}

export enum ElementDataType {
  Bl = 'BL',
  Cd = 'CD',
  Ctr = 'CTR',
  Dt = 'DT',
  Fn = 'FN',
  Ln = 'LN',
  Mn = 'MN',
  Num = 'NUM',
  Pq = 'PQ',
  Real = 'Real',
  St = 'ST',
  Tm = 'TM',
  Ts = 'TS',
}

export enum ElementMissingDataAction {
  Illegal = 'Illegal',
  NoAction = 'NoAction',
  Report = 'Report',
}

export enum ElementSelectionType {
  Multiple = 'Multiple',
  Single = 'Single',
}

export type EnableUserInput = {
  enabled: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  username: Scalars['String']['input'];
};

export enum EnforcerType {
  Admin = 'Admin',
  Case = 'Case',
  Clinician = 'Clinician',
  Dashboard = 'Dashboard',
  DiseaseStateModule = 'DiseaseStateModule',
  Entity = 'Entity',
  File = 'File',
  General = 'General',
  Initiative = 'Initiative',
  PatientList = 'PatientList',
  StrategyBoard = 'StrategyBoard',
  Tenant = 'Tenant',
  User = 'User',
}

export type EntityPolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  eft?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export enum EntityState {
  Development = 'Development',
  ProductionDeployment = 'ProductionDeployment',
  Release = 'Release',
  Request = 'Request',
}

export enum EntityStatus {
  CancelledArchived = 'CancelledArchived',
  CodeReviewApproved = 'CodeReviewApproved',
  Draft = 'Draft',
  MergedToProduction = 'MergedToProduction',
  MergedToStaging = 'MergedToStaging',
  OeDataMoveToProdCompleted = 'OeDataMoveToProdCompleted',
  OeDataMoveToProdFailed = 'OeDataMoveToProdFailed',
  OeDataMoveToProdStarted = 'OeDataMoveToProdStarted',
  OePipelineCompleted = 'OePipelineCompleted',
  OePipelineFailed = 'OePipelineFailed',
  OePipelineStarted = 'OePipelineStarted',
  Planned = 'Planned',
  ProductionPipelineCompleted = 'ProductionPipelineCompleted',
  ProductionPipelineFailed = 'ProductionPipelineFailed',
  ReStarted = 'ReStarted',
  Ready = 'Ready',
  ReadyForPeerReview = 'ReadyForPeerReview',
  ReadyForSmeReview = 'ReadyForSmeReview',
  SmeReviewApproved = 'SmeReviewApproved',
  SmeReviewRejected = 'SmeReviewRejected',
  StagingPipelineCompleted = 'StagingPipelineCompleted',
  StagingPipelineFailed = 'StagingPipelineFailed',
  Started = 'Started',
}

export type EntraIdGroup = {
  __typename?: 'EntraIdGroup';
  /** Description of the group. */
  description?: Maybe<Scalars['String']['output']>;
  /** Every entry in the directory has a distinguished name (DN). The DN is the name that uniquely identifies an entry in the directory. It is a sequence of relative distinguished names (RDN) connected by commas. An RDN is an attribute with an associated value in the form attribute=value; normally expressed in a UTF-8 string format. RDN attributes consist of commonName (CN), organizationalUnitName (OU) and so on. */
  distinguishedName?: Maybe<Scalars['String']['output']>;
  /** The azure group's acoount-id to identify it uniquely. */
  id: Scalars['String']['output'];
  /** Display name of the group */
  name?: Maybe<Scalars['String']['output']>;
};

export type EntraIdUser = {
  __typename?: 'EntraIdUser';
  adGroups?: Maybe<Array<EntraIdGroup>>;
  /** Common Name. The name that represents an object. Used to perform searches. */
  commonName?: Maybe<Scalars['String']['output']>;
  /** The user's company name. */
  company?: Maybe<Scalars['String']['output']>;
  /** Every entry in the directory has a distinguished name (DN). The DN is the name that uniquely identifies an entry in the directory. It is a sequence of relative distinguished names (RDN) connected by commas. An RDN is an attribute with an associated value in the form attribute=value; normally expressed in a UTF-8 string format. RDN attributes consist of commonName (CN), organizationalUnitName (OU) and so on. */
  distinguishedName?: Maybe<Scalars['String']['output']>;
  /** A boolean attribute that indicates if the user is enabled or not */
  enabled: Scalars['Boolean']['output'];
  /** Contains the given name (first name) of the user. */
  givenName?: Maybe<Scalars['String']['output']>;
  /** The azure user's acoount-id to identify it uniquely. */
  id: Scalars['String']['output'];
  /** The last time the user logged on. This value is stored as a large integer that represents the number of milliseconds since midnight, January 1, 1970 UTC */
  lastLogon?: Maybe<Scalars['Float']['output']>;
  /** This is the time that the user last logged into the domain. This value is stored as a large integer that represents the number of 100-nanosecond intervals since January 1, 1601 (UTC). Whenever a user logs on, the value of this attribute is read from the DC. If the value is older [ current_time - msDS-LogonTimeSyncInterval ], the value is updated. The initial update after the raise of the domain functional level is calculated as 14 days minus random percentage of 5 days. */
  lastLogonTimestamp?: Maybe<Scalars['String']['output']>;
  /** Date when user last changed the password. */
  lastPasswordChangeDate?: Maybe<Scalars['DateTime']['output']>;
  /** A boolean attribute that indicates if the user is locked or not */
  locked?: Maybe<Scalars['Boolean']['output']>;
  /** The date and time (UTC) that this account was locked out. This value is stored as a large integer that represents the number of 100-nanosecond intervals since January 1, 1601 (UTC). A value of zero means that the account is not currently locked out. */
  lockoutTime?: Maybe<Scalars['Float']['output']>;
  /** Holds the primary email address of a user, without the SMTP protocol prefix. e.g. user@domain.com */
  mail?: Maybe<Scalars['String']['output']>;
  /** A boolean attribute that indicates if the user password can be expired or not */
  passwordNeverExpires: Scalars['Boolean']['output'];
  /** This attribute contains the family or last name for a user. */
  surname?: Maybe<Scalars['String']['output']>;
  /** The primary telephone number. */
  telephoneNumber?: Maybe<Scalars['String']['output']>;
  /** Contains the user's job title. This property is commonly used to indicate the formal job title, such as Senior Programmer, rather than occupational class, such as programmer. It is not typically used for suffix titles such as Esq. or DDS. */
  title?: Maybe<Scalars['String']['output']>;
  /** Flags that control the behavior of the user account. */
  userAccountControl?: Maybe<Scalars['String']['output']>;
  /** This attribute contains the UPN that is an Internet-style login name for a user based on the Internet standard RFC 822. The UPN is shorter than the distinguished name and easier to remember. By convention, this should map to the user email name. The value set for this attribute is equal to the length of the user's ID and the domain name. */
  userPrincipalName?: Maybe<Scalars['String']['output']>;
  /** The user's account name to identify it uniquely. */
  username: Scalars['String']['output'];
};

export type Epdi = {
  __typename?: 'Epdi';
  admin7DayReadmission?: Maybe<Scalars['String']['output']>;
  admin7DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin14DayReadmission?: Maybe<Scalars['String']['output']>;
  admin14DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin30DayReadmission?: Maybe<Scalars['String']['output']>;
  admin30DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  adminInOutCode?: Maybe<Scalars['String']['output']>;
  adminMatch?: Maybe<Scalars['Float']['output']>;
  admissionUnit?: Maybe<Scalars['String']['output']>;
  admitDayOfWeek?: Maybe<Scalars['String']['output']>;
  admitSourceName?: Maybe<Scalars['String']['output']>;
  admitType?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  ageGroup?: Maybe<Scalars['String']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  attribute?: Maybe<Scalars['String']['output']>;
  bedDays?: Maybe<Scalars['Float']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomePayor?: Maybe<Scalars['String']['output']>;
  cardiacArrest?: Maybe<Scalars['String']['output']>;
  cardiacUS?: Maybe<Scalars['String']['output']>;
  cardioMEMS?: Maybe<Scalars['String']['output']>;
  cardioShock?: Maybe<Scalars['String']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  cath?: Maybe<Scalars['String']['output']>;
  chfAcute?: Maybe<Scalars['String']['output']>;
  chfAcuteOnChronic?: Maybe<Scalars['String']['output']>;
  chfChronicUspec?: Maybe<Scalars['String']['output']>;
  ckdStageIVorV?: Maybe<Scalars['String']['output']>;
  clinicianAFirstName?: Maybe<Scalars['String']['output']>;
  clinicianALastName?: Maybe<Scalars['String']['output']>;
  clinicianName?: Maybe<Scalars['String']['output']>;
  cmi?: Maybe<Scalars['String']['output']>;
  conditionGrouperL2?: Maybe<Scalars['String']['output']>;
  ctScan?: Maybe<Scalars['String']['output']>;
  daysToReadmission?: Maybe<Scalars['String']['output']>;
  daysToReadmissionBins?: Maybe<Scalars['String']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDayOfWeek?: Maybe<Scalars['String']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  dischargeMDName?: Maybe<Scalars['String']['output']>;
  dischargeStatus?: Maybe<Scalars['String']['output']>;
  dischargeUnit?: Maybe<Scalars['String']['output']>;
  distanceFromHospital?: Maybe<Scalars['String']['output']>;
  distanceInMilesBucket?: Maybe<Scalars['String']['output']>;
  drgCodeName?: Maybe<Scalars['String']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  elixhauserIndex?: Maybe<Scalars['Int']['output']>;
  elixhauserRiskBuckets?: Maybe<Scalars['String']['output']>;
  encounterId?: Maybe<Scalars['Float']['output']>;
  endStageRenal?: Maybe<Scalars['String']['output']>;
  epdiPrimaryProcedure?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hypovolShock?: Maybe<Scalars['String']['output']>;
  icdDxCodeCategory?: Maybe<Scalars['String']['output']>;
  icuDaysNumerator?: Maybe<Scalars['Int']['output']>;
  icuUtilizationAny?: Maybe<Scalars['String']['output']>;
  inDirectCost?: Maybe<Scalars['Float']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  losLess1?: Maybe<Scalars['String']['output']>;
  losLess2?: Maybe<Scalars['String']['output']>;
  mdcName?: Maybe<Scalars['String']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  medicare?: Maybe<Scalars['String']['output']>;
  mitraClip?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mortality?: Maybe<Scalars['Int']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  multiVisit?: Maybe<Scalars['Int']['output']>;
  netRevenue?: Maybe<Scalars['Float']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  otherShock?: Maybe<Scalars['String']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  overall?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  primaryProcPostLOSMore2?: Maybe<Scalars['String']['output']>;
  primaryProcPreLOSLess1?: Maybe<Scalars['String']['output']>;
  principalDiagnosisICDCodeName?: Maybe<Scalars['String']['output']>;
  principalProcedureICDCodeName?: Maybe<Scalars['String']['output']>;
  procedureDayOfWeek?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  procedureMDName?: Maybe<Scalars['String']['output']>;
  pulmonaryEmbol?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  rawAdmitSourceName?: Maybe<Scalars['String']['output']>;
  rawDischargeStatus?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionAdmitDayOfWeek?: Maybe<Scalars['String']['output']>;
  readmissionAdmitSourceName?: Maybe<Scalars['String']['output']>;
  readmissionAdmitType?: Maybe<Scalars['String']['output']>;
  readmissionConditionGrouperL2?: Maybe<Scalars['String']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDischargeStatus?: Maybe<Scalars['String']['output']>;
  readmissionDrgName?: Maybe<Scalars['String']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  readmissionICDPrimaryProcedure?: Maybe<Scalars['String']['output']>;
  readmissionInOutCode?: Maybe<Scalars['String']['output']>;
  readmissionReason?: Maybe<Scalars['String']['output']>;
  readmissionSummaryPayorClass?: Maybe<Scalars['String']['output']>;
  readmissionWithWithout?: Maybe<Scalars['String']['output']>;
  referringMDRole?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  renalFailAcute?: Maybe<Scalars['String']['output']>;
  respArrest?: Maybe<Scalars['String']['output']>;
  respFailAcute?: Maybe<Scalars['String']['output']>;
  sepsis?: Maybe<Scalars['String']['output']>;
  tavr?: Maybe<Scalars['String']['output']>;
  ventrFibrillation?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
  visitsPerEpisode?: Maybe<Scalars['Int']['output']>;
};

export enum EtlAvailability {
  Available = 'AVAILABLE',
  Failed = 'FAILED',
  Pending = 'PENDING',
}

export type ExpiringDeadlineWarning = {
  __typename?: 'ExpiringDeadlineWarning';
  datasetId: Scalars['Int']['output'];
  maxDeadline: Scalars['DateTime']['output'];
};

export type ExplicitCareEntityUser = {
  __typename?: 'ExplicitCareEntityUser';
  careEntityCode: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  submitsData: Scalars['Boolean']['output'];
  tenantCode: Scalars['String']['output'];
  tenantId: Scalars['ID']['output'];
  tenantName: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
  username: Scalars['String']['output'];
};

export type ExplicitCareEntityUserPage = {
  __typename?: 'ExplicitCareEntityUserPage';
  /** Pass as `after` to read the next page; null when this page is the last. */
  nextCursor?: Maybe<Scalars['String']['output']>;
  users: Array<ExplicitCareEntityUser>;
};

export enum ExtensionType {
  Avi = 'AVI',
  Cs3916 = 'CS3916',
  Csv = 'CSV',
  Dat = 'DAT',
  Db = 'DB',
  Docx = 'DOCX',
  Em5144 = 'EM5144',
  Filepart = 'FILEPART',
  Fl5144 = 'FL5144',
  Fx5144 = 'FX5144',
  Gpg = 'GPG',
  Gq1808 = 'GQ1808',
  Gq2892 = 'GQ2892',
  Gq3448 = 'GQ3448',
  Gq3968 = 'GQ3968',
  Gq4304 = 'GQ4304',
  Gq4380 = 'GQ4380',
  Gq5144 = 'GQ5144',
  Html = 'HTML',
  Job = 'JOB',
  Ly5144 = 'LY5144',
  Mht = 'MHT',
  Mp4 = 'MP4',
  Msg = 'MSG',
  Ods = 'ODS',
  Other = 'Other',
  Pdf = 'PDF',
  Pgp = 'PGP',
  Pptx = 'PPTX',
  Prn = 'PRN',
  Rep = 'REP',
  Rpt = 'RPT',
  Rtf = 'RTF',
  Samplexlsx = 'SAMPLEXLSX',
  Sevenz = 'SEVENZ',
  Sh = 'SH',
  Sql = 'SQL',
  Tsv = 'TSV',
  Txt = 'TXT',
  Unsupported = 'UNSUPPORTED',
  Url = 'URL',
  Xls = 'XLS',
  Xlsm = 'XLSM',
  Xlsx = 'XLSX',
  Xml = 'XML',
  Zip = 'ZIP',
}

/** File */
export type File = {
  __typename?: 'File';
  category: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distributionLists: Array<DistributionList>;
  extension: Scalars['String']['output'];
  fileLabel?: Maybe<FileLabel>;
  fileShareDate?: Maybe<Scalars['DateTime']['output']>;
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  objectiveStrategyId?: Maybe<Scalars['String']['output']>;
  objectiveStrategyTemplateId?: Maybe<Scalars['String']['output']>;
  phi?: Maybe<Scalars['Boolean']['output']>;
  report?: Maybe<Report>;
  reportId?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  url: Scalars['String']['output'];
  users: Array<FileUser>;
};

export enum FileCategory {
  Banner = 'banner',
  Document = 'document',
  Logo = 'logo',
  Public = 'public',
  Report = 'report',
  Shared = 'shared',
  Slide = 'slide',
}

export type FileDistributionList = {
  __typename?: 'FileDistributionList';
  distributionLists?: Maybe<Array<DistributionList>>;
  file: File;
  fileSharedDate?: Maybe<Scalars['DateTime']['output']>;
  isDirect: Scalars['Boolean']['output'];
};

export type FileInput = {
  category: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extension: Scalars['String']['input'];
  fileLabel?: InputMaybe<UpdateFileLabelInput>;
  historicPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  phi?: InputMaybe<Scalars['Boolean']['input']>;
  report?: InputMaybe<UpdateReportInput>;
  reportId?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<UpdateTenantInput>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  updateById?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type FileLabel = {
  __typename?: 'FileLabel';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  files?: Maybe<Array<File>>;
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy: User;
};

export type FilePolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  eft?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type FileShareNotification = {
  customMessage?: InputMaybe<Scalars['String']['input']>;
  sendNotification: Scalars['Boolean']['input'];
};

export type FileUser = {
  __typename?: 'FileUser';
  distributionLists?: Maybe<Array<DistributionList>>;
  isDirect?: Maybe<Scalars['Boolean']['output']>;
  user: User;
};

export type FileUserInput = {
  distributionLists?: InputMaybe<Array<UpdateDistributionListInput>>;
  isDirect?: InputMaybe<Scalars['Boolean']['input']>;
  user: UpdateUserInput;
};

export type FindLatestJobsInput = {
  jobTypes: Array<JobType>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export enum FlagType {
  AdminFinanceFlag = 'AdminFinanceFlag',
  RegistryFlag = 'RegistryFlag',
}

export enum FollowupOptionScope {
  CareEntity = 'CARE_ENTITY',
  Global = 'GLOBAL',
  Tenant = 'TENANT',
}

export type GeneralPolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  eft?: InputMaybe<Scalars['String']['input']>;
  objectType: Scalars['String']['input'];
  resource: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type GenerateStandardRolesInput = {
  dsmIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  tenantId: Scalars['String']['input'];
  types: Array<RoleType>;
};

export type GridView = {
  __typename?: 'GridView';
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  columnModel: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  default: Scalars['Boolean']['output'];
  externalFilters?: Maybe<Scalars['JSON']['output']>;
  filterModel: Scalars['JSON']['output'];
  gridId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  moduleId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  scope: Scope;
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  updatedById: Scalars['String']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type HeartFailure = {
  __typename?: 'HeartFailure';
  admin7DayReadmission?: Maybe<Scalars['String']['output']>;
  admin7DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin14DayReadmission?: Maybe<Scalars['String']['output']>;
  admin14DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin30DayReadmission?: Maybe<Scalars['String']['output']>;
  admin30DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  adminInOutCode?: Maybe<Scalars['String']['output']>;
  adminMatch?: Maybe<Scalars['Float']['output']>;
  admissionUnit?: Maybe<Scalars['String']['output']>;
  admitSourceName?: Maybe<Scalars['String']['output']>;
  admitType?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  bedDays?: Maybe<Scalars['Float']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomePayor?: Maybe<Scalars['String']['output']>;
  cardioMEMS?: Maybe<Scalars['String']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  chfAcute?: Maybe<Scalars['String']['output']>;
  chfAcuteOnChronic?: Maybe<Scalars['String']['output']>;
  chfChronicUspec?: Maybe<Scalars['String']['output']>;
  ckdStageIVorV?: Maybe<Scalars['String']['output']>;
  clinicianAFirstName?: Maybe<Scalars['String']['output']>;
  clinicianALastName?: Maybe<Scalars['String']['output']>;
  clinicianName?: Maybe<Scalars['String']['output']>;
  cmi?: Maybe<Scalars['String']['output']>;
  conditionGrouperL2?: Maybe<Scalars['String']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  diagnosisPOA?: Maybe<Scalars['String']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  dischargeMDName?: Maybe<Scalars['String']['output']>;
  dischargeUnit?: Maybe<Scalars['String']['output']>;
  drgCodeName?: Maybe<Scalars['String']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  elixhauserIndex?: Maybe<Scalars['Int']['output']>;
  encounterId?: Maybe<Scalars['Float']['output']>;
  endStageRenal?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hfdxInOutCode?: Maybe<Scalars['String']['output']>;
  icdDxCodeCategory?: Maybe<Scalars['String']['output']>;
  icuDaysNumerator?: Maybe<Scalars['Int']['output']>;
  inDirectCost?: Maybe<Scalars['Float']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mortality?: Maybe<Scalars['Int']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  multiVisit?: Maybe<Scalars['Int']['output']>;
  netRevenue?: Maybe<Scalars['Float']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  principalDiagnosisICDCodeName?: Maybe<Scalars['String']['output']>;
  principalProcedureICDCodeName?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  procedureMDName?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  rawAdmitSourceName?: Maybe<Scalars['String']['output']>;
  rawDischargeStatus?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  readmissionWithWithout?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
  visitsPerEpisode?: Maybe<Scalars['Int']['output']>;
};

export type HomepageSection = {
  __typename?: 'HomepageSection';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type Icd = {
  __typename?: 'Icd';
  adminMatch?: Maybe<Scalars['Float']['output']>;
  admissionDayOfWeek?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  ageGroup?: Maybe<Scalars['String']['output']>;
  allGenImplants?: Maybe<Scalars['String']['output']>;
  allGenWithVsWithoutLeadExtraction?: Maybe<Scalars['String']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  arrivalDayOfWeek?: Maybe<Scalars['String']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  bsaBucket?: Maybe<Scalars['String']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  clinicianALastName?: Maybe<Scalars['String']['output']>;
  complicationList?: Maybe<Scalars['String']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDayOfWeek?: Maybe<Scalars['String']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  dischargeLocation?: Maybe<Scalars['String']['output']>;
  distanceInMilesBucket?: Maybe<Scalars['String']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  finalDeviceType?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  icdImpMfr?: Maybe<Scalars['String']['output']>;
  icdIndication?: Maybe<Scalars['String']['output']>;
  inOutCode?: Maybe<Scalars['String']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  procedureDayOfWeek?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  procedureType?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  readmissionType?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
  withPPE?: Maybe<Scalars['String']['output']>;
  withRiskFactor?: Maybe<Scalars['String']['output']>;
};

export type IdentityProvider = {
  __typename?: 'IdentityProvider';
  authnContext: Scalars['String']['output'];
  certificate: Scalars['String']['output'];
  certificates?: Maybe<Array<Certificate>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  defaultRoles?: Maybe<Array<Role>>;
  description: Scalars['String']['output'];
  emailAttribute: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  entityId: Scalars['String']['output'];
  entryPoint: Scalars['String']['output'];
  firstNameAttribute: Scalars['String']['output'];
  forceAuthentication: Scalars['Boolean']['output'];
  groupAccessType?: Maybe<IdentityProviderGroupAccessType>;
  id: Scalars['ID']['output'];
  identifierFormat: Scalars['String']['output'];
  lastNameAttribute: Scalars['String']['output'];
  loginRoute: LoginRoute;
  logoutUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  provisionUsers: Scalars['Boolean']['output'];
  securityGroup?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  updateUsers: Scalars['Boolean']['output'];
};

export enum IdentityProviderGroupAccessType {
  Closed = 'CLOSED',
  Open = 'OPEN',
}

export type IdentityProviderInput = {
  authnContext?: InputMaybe<Scalars['String']['input']>;
  certificate: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  defaultRoles?: InputMaybe<Array<UpdateRoleInput>>;
  description: Scalars['String']['input'];
  emailAttribute?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  entityId: Scalars['String']['input'];
  entryPoint: Scalars['String']['input'];
  firstNameAttribute?: InputMaybe<Scalars['String']['input']>;
  forceAuthentication: Scalars['Boolean']['input'];
  groupAccessType?: InputMaybe<IdentityProviderGroupAccessType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  identifierFormat?: InputMaybe<Scalars['String']['input']>;
  lastNameAttribute?: InputMaybe<Scalars['String']['input']>;
  logoutUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  provisionUsers?: InputMaybe<Scalars['Boolean']['input']>;
  securityGroup?: InputMaybe<Scalars['String']['input']>;
  tenant: UpdateTenantInput;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  updateUsers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageConfigInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};

export enum IngestionState {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Success = 'SUCCESS',
}

export type InitiativePolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['String']['input'];
  eft?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  resource: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export enum InputTrackingStatus {
  Complete = 'Complete',
  Failed = 'Failed',
  NotAttempted = 'NotAttempted',
  Partial = 'Partial',
  Queued = 'Queued',
}

export type JiraIssue = {
  __typename?: 'JiraIssue';
  clientDataFile?: Maybe<ClientDataFile>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Jira Issue Key */
  key: Scalars['String']['output'];
  lastEventId?: Maybe<Scalars['String']['output']>;
  month: Month;
  rootTriggerId?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  type: JiraIssueType;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export enum JiraIssueType {
  Bug = 'Bug',
  Epic = 'Epic',
  Story = 'Story',
  Task = 'Task',
}

export type Job = {
  __typename?: 'Job';
  additionalInfo: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  events?: Maybe<Array<JobEvent>>;
  /** Whether this job reports progress as a step tree. */
  hasProgressTree: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** The type of job to be created */
  jobType: JobType;
  parent?: Maybe<Job>;
  parentId?: Maybe<Scalars['String']['output']>;
  presentations?: Maybe<Array<Presentation>>;
  /** Rollup of this job’s step tree. Null when the type has no blueprint, or when the job predates one. */
  progressSummary?: Maybe<JobProgressSummary>;
  /** Jobs that were retried from this job */
  retriedAs?: Maybe<Array<Job>>;
  /** The failed job this job was retried from, if any */
  retriedFromJobId?: Maybe<Scalars['String']['output']>;
  /** The roles for which the job was created */
  roles?: Maybe<Array<Role>>;
  rootJobId: Scalars['String']['output'];
  /** The status of the job */
  status: JobEventType;
  statusTime: Scalars['DateTime']['output'];
  /** The tenants for which the job was created */
  tenants?: Maybe<Array<Tenant>>;
  /** The users for which the job was created */
  users?: Maybe<Array<User>>;
};

export type JobEvent = {
  __typename?: 'JobEvent';
  /** The type of event that occurred */
  eventType: JobEventType;
  id: Scalars['ID']['output'];
  job: Job;
  message?: Maybe<Scalars['ID']['output']>;
  occuredAt: Scalars['DateTime']['output'];
};

export enum JobEventType {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  CompletedWithFailures = 'CompletedWithFailures',
  Created = 'Created',
  Failed = 'Failed',
  PendingCancellation = 'PendingCancellation',
  Retrying = 'Retrying',
  Stalled = 'Stalled',
  Waiting = 'Waiting',
}

export type JobProgressNode = {
  __typename?: 'JobProgressNode';
  childJob?: Maybe<JobProgressTree>;
  childJobId?: Maybe<Scalars['String']['output']>;
  children: Array<JobProgressNode>;
  completedUnits: Scalars['Float']['output'];
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobId: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  order: Scalars['Float']['output'];
  parentStepId?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: JobStepStatus;
  totalUnits: Scalars['Float']['output'];
  type: JobStepType;
  weight: Scalars['Float']['output'];
};

export type JobProgressSummary = {
  __typename?: 'JobProgressSummary';
  jobId: Scalars['String']['output'];
  overallPercent: Scalars['Int']['output'];
  status: JobEventType;
  stepsCompleted: Scalars['Int']['output'];
  stepsTotal: Scalars['Int']['output'];
};

export type JobProgressTree = {
  __typename?: 'JobProgressTree';
  nodes: Array<JobProgressNode>;
  summary: JobProgressSummary;
};

export enum JobStepStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  NotRun = 'NotRun',
  Pending = 'Pending',
  Running = 'Running',
  Skipped = 'Skipped',
}

export enum JobStepType {
  JobLink = 'JobLink',
  Step = 'Step',
}

export enum JobType {
  CalculateExpectedVolume = 'CalculateExpectedVolume',
  EnsureAndAssociateBeats = 'EnsureAndAssociateBeats',
  EnumerateDataflowRunInputs = 'EnumerateDataflowRunInputs',
  EnumerateOePipelineRunInputs = 'EnumerateOePipelineRunInputs',
  GenerateBeats = 'GenerateBeats',
  GenerateReport = 'GenerateReport',
  GenerateStandardRoles = 'GenerateStandardRoles',
  IngestionAndMaskedCleanUp = 'IngestionAndMaskedCleanUp',
  PresentationClone = 'PresentationClone',
  PresentationImagesRefresh = 'PresentationImagesRefresh',
  PresentationSlidesGeneration = 'PresentationSlidesGeneration',
  PresentationSubmissionClone = 'PresentationSubmissionClone',
  ProcessInitiativesNotifications = 'ProcessInitiativesNotifications',
  ProcessSubmissionReminders = 'ProcessSubmissionReminders',
  PublishEvent = 'PublishEvent',
  PushEchoWorkflowSelections = 'PushEchoWorkflowSelections',
  RemoveRoles = 'RemoveRoles',
  RowLevelSecuritySync = 'RowLevelSecuritySync',
  StandardRolesRefresh = 'StandardRolesRefresh',
  TenantOffboardingDestroy = 'TenantOffboardingDestroy',
  TenantOffboardingDryRun = 'TenantOffboardingDryRun',
}

export type KeptSourceInput = {
  /** Manifest entry key */
  key: Scalars['String']['input'];
  /** 1 to 500 characters */
  reason: Scalars['String']['input'];
};

export type Laao = {
  __typename?: 'Laao';
  adminLOSPreOp12HoursBucket?: Maybe<Scalars['String']['output']>;
  adminMatch?: Maybe<Scalars['Float']['output']>;
  admissionDayOfWeek?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  ageGroup?: Maybe<Scalars['String']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  anesthesia?: Maybe<Scalars['String']['output']>;
  arrivalDayOfWeek?: Maybe<Scalars['String']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  bedDays?: Maybe<Scalars['Float']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  bmiGroup?: Maybe<Scalars['String']['output']>;
  bsa?: Maybe<Scalars['Float']['output']>;
  bsaBucket?: Maybe<Scalars['String']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  cha2DS2VASCScore?: Maybe<Scalars['Int']['output']>;
  chadVascDis?: Maybe<Scalars['String']['output']>;
  clinicianACode?: Maybe<Scalars['String']['output']>;
  clinicianAFirstName?: Maybe<Scalars['String']['output']>;
  clinicianALastName?: Maybe<Scalars['String']['output']>;
  clinicianANPI?: Maybe<Scalars['String']['output']>;
  complicationList?: Maybe<Scalars['String']['output']>;
  concomitantProcPerf?: Maybe<Scalars['String']['output']>;
  conditionGroup?: Maybe<Scalars['String']['output']>;
  contributionMarginOutlier?: Maybe<Scalars['Int']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  directCostOutlier?: Maybe<Scalars['Int']['output']>;
  dischargeDayOfWeek?: Maybe<Scalars['String']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  dischargeLocation?: Maybe<Scalars['String']['output']>;
  distanceInMilesBucket?: Maybe<Scalars['String']['output']>;
  drgCode?: Maybe<Scalars['String']['output']>;
  drgName?: Maybe<Scalars['String']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hasBledScore?: Maybe<Scalars['Int']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  laaoAvgContributionMarginNumerator?: Maybe<Scalars['Float']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  multiVisit?: Maybe<Scalars['Int']['output']>;
  netRevenue?: Maybe<Scalars['Float']['output']>;
  netRevenueInclude?: Maybe<Scalars['Int']['output']>;
  netRevenueNumerator?: Maybe<Scalars['Float']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  overall?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  payorPlan?: Maybe<Scalars['String']['output']>;
  procAborted?: Maybe<Scalars['String']['output']>;
  procLocation?: Maybe<Scalars['String']['output']>;
  procedureDayOfWeek?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  procedureGroup?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  rankinScale?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  summaryPayorClass?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
  visitsPerEpisode?: Maybe<Scalars['Int']['output']>;
};

export type LifelineActionError = {
  __typename?: 'LifelineActionError';
  clientDataFile: ClientDataFile;
  clientDataFileId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataframe?: Maybe<DataFrame>;
  dataframeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  rootTriggerId?: Maybe<Scalars['String']['output']>;
  type: LifelineActionType;
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum LifelineActionType {
  Cleanup = 'CLEANUP',
  IgnoreFile = 'IGNORE_FILE',
  IgnoreMaskerWarnings = 'IGNORE_MASKER_WARNINGS',
  IngestionCleanupJob = 'INGESTION_CLEANUP_JOB',
  MaskedCleanupJob = 'MASKED_CLEANUP_JOB',
  OverrideCrosswalkFailure = 'OVERRIDE_CROSSWALK_FAILURE',
  Reprocess = 'REPROCESS',
  TriggerStep = 'TRIGGER_STEP',
  UpdateValidation = 'UPDATE_VALIDATION',
}

export type LifelineEvent = {
  __typename?: 'LifelineEvent';
  beats: Array<Beat>;
  clientDataFileFamilies: Array<ClientDataFileFamily>;
  clientDataFiles: Array<ClientDataFile>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  data?: Maybe<Scalars['JSON']['output']>;
  dataframes: Array<DataFrame>;
  datasetInstances: Array<DatasetInstance>;
  id: Scalars['ID']['output'];
  subject: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
};

export type LoginRoute = {
  __typename?: 'LoginRoute';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  identityProvider: IdentityProvider;
  identityProviderId: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
};

export type LoginRouteInput = {
  domain: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  identityProvider: UpdateIdentityProviderInput;
};

export enum ManifestEntryChange {
  Gone = 'Gone',
  New = 'New',
}

export enum MaskState {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Success = 'SUCCESS',
}

export type MaskedDataframeLocations = {
  __typename?: 'MaskedDataframeLocations';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataframe: DataFrame;
  id: Scalars['ID']['output'];
  location: Scalars['String']['output'];
  locationType: DataframeLocationType;
  name: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
};

export enum MaskerState {
  CompletedWithWarnings = 'COMPLETED_WITH_WARNINGS',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  ManualOverride = 'MANUAL_OVERRIDE',
  Pending = 'PENDING',
  Success = 'SUCCESS',
}

export enum MeasureFamily {
  Cost = 'Cost',
  Los = 'LOS',
  Readmission = 'Readmission',
}

export enum MeasureInputDataType {
  Admin = 'Admin',
  AdminAndCost = 'AdminAndCost',
  Clinical = 'Clinical',
  Cost = 'Cost',
}

export type MeasureLink = {
  __typename?: 'MeasureLink';
  id: Scalars['ID']['output'];
  link: MeasureLinkType;
  objectId: Scalars['Float']['output'];
  objectMeasure: MeasureMetadata;
  processMeasure: Scalars['Boolean']['output'];
  subjectId: Scalars['Float']['output'];
  subjectMeasure: MeasureMetadata;
};

export enum MeasureLinkType {
  Balances = 'Balances',
  Influences = 'Influences',
  RelatesTo = 'RelatesTo',
}

export type MeasureMetadata = {
  __typename?: 'MeasureMetadata';
  accessCategory: AccessCategory;
  adjustment?: Maybe<Array<Scalars['String']['output']>>;
  aggregationFn?: Maybe<Array<Scalars['String']['output']>>;
  aggregationType?: Maybe<SummaryCalculationType>;
  annualMeasureBaseId?: Maybe<Scalars['String']['output']>;
  benchmarkExtraction: Scalars['Boolean']['output'];
  children?: Maybe<Array<MeasureMetadata>>;
  commonMeasureDisplayName: Scalars['String']['output'];
  commonMeasureQualifying?: Maybe<Scalars['Boolean']['output']>;
  costComponentMeasure?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  dataTypeRequired?: Maybe<MeasureInputDataType>;
  denominatorColumnName?: Maybe<Scalars['String']['output']>;
  denominatorLegacyDescription?: Maybe<Scalars['String']['output']>;
  denominatorPipelineElement?: Maybe<PipelineElement>;
  denominatorPipelineElementId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  developedOn?: Maybe<Scalars['DateTime']['output']>;
  dimensionSets?: Maybe<Array<DimensionSet>>;
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModuleId: Scalars['Int']['output'];
  excludedCohortIds?: Maybe<Array<Scalars['Float']['output']>>;
  family?: Maybe<MeasureFamily>;
  hideFromReports: Scalars['Boolean']['output'];
  higherIsBetter?: Maybe<Scalars['Boolean']['output']>;
  history: Array<MeasureMetadataHistory>;
  id: Scalars['Int']['output'];
  includeColumnName?: Maybe<Scalars['String']['output']>;
  includePipelineElement?: Maybe<PipelineElement>;
  includePipelineElementId?: Maybe<Scalars['String']['output']>;
  isBenchmark?: Maybe<Scalars['Boolean']['output']>;
  losROIQualifying?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  ncdrMeasureName?: Maybe<Scalars['String']['output']>;
  numeratorColumnName?: Maybe<Scalars['String']['output']>;
  numeratorLegacyDescription?: Maybe<Scalars['String']['output']>;
  numeratorPipelineElement?: Maybe<PipelineElement>;
  numeratorPipelineElementId?: Maybe<Scalars['String']['output']>;
  numeratorUnit: Scalars['String']['output'];
  objectiveTemplates?: Maybe<Array<ObjectiveTemplate>>;
  objectives?: Maybe<Array<Objective>>;
  objects?: Maybe<Array<MeasureLink>>;
  opportunityType: Array<OpportunityType>;
  outcomeType?: Maybe<MeasureOutcomeType>;
  parent?: Maybe<MeasureMetadata>;
  parentId?: Maybe<Scalars['ID']['output']>;
  publicationSource?: Maybe<Array<PublicationSource>>;
  rareEvent: Scalars['Boolean']['output'];
  registryMeasureId?: Maybe<Scalars['Int']['output']>;
  reportRowId?: Maybe<Scalars['Int']['output']>;
  requirements?: Maybe<Scalars['String']['output']>;
  riskAdjusted: Scalars['Boolean']['output'];
  riskMetric?: Maybe<RiskMetric>;
  riskMetricId?: Maybe<Scalars['String']['output']>;
  riskMetricPipelineElement?: Maybe<PipelineElement>;
  riskMetricPipelineElementId?: Maybe<Scalars['String']['output']>;
  roiCalcType?: Maybe<SummaryCalculationType>;
  roiMetrics?: Maybe<Array<RoiMetric>>;
  secondaryFamily?: Maybe<MeasureFamily>;
  strategyTemplates?: Maybe<Array<ObjectiveStrategyTemplate>>;
  subjects?: Maybe<Array<MeasureLink>>;
  summaryCohortId?: Maybe<Scalars['Float']['output']>;
  summaryInitiativeMeasure: Scalars['Boolean']['output'];
  tableName?: Maybe<Scalars['String']['output']>;
  tableauViews?: Maybe<Array<MeasureTableauView>>;
  testCapture?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
  validationSource?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  volumeMeasure?: Maybe<Scalars['Boolean']['output']>;
};

export type MeasureMetadataHistory = {
  __typename?: 'MeasureMetadataHistory';
  accessCategory: AccessCategory;
  adjustment?: Maybe<Array<Scalars['String']['output']>>;
  aggregationFn?: Maybe<Array<Scalars['String']['output']>>;
  aggregationType?: Maybe<SummaryCalculationType>;
  commonMeasureDisplayName: Scalars['String']['output'];
  commonMeasureQualifying?: Maybe<Scalars['Boolean']['output']>;
  costComponentMeasure?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataTypeRequired?: Maybe<MeasureInputDataType>;
  denominatorColumnName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dimensionSets?: Maybe<Scalars['JSON']['output']>;
  diseaseStateModule: Scalars['JSON']['output'];
  excludedCohortIds?: Maybe<Array<Scalars['Int']['output']>>;
  family?: Maybe<MeasureFamily>;
  higherIsBetter?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  includeColumnName?: Maybe<Scalars['String']['output']>;
  isBenchmark?: Maybe<Scalars['Boolean']['output']>;
  losROIQualifying?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  ncdrMeasureName?: Maybe<Scalars['String']['output']>;
  numeratorColumnName?: Maybe<Scalars['String']['output']>;
  numeratorUnit?: Maybe<Scalars['String']['output']>;
  opportunityType: Array<OpportunityType>;
  outcomeType?: Maybe<MeasureOutcomeType>;
  publicationSource?: Maybe<Array<PublicationSource>>;
  rareEvent: Scalars['Boolean']['output'];
  riskMetric?: Maybe<RiskMetric>;
  riskMetricId?: Maybe<Scalars['String']['output']>;
  roiCalcType?: Maybe<SummaryCalculationType>;
  roiMetrics?: Maybe<Scalars['JSON']['output']>;
  secondaryFamily?: Maybe<MeasureFamily>;
  summaryCohortId?: Maybe<Scalars['Float']['output']>;
  summaryInitiativeMeasure: Scalars['Boolean']['output'];
  tableName?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  version?: Maybe<Scalars['String']['output']>;
};

export enum MeasureOutcomeType {
  Binary = 'Binary',
  Continuous = 'Continuous',
  Oer = 'Oer',
}

export type MeasureTableauView = {
  __typename?: 'MeasureTableauView';
  id: Scalars['Int']['output'];
  isPrimary: Scalars['Boolean']['output'];
  measure: MeasureMetadata;
  measureId: Scalars['Int']['output'];
  tableauView: TableauView;
  tableauViewId: Scalars['Int']['output'];
};

export type Mitraclip = {
  __typename?: 'Mitraclip';
  ArrivalDayOfWeek?: Maybe<Scalars['String']['output']>;
  adminMatch?: Maybe<Scalars['Float']['output']>;
  admissionDayOfWeek?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  ageGroup?: Maybe<Scalars['String']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  bmiGroup?: Maybe<Scalars['String']['output']>;
  bsaBucket?: Maybe<Scalars['String']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  clinicianALastName?: Maybe<Scalars['String']['output']>;
  clinicianBLastName?: Maybe<Scalars['String']['output']>;
  complicationList?: Maybe<Scalars['String']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDayOfWeek?: Maybe<Scalars['String']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  dischargeLocation?: Maybe<Scalars['String']['output']>;
  distanceInMilesBucket?: Maybe<Scalars['String']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  prOthCar?: Maybe<Scalars['String']['output']>;
  predictedRiskOfMortality?: Maybe<Scalars['String']['output']>;
  procedureDayOfWeek?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  procedureGroup?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  registryReadmissionReason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tvtLocation?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
};

export enum Month {
  April = 'April',
  August = 'August',
  December = 'December',
  February = 'February',
  January = 'January',
  July = 'July',
  June = 'June',
  March = 'March',
  May = 'May',
  November = 'November',
  October = 'October',
  September = 'September',
}

export enum MovedToProdStatus {
  Failed = 'Failed',
  InProgress = 'InProgress',
  Pending = 'Pending',
  Success = 'Success',
}

export type MultiProcTable = {
  __typename?: 'MultiProcTable';
  developmentDimensions?: Maybe<Array<DevelopmentDimension>>;
  dimensions?: Maybe<Array<Dimension>>;
  diseaseStateModule: DiseaseStateModule;
  id: Scalars['ID']['output'];
  tableName: Scalars['String']['output'];
};

export type MultiProcTableDeletionActionInput = {
  multiProcTableId: Scalars['ID']['input'];
  replacementMultiProcTableId?: InputMaybe<Scalars['ID']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** this mutation is to add the view to user-favorites for the tenant */
  addFavorite: Scalars['Boolean']['output'];
  addFieldDatasetVersions: Scalars['Boolean']['output'];
  /** a data submitter should be added to GoAnywhere Users group while a 2FA user should be added to MFA group */
  addToAdGroup: Scalars['Boolean']['output'];
  approveSmeReviewForDimension: Scalars['Boolean']['output'];
  approveSmeReviewForMeasure: Scalars['Boolean']['output'];
  approveSmeReviewForRoiMetric: Scalars['Boolean']['output'];
  approveTenantOffboarding: TenantOffboardingJob;
  archiveDataset: Dataset;
  archiveDiseaseStateModule: DiseaseStateModule;
  archiveObjective: Scalars['Boolean']['output'];
  archiveObjectiveStrategy: Scalars['Boolean']['output'];
  archiveObjectiveStrategyTemplate: Scalars['Boolean']['output'];
  archiveObjectiveTemplate: Scalars['Boolean']['output'];
  assignTenantToBiomeUsers: Scalars['Boolean']['output'];
  attachFloatingStrategies: Scalars['Boolean']['output'];
  bulkGenerateSlides: Scalars['Boolean']['output'];
  cancelDevelopmentDimension: DevelopmentDimension;
  cancelDevelopmentMeasure: DevelopmentMeasure;
  cancelDevelopmentRoiMetric: DevelopmentRoiMetric;
  cancelPresentationJob: Scalars['Boolean']['output'];
  cancelTenantOffboarding: TenantOffboardingJob;
  /** Change user password */
  changePassword: Scalars['Boolean']['output'];
  cloneGridView: GridView;
  clonePresentation: Scalars['Boolean']['output'];
  clonePresentationForSubmission: Scalars['Boolean']['output'];
  convertToShortLinks: Scalars['Boolean']['output'];
  createActivityLog: Scalars['Boolean']['output'];
  /** Deletes existing Admin policies for a role and re-creates as per requested in this mutation */
  createAdminPolicies: Scalars['Boolean']['output'];
  createAggregateSubmission: Array<Submission>;
  createApplication: Application;
  createBiomeDictionary: TranslatorConfig;
  createBookmark: Bookmark;
  /** Converts a given bookmark url to a shorter version. */
  createBookmarkShortUrl: Scalars['String']['output'];
  createBulkCareEntities: Array<CareEntity>;
  createBulkDeadlines: Array<Deadline>;
  createCareEntity: CareEntity;
  /** Deletes existing Case policies for a role and re-creates as per requested in this mutation */
  createCasePolicies: Scalars['Boolean']['output'];
  createClinicalProgram: ClinicalProgram;
  /** Deletes existing Clinician policies for a role and re-creates as per requested in this mutation */
  createClinicianPolicies: Scalars['Boolean']['output'];
  createComment: Comment;
  createCommentReaction: CommentReaction;
  /** Deletes existing Dashboard policies for a role and re-creates as per requested in this mutation */
  createDashboardPolicies: Scalars['Boolean']['output'];
  createDataset: Dataset;
  createDatasetVersion: DatasetVersion;
  createDeadline: Deadline;
  createDevelopmentDimension: DevelopmentDimension;
  createDevelopmentMeasure: DevelopmentMeasure;
  createDevelopmentRoiMetric: DevelopmentRoiMetric;
  createDictionary: Dictionary;
  createDimension: Dimension;
  createDiseaseStateModule: DiseaseStateModule;
  createDistributionList: DistributionList;
  /** Deletes existing DiseaseStateModule policies for a role and re-creates as per requested in this mutation */
  createDsmPolicies: Scalars['Boolean']['output'];
  createEchoFindingFollowup: EchoFindingFollowup;
  createEchoFollowupOption: EchoFindingFollowupOption;
  createEchoMessageTemplate: EchoMessageTemplate;
  /** Deletes existing Entity policies for a role and re-creates as per requested in this mutation */
  createEntityPolicies: Scalars['Boolean']['output'];
  /** Deletes existing File policies for a role/user and re-creates as per requested in this mutation */
  createFilePolicies: Scalars['Boolean']['output'];
  /** Deletes existing General policies for a role and re-creates as per requested in this mutation */
  createGeneralPolicies: Scalars['Boolean']['output'];
  createGridView: GridView;
  createHomepageSection: HomepageSection;
  createIdentityProvider: IdentityProvider;
  /** Deletes existing Initiative policies for a role and re-creates as per requested in this mutation */
  createInitiativePolicies: Scalars['Boolean']['output'];
  createLoginRoutes: Array<LoginRoute>;
  createMeasureMetadata: MeasureMetadata;
  createNotification: Notification;
  createObjective: Objective;
  createObjectiveStrategy: ObjectiveStrategy;
  createObjectiveStrategyTemplate: ObjectiveStrategyTemplate;
  createObjectiveTemplate: ObjectiveTemplate;
  /** creates new Organizational Units in AD as sub ou of BIOME-CLIENTS */
  createOrganizationalUnit: Scalars['Boolean']['output'];
  /** Deletes existing PatientList policies for a role and re-creates as per requested in this mutation */
  createPatientListPolicies: Scalars['Boolean']['output'];
  createPerformanceManagerStrategy: ObjectiveStrategy;
  createPresentation: Presentation;
  createRecentTableauView: RecentTableauView;
  createReport: Report;
  createReportFromGridView: Scalars['Boolean']['output'];
  createRiskAuditTrail: RiskAuditTrail;
  createRoiMetric: RoiMetric;
  createRole: Role;
  createSlide: Slide;
  /** Deletes existing Strategy Board policies for a role and re-creates as per requested in this mutation */
  createStrategyBoardPolicies: Scalars['Boolean']['output'];
  createSubmission: Submission;
  createTableauView: TableauView;
  createTenant: Tenant;
  createThread: Thread;
  createUser: User;
  /** Deletes existing user policies for a role and re-creates as per requested in this mutation */
  createUserPolicies: Scalars['Boolean']['output'];
  createWorkbook: Workbook;
  createWorkbookGroup: WorkbookGroup;
  deletePresentation: Scalars['Boolean']['output'];
  deleteReport: Scalars['Boolean']['output'];
  deleteSlides: Scalars['Boolean']['output'];
  /** Queues the deletion of an approved (or failed) request, except the kept sources. */
  deleteTenantOffboarding: TenantOffboardingJob;
  downloadFile: File;
  downloadStrategyAttachment: File;
  enableUser: Scalars['Boolean']['output'];
  generateStandardRoles: Scalars['Boolean']['output'];
  logContentAccess: Scalars['Boolean']['output'];
  logPublicFileAccess: Scalars['Boolean']['output'];
  markAsRead: Scalars['Boolean']['output'];
  parseAndSaveCertificate: Certificate;
  rediscoverTenantOffboarding: TenantOffboardingJob;
  refreshPresentationImages: Scalars['Boolean']['output'];
  /**
   * Initiates a job to remove and recreate policies for the given standard roles.
   *       This is useful when the policy rules change and all existing standard roles need to be realigned.
   */
  refreshStandardRoles: Scalars['Boolean']['output'];
  rejectSmeReviewForDimension: Scalars['Boolean']['output'];
  rejectSmeReviewForMeasure: Scalars['Boolean']['output'];
  rejectSmeReviewForRoiMetric: Scalars['Boolean']['output'];
  rejectTenantOffboarding: TenantOffboardingJob;
  /** Reloads cached enforcer policies */
  reloadCachedPolicies: Scalars['Boolean']['output'];
  removeAdUser: Scalars['Boolean']['output'];
  /** Deletes the admin policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeAdminPolicies: Scalars['Boolean']['output'];
  removeApplication: Scalars['Boolean']['output'];
  removeBiomeDictionary: TranslatorConfig;
  removeBookmark: Scalars['Boolean']['output'];
  removeCareEntity: Scalars['Boolean']['output'];
  /** Deletes the Case policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeCasePolicies: Scalars['Boolean']['output'];
  removeClinicalProgram: Scalars['Boolean']['output'];
  /** Deletes the Clinician policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeClinicianPolicies: Scalars['Boolean']['output'];
  removeComment: Scalars['Boolean']['output'];
  removeCommentReaction: Scalars['Boolean']['output'];
  /** Deletes the Dashboard policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeDashboardPolicies: Scalars['Boolean']['output'];
  removeDataset: Scalars['Boolean']['output'];
  removeDatasetVersion: Scalars['Boolean']['output'];
  removeDeadline: Scalars['Boolean']['output'];
  removeDictionary: Scalars['Boolean']['output'];
  removeDimension: Scalars['Boolean']['output'];
  removeDiseaseStateModule: Scalars['Boolean']['output'];
  removeDistributionList: Scalars['Boolean']['output'];
  /** Deletes the DiseaseStateModule policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeDsmPolicies: Scalars['Boolean']['output'];
  /** Deletes the Entity policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeEntityPolicies: Scalars['Boolean']['output'];
  /** this mutation is to remove the view from user-favorites for the tenant */
  removeFavorite: Scalars['Boolean']['output'];
  removeFieldDatasetVersions: Scalars['Boolean']['output'];
  removeFile: Scalars['Boolean']['output'];
  /** Deletes the file policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeFilePolicies: Scalars['Boolean']['output'];
  /** Deletes the General policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeGeneralEntityPolicies: Scalars['Boolean']['output'];
  removeGridView: Scalars['Boolean']['output'];
  removeHomepageSection: Scalars['Boolean']['output'];
  removeIdentityProvider: Scalars['Boolean']['output'];
  /** Deletes the Initiative policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeInitiativePolicies: Scalars['Boolean']['output'];
  removeLoginRoute: Scalars['Boolean']['output'];
  removeMeasureMetaddata: Scalars['Boolean']['output'];
  removeNotification: Scalars['Boolean']['output'];
  removeObjective: Scalars['Boolean']['output'];
  removeObjectiveStrategy: Scalars['Boolean']['output'];
  removeObjectiveStrategyTemplate: Scalars['Boolean']['output'];
  removeObjectiveTemplate: Scalars['Boolean']['output'];
  /** Deletes the PatientList policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removePatientListPolicies: Scalars['Boolean']['output'];
  removePublicFile: Scalars['Boolean']['output'];
  removeRoiMetric: Scalars['Boolean']['output'];
  removeRoles: Scalars['Boolean']['output'];
  removeStrategyAttachment: Scalars['Boolean']['output'];
  /** Deletes the Strategy Board policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeStrategyBoardPolicies: Scalars['Boolean']['output'];
  removeSubmission: Scalars['Boolean']['output'];
  removeTableauView: Scalars['Boolean']['output'];
  removeThread: Scalars['Boolean']['output'];
  removeUser: Scalars['Boolean']['output'];
  /** Deletes the user policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeUserPolicies: Scalars['Boolean']['output'];
  removeWorkbook: Scalars['Boolean']['output'];
  removeWorkbookGroup: Scalars['Boolean']['output'];
  requestDimensionUpdate: DevelopmentDimension;
  requestMeasureUpdate: DevelopmentMeasure;
  requestRoiMetricUpdate: DevelopmentRoiMetric;
  requestSmeReviewForDimension: Scalars['Boolean']['output'];
  requestSmeReviewForMeasure: Scalars['Boolean']['output'];
  requestSmeReviewForRoiMetric: Scalars['Boolean']['output'];
  requestTenantOffboarding: TenantOffboardingJob;
  /** Resets user password and sends onboarding email */
  resendOnboardingEmail: Scalars['Boolean']['output'];
  /** Initiates a password reset request for the user and sends a reset password link to user's email. */
  resetPassword: Scalars['Boolean']['output'];
  restorePresentation: Scalars['Boolean']['output'];
  /** Retries a failed job, returning the new job id. */
  retryJob: Scalars['String']['output'];
  retryTenantOffboardingDiscovery: TenantOffboardingJob;
  revokeToken: Scalars['Boolean']['output'];
  runReport: Scalars['Boolean']['output'];
  sendInquiry: SendInquiryResponse;
  sendMessage: Array<Scalars['Boolean']['output']>;
  setHomepage: Scalars['Boolean']['output'];
  shareFilesWithDistributionLists: Scalars['Boolean']['output'];
  shareFilesWithUsers: Scalars['Boolean']['output'];
  softDeleteCareEntity: Scalars['Boolean']['output'];
  softDeletePresentation: Scalars['Boolean']['output'];
  softDeleteUser: Scalars['Boolean']['output'];
  /** Starts the caller's approval discovery, or returns the one they already have running. */
  startTenantOffboardingApprovalDiscovery: TenantOffboardingDiscovery;
  syncRoleRowLevelSecurity: Scalars['Boolean']['output'];
  syncTenantRowLevelSecurity: Scalars['Boolean']['output'];
  syncUserRowLevelSecurity: Scalars['Boolean']['output'];
  unarchiveDataset: Dataset;
  unarchiveDiseaseStateModule: DiseaseStateModule;
  unlinkObjectiveStrategy: Scalars['Boolean']['output'];
  /** Unlock user */
  unlockUser: Scalars['Boolean']['output'];
  updateAdUser: Scalars['Boolean']['output'];
  updateApplication: Application;
  updateBiomeDictionary: TranslatorConfig;
  updateBookmark: Bookmark;
  updateCareEntity: CareEntity;
  updateClinicalProgram: ClinicalProgram;
  updateComment: Comment;
  updateDataset: Dataset;
  updateDatasetVersion: Scalars['Boolean']['output'];
  updateDeadline: Scalars['Boolean']['output'];
  updateDevelopmentDimension: DevelopmentDimension;
  updateDevelopmentMeasure: DevelopmentMeasure;
  updateDevelopmentRoiMetric: DevelopmentRoiMetric;
  updateDictionary: Dictionary;
  updateDimension: Dimension;
  updateDiseaseStateModule: DiseaseStateModule;
  updateDistributionList: DistributionList;
  updateEchoFollowupOptions: Array<EchoFindingFollowupOption>;
  updateEchoMessageTemplate: EchoMessageTemplate;
  updateEchoReferringProvider: EchoReferringProvider;
  updateGridView: GridView;
  updateHomepageSections: Array<HomepageSection>;
  updateIdentityProvider: IdentityProvider;
  updateLoginRoute: LoginRoute;
  updateMeasureMetadata: MeasureMetadata;
  updateNotification: Scalars['Boolean']['output'];
  updateObjective: Objective;
  updateObjectiveStrategy: ObjectiveStrategy;
  updateObjectiveStrategyTemplate: ObjectiveStrategyTemplate;
  updateObjectiveTemplate: ObjectiveTemplate;
  updatePresentation: Scalars['Boolean']['output'];
  updateReport: Report;
  updateRoiMetric: RoiMetric;
  updateRole: Role;
  updateSlides: Scalars['Boolean']['output'];
  updateSubmission: Array<Submission>;
  updateTableauView: Scalars['Boolean']['output'];
  updateTenant: Tenant;
  updateThread: Thread;
  updateUser: User;
  updateUserAccount: User;
  updateWorkbook: Workbook;
  updateWorkbookGroup: WorkbookGroup;
};

export type MutationAddFavoriteArgs = {
  tenantId: Scalars['String']['input'];
  viewId: Scalars['Float']['input'];
};

export type MutationAddFieldDatasetVersionsArgs = {
  datasetVersionFieldInputs: Array<CreateDatasetVersionFieldInput>;
};

export type MutationAddToAdGroupArgs = {
  groupName: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type MutationApproveSmeReviewForDimensionArgs = {
  dimensionId: Scalars['Int']['input'];
};

export type MutationApproveSmeReviewForMeasureArgs = {
  measureId: Scalars['Int']['input'];
};

export type MutationApproveSmeReviewForRoiMetricArgs = {
  roiMetricId: Scalars['String']['input'];
};

export type MutationApproveTenantOffboardingArgs = {
  discoveryId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

export type MutationArchiveDatasetArgs = {
  id: Scalars['Int']['input'];
};

export type MutationArchiveDiseaseStateModuleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationArchiveObjectiveArgs = {
  id: Scalars['ID']['input'];
};

export type MutationArchiveObjectiveStrategyArgs = {
  id: Scalars['ID']['input'];
};

export type MutationArchiveObjectiveStrategyTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationArchiveObjectiveTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationAssignTenantToBiomeUsersArgs = {
  biomeUserRegion?: InputMaybe<BiomeUserRegion>;
  tenantId: Scalars['String']['input'];
};

export type MutationAttachFloatingStrategiesArgs = {
  cohort: Scalars['Float']['input'];
  configuringCareEntity: Scalars['String']['input'];
  initiativeId: Scalars['Float']['input'];
  measure: Scalars['Float']['input'];
  registry: Scalars['String']['input'];
};

export type MutationBulkGenerateSlidesArgs = {
  presentationId: Scalars['String']['input'];
  slidesConfig: Array<BulkSlidesInput>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCancelDevelopmentDimensionArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  dimensionId: Scalars['Int']['input'];
};

export type MutationCancelDevelopmentMeasureArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  measureId: Scalars['Int']['input'];
};

export type MutationCancelDevelopmentRoiMetricArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  roiMetricId: Scalars['String']['input'];
};

export type MutationCancelPresentationJobArgs = {
  jobId: Scalars['String']['input'];
};

export type MutationCancelTenantOffboardingArgs = {
  id: Scalars['String']['input'];
};

export type MutationChangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type MutationCloneGridViewArgs = {
  id: Scalars['String']['input'];
};

export type MutationClonePresentationArgs = {
  inputs: Array<PresentationCloneInput>;
  name: Scalars['String']['input'];
  presentationId: Scalars['String']['input'];
  procedure?: InputMaybe<Array<ProcedureInput>>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  useCompleteData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationClonePresentationForSubmissionArgs = {
  dashboardEntityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  input: CreatePresentationSubmissionInput;
  useCompleteData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateActivityLogArgs = {
  createActivityLogInput: CreateActivityLogInput;
};

export type MutationCreateAdminPoliciesArgs = {
  policyInputs: Array<AdminPolicyInput>;
};

export type MutationCreateAggregateSubmissionArgs = {
  createAggregateSubmissionInput: CreateAggregateSubmissionsInput;
};

export type MutationCreateApplicationArgs = {
  createApplicationInput: CreateApplicationInput;
};

export type MutationCreateBiomeDictionaryArgs = {
  createBiomeDictionaryInput: CreateTranslatorConfigInput;
};

export type MutationCreateBookmarkArgs = {
  createBookmarkInput: CreateBookmarkInput;
};

export type MutationCreateBookmarkShortUrlArgs = {
  originalUrl: Scalars['String']['input'];
};

export type MutationCreateBulkCareEntitiesArgs = {
  inputs: Array<CreateBulkCareEntityInput>;
};

export type MutationCreateBulkDeadlinesArgs = {
  createDeadlineInputs: Array<CreateDeadlineInput>;
};

export type MutationCreateCareEntityArgs = {
  createCareEntityInput: CreateCareEntityInput;
};

export type MutationCreateCasePoliciesArgs = {
  policyInputs: Array<CasePolicyInput>;
};

export type MutationCreateClinicalProgramArgs = {
  createClinicalProgramInput: CreateClinicalProgramInput;
};

export type MutationCreateClinicianPoliciesArgs = {
  policyInputs: Array<ClinicianPolicyInput>;
};

export type MutationCreateCommentArgs = {
  createCommentInput: CreateCommentInput;
};

export type MutationCreateCommentReactionArgs = {
  createCommentReactionInput: CreateCommentReactionInput;
};

export type MutationCreateDashboardPoliciesArgs = {
  policyInputs: Array<DashboardPolicyInput>;
};

export type MutationCreateDatasetArgs = {
  createDatasetInput: CreateDatasetInput;
};

export type MutationCreateDatasetVersionArgs = {
  createDatasetVersionInput: CreateDatasetVersionInput;
};

export type MutationCreateDeadlineArgs = {
  createDeadlineInput: CreateDeadlineInput;
};

export type MutationCreateDevelopmentDimensionArgs = {
  input: CreateDevelopmentDimensionInput;
};

export type MutationCreateDevelopmentMeasureArgs = {
  input: CreateDevelopmentMeasureInput;
};

export type MutationCreateDevelopmentRoiMetricArgs = {
  input: CreateDevelopmentRoiMetricInput;
};

export type MutationCreateDictionaryArgs = {
  createDictionaryInput: CreateDictionaryInput;
};

export type MutationCreateDimensionArgs = {
  createDimensionInput: CreateDimensionInput;
};

export type MutationCreateDiseaseStateModuleArgs = {
  createDiseaseStateModuleInput: CreateDiseaseStateModuleInput;
};

export type MutationCreateDistributionListArgs = {
  createDistributionListInput: CreateDistributionListInput;
};

export type MutationCreateDsmPoliciesArgs = {
  policyInputs: Array<DsmPolicyInput>;
};

export type MutationCreateEchoFindingFollowupArgs = {
  input: EchoFindingFollowupInput;
};

export type MutationCreateEchoFollowupOptionArgs = {
  input: EchoFollowupOptionInput;
};

export type MutationCreateEchoMessageTemplateArgs = {
  input: EchoMessageTemplateInput;
};

export type MutationCreateEntityPoliciesArgs = {
  policyInputs: Array<EntityPolicyInput>;
};

export type MutationCreateFilePoliciesArgs = {
  policyInputs: Array<FilePolicyInput>;
};

export type MutationCreateGeneralPoliciesArgs = {
  policyInputs: Array<GeneralPolicyInput>;
};

export type MutationCreateGridViewArgs = {
  createGridViewInput: CreateGridViewInput;
};

export type MutationCreateHomepageSectionArgs = {
  createHomepageSectionInput: CreateHomepageSectionInput;
};

export type MutationCreateIdentityProviderArgs = {
  identityProviderInput: IdentityProviderInput;
};

export type MutationCreateInitiativePoliciesArgs = {
  policyInputs: Array<InitiativePolicyInput>;
};

export type MutationCreateLoginRoutesArgs = {
  loginInputs: Array<LoginRouteInput>;
};

export type MutationCreateMeasureMetadataArgs = {
  createMeasureMetadataInput: CreateMeasureMetadataInput;
};

export type MutationCreateNotificationArgs = {
  createNotificationInput: CreateNotificationInput;
};

export type MutationCreateObjectiveArgs = {
  createObjectiveInput: CreateObjectiveInput;
};

export type MutationCreateObjectiveStrategyArgs = {
  createObjectiveStrategyInput: CreateObjectiveStrategyInput;
};

export type MutationCreateObjectiveStrategyTemplateArgs = {
  createObjectiveStrategyTemplateInput: CreateObjectiveStrategyTemplateInput;
};

export type MutationCreateObjectiveTemplateArgs = {
  createObjectiveTemplateInput: CreateObjectiveTemplateInput;
};

export type MutationCreateOrganizationalUnitArgs = {
  ouName: Scalars['String']['input'];
};

export type MutationCreatePatientListPoliciesArgs = {
  policyInputs: Array<PatientListPolicyInput>;
};

export type MutationCreatePerformanceManagerStrategyArgs = {
  input: CreatePerformanceManagerStrategyInput;
};

export type MutationCreatePresentationArgs = {
  input: CreatePresentationInput;
};

export type MutationCreateRecentTableauViewArgs = {
  createRecentTableauViewInput: CreateRecentTableauViewInput;
};

export type MutationCreateReportArgs = {
  reportInput: ReportInput;
  startExport: Scalars['Boolean']['input'];
};

export type MutationCreateReportFromGridViewArgs = {
  gridViewId: Scalars['String']['input'];
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateRiskAuditTrailArgs = {
  input: RiskAuditTrailInput;
};

export type MutationCreateRoiMetricArgs = {
  createRoiMetricInput: CreateRoiMetricInput;
};

export type MutationCreateRoleArgs = {
  createRoleInput: CreateRoleInput;
};

export type MutationCreateSlideArgs = {
  input: CreateSlideInput;
};

export type MutationCreateStrategyBoardPoliciesArgs = {
  policyInputs: Array<StrategyBoardPolicyInput>;
};

export type MutationCreateSubmissionArgs = {
  createSubmissionInput: CreateSubmissionInput;
};

export type MutationCreateTableauViewArgs = {
  createViewInput: CreateTableauViewInput;
};

export type MutationCreateTenantArgs = {
  createTenantInput: CreateTenantInput;
};

export type MutationCreateThreadArgs = {
  createThreadInput: CreateThreadInput;
};

export type MutationCreateUserArgs = {
  createUserInput: CreateUserInput;
};

export type MutationCreateUserPoliciesArgs = {
  policyInputs: Array<UserPolicyInput>;
};

export type MutationCreateWorkbookArgs = {
  createWorkbookInput: CreateWorkbookInput;
};

export type MutationCreateWorkbookGroupArgs = {
  createGroupInput: CreateWorkbookGroupInput;
};

export type MutationDeletePresentationArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteReportArgs = {
  reportId: Scalars['String']['input'];
};

export type MutationDeleteSlidesArgs = {
  ids: Array<Scalars['String']['input']>;
  presentationId: Scalars['String']['input'];
};

export type MutationDeleteTenantOffboardingArgs = {
  input: DeleteTenantOffboardingInput;
};

export type MutationDownloadFileArgs = {
  id: Scalars['String']['input'];
};

export type MutationDownloadStrategyAttachmentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationEnableUserArgs = {
  alternativeUserId: Scalars['String']['input'];
  enableUserInput: EnableUserInput;
};

export type MutationGenerateStandardRolesArgs = {
  input: GenerateStandardRolesInput;
};

export type MutationLogContentAccessArgs = {
  fileName: Scalars['String']['input'];
  source: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type MutationLogPublicFileAccessArgs = {
  fileId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type MutationMarkAsReadArgs = {
  messageIds: Array<Scalars['String']['input']>;
};

export type MutationParseAndSaveCertificateArgs = {
  idpId: Scalars['String']['input'];
};

export type MutationRediscoverTenantOffboardingArgs = {
  id: Scalars['String']['input'];
};

export type MutationRefreshPresentationImagesArgs = {
  missingSlidesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  presentationId: Scalars['String']['input'];
  slideIds?: InputMaybe<Array<Scalars['String']['input']>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  useCompleteData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationRefreshStandardRolesArgs = {
  roleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  roleTypes?: InputMaybe<Array<RoleType>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRejectSmeReviewForDimensionArgs = {
  comment: Scalars['String']['input'];
  dimensionId: Scalars['Int']['input'];
};

export type MutationRejectSmeReviewForMeasureArgs = {
  comment: Scalars['String']['input'];
  measureId: Scalars['Int']['input'];
};

export type MutationRejectSmeReviewForRoiMetricArgs = {
  comment: Scalars['String']['input'];
  roiMetricId: Scalars['String']['input'];
};

export type MutationRejectTenantOffboardingArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type MutationRemoveAdUserArgs = {
  username: Scalars['String']['input'];
};

export type MutationRemoveAdminPoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<AdminPolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveApplicationArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemoveBiomeDictionaryArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemoveBookmarkArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemoveCareEntityArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemoveCasePoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<CasePolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveClinicalProgramArgs = {
  id: Scalars['Int']['input'];
};

export type MutationRemoveClinicianPoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<ClinicianPolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveCommentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemoveCommentReactionArgs = {
  commentId: Scalars['String']['input'];
};

export type MutationRemoveDashboardPoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<DashboardPolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveDatasetArgs = {
  id: Scalars['Int']['input'];
};

export type MutationRemoveDatasetVersionArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemoveDeadlineArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemoveDictionaryArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemoveDimensionArgs = {
  id: Scalars['Int']['input'];
};

export type MutationRemoveDiseaseStateModuleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemoveDistributionListArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemoveDsmPoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<DsmPolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveEntityPoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<EntityPolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveFavoriteArgs = {
  tenantId: Scalars['String']['input'];
  viewId: Scalars['Float']['input'];
};

export type MutationRemoveFieldDatasetVersionsArgs = {
  fieldId: Scalars['Int']['input'];
};

export type MutationRemoveFileArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemoveFilePoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<FilePolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveGeneralEntityPoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<GeneralPolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveGridViewArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemoveHomepageSectionArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemoveIdentityProviderArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemoveInitiativePoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<InitiativePolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveLoginRouteArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemoveMeasureMetaddataArgs = {
  id: Scalars['Int']['input'];
};

export type MutationRemoveNotificationArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemoveObjectiveArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemoveObjectiveStrategyArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemoveObjectiveStrategyTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemoveObjectiveTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemovePatientListPoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<PatientListPolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemovePublicFileArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemoveRoiMetricArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemoveRolesArgs = {
  ids: Array<Scalars['String']['input']>;
};

export type MutationRemoveStrategyAttachmentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemoveStrategyBoardPoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<StrategyBoardPolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveSubmissionArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemoveTableauViewArgs = {
  id: Scalars['Int']['input'];
};

export type MutationRemoveThreadArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemoveUserArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemoveUserPoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<UserPolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveWorkbookArgs = {
  id: Scalars['Int']['input'];
};

export type MutationRemoveWorkbookGroupArgs = {
  id: Scalars['Int']['input'];
};

export type MutationRequestDimensionUpdateArgs = {
  dimensionId: Scalars['Int']['input'];
};

export type MutationRequestMeasureUpdateArgs = {
  measureId: Scalars['Int']['input'];
};

export type MutationRequestRoiMetricUpdateArgs = {
  roiMetricId: Scalars['String']['input'];
};

export type MutationRequestSmeReviewForDimensionArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  dimensionId: Scalars['Int']['input'];
};

export type MutationRequestSmeReviewForMeasureArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  measureId: Scalars['Int']['input'];
};

export type MutationRequestSmeReviewForRoiMetricArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  roiMetricId: Scalars['String']['input'];
};

export type MutationRequestTenantOffboardingArgs = {
  input: RequestTenantOffboardingInput;
};

export type MutationResendOnboardingEmailArgs = {
  userId: Scalars['String']['input'];
};

export type MutationResetPasswordArgs = {
  passwordResetInput: PasswordResetInput;
};

export type MutationRestorePresentationArgs = {
  id: Scalars['String']['input'];
};

export type MutationRetryJobArgs = {
  jobId: Scalars['String']['input'];
};

export type MutationRetryTenantOffboardingDiscoveryArgs = {
  id: Scalars['String']['input'];
};

export type MutationRevokeTokenArgs = {
  id: Scalars['String']['input'];
};

export type MutationRunReportArgs = {
  reportId: Scalars['String']['input'];
};

export type MutationSendInquiryArgs = {
  input: SendInquiryInput;
};

export type MutationSendMessageArgs = {
  distributionListId?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  subject: Scalars['String']['input'];
};

export type MutationSetHomepageArgs = {
  createBookmarkInput: CreateBookmarkInput;
};

export type MutationShareFilesWithDistributionListsArgs = {
  fileShareNotification?: InputMaybe<FileShareNotification>;
  filesShareInput?: InputMaybe<Array<UpdateDistributionListInput>>;
};

export type MutationShareFilesWithUsersArgs = {
  fileShareNotification?: InputMaybe<FileShareNotification>;
  userFileShareInputs: Array<UpdateUserInput>;
};

export type MutationSoftDeleteCareEntityArgs = {
  id: Scalars['String']['input'];
};

export type MutationSoftDeletePresentationArgs = {
  id: Scalars['String']['input'];
};

export type MutationSoftDeleteUserArgs = {
  id: Scalars['String']['input'];
};

export type MutationStartTenantOffboardingApprovalDiscoveryArgs = {
  id: Scalars['String']['input'];
};

export type MutationSyncRoleRowLevelSecurityArgs = {
  roleId: Scalars['String']['input'];
};

export type MutationSyncTenantRowLevelSecurityArgs = {
  tenantId: Scalars['String']['input'];
};

export type MutationSyncUserRowLevelSecurityArgs = {
  userId: Scalars['String']['input'];
};

export type MutationUnarchiveDatasetArgs = {
  id: Scalars['Int']['input'];
};

export type MutationUnarchiveDiseaseStateModuleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUnlinkObjectiveStrategyArgs = {
  id: Scalars['ID']['input'];
  objectiveId: Scalars['ID']['input'];
};

export type MutationUnlockUserArgs = {
  username: Scalars['String']['input'];
};

export type MutationUpdateAdUserArgs = {
  updateAdUserInput: UpdateEntraIdUserInput;
};

export type MutationUpdateApplicationArgs = {
  updateApplicationInput: CreateApplicationInput;
};

export type MutationUpdateBiomeDictionaryArgs = {
  updateBiomeDictionaryInput: UpdateTranslatorConfigInput;
};

export type MutationUpdateBookmarkArgs = {
  updateBookmarkInput: UpdateBookmarkInput;
};

export type MutationUpdateCareEntityArgs = {
  updateCareEntityInput: UpdateCareEntityInput;
};

export type MutationUpdateClinicalProgramArgs = {
  updateClinicalProgramInput: UpdateClinicalProgramInput;
};

export type MutationUpdateCommentArgs = {
  updateCommentInput: UpdateCommentInput;
};

export type MutationUpdateDatasetArgs = {
  updateDatasetInput: UpdateDatasetInput;
};

export type MutationUpdateDatasetVersionArgs = {
  updateDatasetVersionInput: UpdateDatasetVersionInput;
};

export type MutationUpdateDeadlineArgs = {
  updateDeadlineInput: UpdateDeadlineInput;
};

export type MutationUpdateDevelopmentDimensionArgs = {
  input: UpdateDevelopmentDimensionInput;
};

export type MutationUpdateDevelopmentMeasureArgs = {
  input: UpdateDevelopmentMeasureInput;
};

export type MutationUpdateDevelopmentRoiMetricArgs = {
  input: UpdateDevelopmentRoiMetricInput;
};

export type MutationUpdateDictionaryArgs = {
  updateDictionaryInput: UpdateDictionaryInput;
};

export type MutationUpdateDimensionArgs = {
  updateDimensionInput: UpdateDimensionInput;
};

export type MutationUpdateDiseaseStateModuleArgs = {
  updateDiseaseStateModuleInput: UpdateDiseaseStateModuleInput;
};

export type MutationUpdateDistributionListArgs = {
  fileShareNotification?: InputMaybe<FileShareNotification>;
  updateDistributionListInput: UpdateDistributionListInput;
};

export type MutationUpdateEchoFollowupOptionsArgs = {
  inputs: Array<UpdateEchoFollowupOptionInput>;
};

export type MutationUpdateEchoMessageTemplateArgs = {
  input: UpdateEchoMessageTemplateInput;
};

export type MutationUpdateEchoReferringProviderArgs = {
  input: UpdateEchoReferringProviderInput;
};

export type MutationUpdateGridViewArgs = {
  updateGridViewInput: UpdateGridViewInput;
};

export type MutationUpdateHomepageSectionsArgs = {
  inputs: Array<UpdateHomepageSectionInput>;
};

export type MutationUpdateIdentityProviderArgs = {
  updateIdentityProviderInput: UpdateIdentityProviderInput;
};

export type MutationUpdateLoginRouteArgs = {
  updateLoginRouteInput: UpdateLoginRouteInput;
};

export type MutationUpdateMeasureMetadataArgs = {
  updateMeasureMetadataInput: UpdateMeasureMetadataInput;
};

export type MutationUpdateNotificationArgs = {
  updateNotificationInput: UpdateNotificationInput;
};

export type MutationUpdateObjectiveArgs = {
  updateObjectiveInput: UpdateObjectiveInput;
};

export type MutationUpdateObjectiveStrategyArgs = {
  updateObjectiveStrategyInput: UpdateObjectiveStrategyInput;
};

export type MutationUpdateObjectiveStrategyTemplateArgs = {
  updateObjectiveStrategyTemplateInput: UpdateObjectiveStrategyTemplateInput;
};

export type MutationUpdateObjectiveTemplateArgs = {
  updateObjectiveTemplateInput: UpdateObjectiveTemplateInput;
};

export type MutationUpdatePresentationArgs = {
  input: UpdatePresentationInput;
};

export type MutationUpdateReportArgs = {
  reportInput: UpdateReportInput;
  startExport: Scalars['Boolean']['input'];
};

export type MutationUpdateRoiMetricArgs = {
  updateRoiMetricInput: UpdateRoiMetricInput;
};

export type MutationUpdateRoleArgs = {
  updateRoleInput: UpdateRoleInput;
};

export type MutationUpdateSlidesArgs = {
  inputs: Array<UpdateSlideInput>;
  presentationId: Scalars['String']['input'];
};

export type MutationUpdateSubmissionArgs = {
  updateSubmissionInput: UpdateSubmissionInput;
};

export type MutationUpdateTableauViewArgs = {
  updateViewInput: UpdateTableauViewInput;
};

export type MutationUpdateTenantArgs = {
  updateTenantInput: UpdateTenantInput;
};

export type MutationUpdateThreadArgs = {
  updateThreadInput: UpdateThreadInput;
};

export type MutationUpdateUserArgs = {
  fileShareNotification?: InputMaybe<FileShareNotification>;
  updateUserInput: UpdateUserInput;
};

export type MutationUpdateUserAccountArgs = {
  updateUserInput: UpdateUserAccountInput;
};

export type MutationUpdateWorkbookArgs = {
  updateWorkbookInput: UpdateWorkbookInput;
};

export type MutationUpdateWorkbookGroupArgs = {
  updateGroupInput: UpdateWorkbookGroupInput;
};

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  /** Description of the notification */
  description?: Maybe<Scalars['String']['output']>;
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notificationLogs?: Maybe<Array<NotificationLogs>>;
  type: NotificationType;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  users?: Maybe<Array<User>>;
};

export type NotificationLogs = {
  __typename?: 'NotificationLogs';
  /** Creation Datetime */
  createdAt: Scalars['DateTime']['output'];
  dsm?: Maybe<DiseaseStateModule>;
  dsmId?: Maybe<Scalars['Int']['output']>;
  /** Auto increment ID */
  id: Scalars['ID']['output'];
  notification: Notification;
  notificationId: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  /** Modification Datetime */
  updateAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export enum NotificationType {
  DataRefreshEmails = 'DataRefreshEmails',
  EchoSummaryEmails = 'EchoSummaryEmails',
  ProductNewsUpdates = 'ProductNewsUpdates',
  RiskAuditEmails = 'RiskAuditEmails',
}

export type Objective = {
  __typename?: 'Objective';
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  cohortIds?: Maybe<Array<Scalars['Float']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  diseaseStateModule?: Maybe<DiseaseStateModule>;
  diseaseStateModuleId?: Maybe<Scalars['Int']['output']>;
  hiddenStrategyCount?: Maybe<Scalars['Int']['output']>;
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  /** Source: Perf Api initiative list */
  initiativeId?: Maybe<Scalars['Float']['output']>;
  measures?: Maybe<Array<MeasureMetadata>>;
  /** Title of the objective, populate based on measure & cohort in case of Opportunity objective */
  name: Scalars['String']['output'];
  objectiveTemplate?: Maybe<ObjectiveTemplate>;
  objectiveTemplateId?: Maybe<Scalars['ID']['output']>;
  participants?: Maybe<Array<ObjectiveParticipant>>;
  performanceManagerSyncFailed?: Maybe<Scalars['Boolean']['output']>;
  physicianChampions?: Maybe<Array<ObjectiveParticipant>>;
  processSponsors?: Maybe<Array<ObjectiveParticipant>>;
  strategies?: Maybe<Array<ObjectiveStrategy>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type ObjectiveAttachPreviewInput = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  cohortIds: Array<Scalars['Float']['input']>;
  diseaseStateModuleId?: InputMaybe<Scalars['Int']['input']>;
  measureIds: Array<Scalars['Float']['input']>;
  objectiveId?: InputMaybe<Scalars['ID']['input']>;
  tenantId: Scalars['ID']['input'];
};

export type ObjectiveAttachPreviewStrategy = {
  __typename?: 'ObjectiveAttachPreviewStrategy';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ObjectiveParticipant = {
  __typename?: 'ObjectiveParticipant';
  createdAt: Scalars['DateTime']['output'];
  /** Free text username/email for external participants not in User table */
  externalUsername?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  objective: Objective;
  objectiveId: Scalars['String']['output'];
  role: ParticipantRole;
  updateAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ObjectiveStrategy = {
  __typename?: 'ObjectiveStrategy';
  associatedObjectiveCount: Scalars['Int']['output'];
  associatedObjectives: Array<Objective>;
  associations?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<File>>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  checkpointDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  diseaseStateModuleId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  participants?: Maybe<Array<StrategyParticipant>>;
  performanceManagerSyncFailed?: Maybe<Scalars['Boolean']['output']>;
  physicianChampions?: Maybe<Array<StrategyParticipant>>;
  processSponsors?: Maybe<Array<StrategyParticipant>>;
  resources?: Maybe<Array<ObjectiveStrategyResource>>;
  showInPerformanceMonitor: Scalars['Boolean']['output'];
  status: ObjectiveStrategyStatus;
  template?: Maybe<ObjectiveStrategyTemplate>;
  templateId?: Maybe<Scalars['ID']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
};

export type ObjectiveStrategyResource = {
  __typename?: 'ObjectiveStrategyResource';
  createdAt: Scalars['DateTime']['output'];
  displayText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  objectiveStrategy: ObjectiveStrategy;
  objectiveStrategyId: Scalars['ID']['output'];
  updateAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export enum ObjectiveStrategyStatus {
  AttentionRequired = 'ATTENTION_REQUIRED',
  Completed = 'COMPLETED',
  OnTrack = 'ON_TRACK',
  Stalled = 'STALLED',
}

export type ObjectiveStrategyTemplate = {
  __typename?: 'ObjectiveStrategyTemplate';
  allDiseaseStateModules: Scalars['Boolean']['output'];
  allMeasures: Scalars['Boolean']['output'];
  attachments?: Maybe<Array<File>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  diseaseStateModule?: Maybe<DiseaseStateModule>;
  diseaseStateModuleId?: Maybe<Scalars['Int']['output']>;
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  measures?: Maybe<Array<MeasureMetadata>>;
  name: Scalars['String']['output'];
  resources?: Maybe<Array<ObjectiveStrategyTemplateResource>>;
  strategies?: Maybe<Array<ObjectiveStrategy>>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type ObjectiveStrategyTemplateResource = {
  __typename?: 'ObjectiveStrategyTemplateResource';
  createdAt: Scalars['DateTime']['output'];
  displayText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  objectiveStrategyTemplate: ObjectiveStrategyTemplate;
  objectiveStrategyTemplateId: Scalars['ID']['output'];
  updateAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type ObjectiveTemplate = {
  __typename?: 'ObjectiveTemplate';
  cohortIds?: Maybe<Array<Scalars['Float']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  diseaseStateModule?: Maybe<DiseaseStateModule>;
  diseaseStateModuleId?: Maybe<Scalars['Int']['output']>;
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  linkedStrategyTemplates?: Maybe<Array<ObjectiveStrategyTemplate>>;
  measures?: Maybe<Array<MeasureMetadata>>;
  /** Title of the objective template */
  name: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type OePipelineRun = {
  __typename?: 'OePipelineRun';
  auditourReports: Array<AuditourReport>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataflowRunUUID?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  etlRuns: Array<DataflowRun>;
  id: Scalars['String']['output'];
  inputSourcesListed?: Maybe<Scalars['Int']['output']>;
  inputSourcesResolved?: Maybe<Scalars['Int']['output']>;
  inputSourcesUnresolved?: Maybe<Scalars['Int']['output']>;
  inputTracking: InputTrackingStatus;
  inputTrackingAt?: Maybe<Scalars['DateTime']['output']>;
  inputTrackingError?: Maybe<Scalars['JSON']['output']>;
  inputs: Array<OeRunStatsInput>;
  isDemo: Scalars['Boolean']['output'];
  movedToProd: MovedToProdStatus;
  movedToProdAt?: Maybe<Scalars['DateTime']['output']>;
  movedToStaging: MovedToProdStatus;
  pipelineName?: Maybe<Scalars['String']['output']>;
  registry?: Maybe<OeRegistry>;
  request?: Maybe<DataflowRequest>;
  requestId?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['DateTime']['output'];
  status: DataflowRunStatus;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  validation: DataflowValidationStatus;
};

export enum OeRegistry {
  AFib = 'AFib',
  AhaHeartFailure = 'AhaHeartFailure',
  CathPci = 'CathPci',
  Cpmi = 'Cpmi',
  Cvsl = 'Cvsl',
  Echocardiogram = 'Echocardiogram',
  Icd = 'Icd',
  Laao = 'Laao',
  Stroke = 'Stroke',
  Sts = 'Sts',
  Tvt = 'Tvt',
}

export type OeRunStatsInput = {
  __typename?: 'OeRunStatsInput';
  DatasetName: Scalars['String']['output'];
  ETlRunuuid: Scalars['String']['output'];
  TenantName: Scalars['String']['output'];
};

export type OpportunityPercentileEntry = {
  __typename?: 'OpportunityPercentileEntry';
  at: Scalars['Int']['output'];
  distanceFrom?: Maybe<Scalars['Float']['output']>;
  los?: Maybe<Scalars['Float']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  performance?: Maybe<Scalars['Boolean']['output']>;
  roi?: Maybe<Scalars['Float']['output']>;
  summedRoi?: Maybe<Scalars['Float']['output']>;
};

export enum OpportunityPreference {
  Active = 'Active',
  All = 'All',
  Favorite = 'Favorite',
  Snoozed = 'Snoozed',
}

export enum OpportunityTrend {
  Improving = 'Improving',
  NoDiscernibleTrend = 'NoDiscernibleTrend',
  Worsening = 'Worsening',
}

export enum OpportunityType {
  Admin = 'Admin',
  Clinical = 'Clinical',
  DataQuality = 'DataQuality',
  Financial = 'Financial',
  Operational = 'Operational',
  PatientPopulation = 'PatientPopulation',
  PubliclyReported = 'PubliclyReported',
  StrategicGrowth = 'StrategicGrowth',
}

export type OrganizationalUnit = {
  __typename?: 'OrganizationalUnit';
  /** Every entry in the directory has a distinguished name (DN). The DN is the name that uniquely identifies an entry in the directory. It is a sequence of relative distinguished names (RDN) connected by commas. An RDN is an attribute with an associated value in the form attribute=value; normally expressed in a UTF-8 string format. RDN attributes consist of commonName (CN), organizationalUnitName (OU) and so on. */
  distinguishedName: Scalars['String']['output'];
  /** Sub Organizational Units */
  subOu?: Maybe<Array<OrganizationalUnit>>;
};

export type OtherEmail = {
  __typename?: 'OtherEmail';
  email: Scalars['String']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type OtherEmailInput = {
  email: Scalars['String']['input'];
};

export type OutboundMessage = {
  __typename?: 'OutboundMessage';
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  outboundMessageDetails?: Maybe<OutboundMessageDetails>;
  read: Scalars['Boolean']['output'];
  recipient: User;
  requester: User;
  sentDate: Scalars['DateTime']['output'];
  subject: Scalars['String']['output'];
  trigger: OutboundMessageTrigger;
};

export type OutboundMessageDetails = {
  __typename?: 'OutboundMessageDetails';
  body?: Maybe<Scalars['String']['output']>;
  htmlBody?: Maybe<Scalars['String']['output']>;
  messageEvents?: Maybe<Array<OutboundMessageEvent>>;
  textBody?: Maybe<Scalars['String']['output']>;
};

export type OutboundMessageEvent = {
  __typename?: 'OutboundMessageEvent';
  details?: Maybe<OutboundMessageEventDetails>;
  receivedAt?: Maybe<Scalars['String']['output']>;
  recipient?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type OutboundMessageEventDetails = {
  __typename?: 'OutboundMessageEventDetails';
  deliveryMessage?: Maybe<Scalars['String']['output']>;
  destinationIP?: Maybe<Scalars['String']['output']>;
  destinationServer?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export enum OutboundMessageTrigger {
  Custom = 'CUSTOM',
  FileShare = 'FILE_SHARE',
  TenantOffboarding = 'TENANT_OFFBOARDING',
}

export type ParentChildValidation = {
  __typename?: 'ParentChildValidation';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  element: Element;
  id: Scalars['ID']['output'];
  parent: Element;
  parentElementSelectionName?: Maybe<Scalars['String']['output']>;
  parentId: Scalars['String']['output'];
  parentSelection?: Maybe<Selection>;
  parentSelectionId?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

/** Role of the participant in the objective */
export enum ParticipantRole {
  Champion = 'CHAMPION',
  Sponsor = 'SPONSOR',
}

export type PasswordResetInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  /** Unique username */
  username: Scalars['String']['input'];
};

export type PatientListAttribute = {
  __typename?: 'PatientListAttribute';
  maxDate?: Maybe<Scalars['String']['output']>;
  quarters: Array<Scalars['String']['output']>;
};

export type PatientListField = {
  __typename?: 'PatientListField';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  displayRank: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  patientListType: PatientListType;
  phi: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  visibility: VisibilityType;
};

export type PatientListPolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['String']['input'];
  eft?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export enum PatientListType {
  Ablation = 'ablation',
  Afib = 'afib',
  Ahaheartfailure = 'ahaheartfailure',
  Ami = 'ami',
  Arrhythmia = 'arrhythmia',
  Cardiacsurgery = 'cardiacsurgery',
  Cardiogenicshock = 'cardiogenicshock',
  Cathpci = 'cathpci',
  Cied = 'cied',
  Cpmi = 'cpmi',
  Cvimaging = 'cvimaging',
  Echocardiogram = 'echocardiogram',
  Ecmo = 'ecmo',
  Epdi = 'epdi',
  Heartfailure = 'heartfailure',
  Icd = 'icd',
  Interventionalradiology = 'interventionalradiology',
  Laao = 'laao',
  Mitraclip = 'mitraclip',
  Neurovascular = 'neurovascular',
  Otherhemodynamic = 'otherhemodynamic',
  Pcidiagcath = 'pcidiagcath',
  Renaldenervation = 'renaldenervation',
  Stroke = 'stroke',
  Structuralheart = 'structuralheart',
  Sts = 'sts',
  Tavr = 'tavr',
  Thoracic = 'thoracic',
  Tricuspid = 'tricuspid',
  Vad = 'vad',
  Vascular = 'vascular',
}

export type PerformanceManagerStrategy = {
  __typename?: 'PerformanceManagerStrategy';
  canEdit: Scalars['Boolean']['output'];
  checkpointDate?: Maybe<Scalars['DateTime']['output']>;
  floating: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  initiatives: Array<PerformanceManagerStrategyInitiative>;
  name: Scalars['String']['output'];
  objectives: Array<Objective>;
  strategy?: Maybe<ObjectiveStrategy>;
};

export type PerformanceManagerStrategyInitiative = {
  __typename?: 'PerformanceManagerStrategyInitiative';
  initiativeId: Scalars['Float']['output'];
  monitoredCareEntity: Scalars['String']['output'];
};

export enum PhiEnrichmentState {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Success = 'SUCCESS',
}

export type PipelineElement = {
  __typename?: 'PipelineElement';
  biomeDictionaryElements: Array<Element>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataframe: Scalars['String']['output'];
  denominatorMeasures?: Maybe<Array<MeasureMetadata>>;
  documentation?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  includeMeasures?: Maybe<Array<MeasureMetadata>>;
  numeratorMeasures?: Maybe<Array<MeasureMetadata>>;
  pipelineMetadata: PipelineMetadata;
  qualifiedName: Scalars['String']['output'];
  riskMetricMeasures?: Maybe<Array<MeasureMetadata>>;
  shortName: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
};

export type PipelineMetadata = {
  __typename?: 'PipelineMetadata';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  diseaseStateModule: DiseaseStateModule;
  id: Scalars['ID']['output'];
  isLatest: Scalars['Boolean']['output'];
  pipelineElements: Array<PipelineElement>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  version: Scalars['String']['output'];
};

export type PolicyRequest = {
  action: Scalars['String']['input'];
  attribute?: InputMaybe<Scalars['String']['input']>;
  dsmId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  object?: InputMaybe<Scalars['String']['input']>;
  objectType: EnforcerType;
  resource?: InputMaybe<Scalars['String']['input']>;
  /** roles/<roleId> */
  subjectId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  workbookGroupId?: InputMaybe<Scalars['String']['input']>;
  workbookId?: InputMaybe<Scalars['String']['input']>;
};

export type PolicyResponse = {
  __typename?: 'PolicyResponse';
  action: Scalars['String']['output'];
  attribute?: Maybe<Scalars['String']['output']>;
  dsmId?: Maybe<Scalars['String']['output']>;
  eft?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
  /** roles/<roleId> */
  subjectId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  workbookGroupId?: Maybe<Scalars['String']['output']>;
  workbookId?: Maybe<Scalars['String']['output']>;
};

export type Presentation = {
  __typename?: 'Presentation';
  clonedFor?: Maybe<Array<Scalars['String']['output']>>;
  clonesGenerated: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  cropConfig: Scalars['JSON']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  diseaseStateModule?: Maybe<DiseaseStateModule>;
  diseaseStateModuleId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imagesRefreshedAt?: Maybe<Scalars['DateTime']['output']>;
  latestJob?: Maybe<Job>;
  latestJobId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  presentationType?: Maybe<PresentationType>;
  refreshJob?: Maybe<Job>;
  refreshJobId?: Maybe<Scalars['String']['output']>;
  slides?: Maybe<Array<Slide>>;
  submissions?: Maybe<PresentationSubmission>;
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type PresentationCloneInput = {
  dashboardEntityIds: Array<Scalars['String']['input']>;
  oeEntityId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type PresentationSubmission = {
  __typename?: 'PresentationSubmission';
  careEntity: CareEntity;
  careEntityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  presentation?: Maybe<Presentation>;
  presentationId: Scalars['String']['output'];
  quarter: Scalars['String']['output'];
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
};

export enum PresentationType {
  Adhoc = 'Adhoc',
  Etc = 'Etc',
  ExecutiveSummary = 'ExecutiveSummary',
  ProgrammaticSummary = 'ProgrammaticSummary',
  StrategicSummary = 'StrategicSummary',
}

export type ProcedureInput = {
  key: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type ProcessListEntry = {
  __typename?: 'ProcessListEntry';
  Command: Scalars['String']['output'];
  Host: Scalars['String']['output'];
  Id: Scalars['Int']['output'];
  Info?: Maybe<Scalars['String']['output']>;
  State?: Maybe<Scalars['String']['output']>;
  Time: Scalars['Int']['output'];
  User: Scalars['String']['output'];
  db?: Maybe<Scalars['String']['output']>;
};

/** Public File */
export type PublicFile = {
  __typename?: 'PublicFile';
  category: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  extension: Scalars['String']['output'];
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sharedAt?: Maybe<Scalars['DateTime']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum PublicationSource {
  HealthGrades = 'HealthGrades',
  HospitalCompare = 'HospitalCompare',
  JointCommission = 'JointCommission',
  NcdrClinicalMetricsGuide = 'NCDRClinicalMetricsGuide',
  StsStarRating = 'STSStarRating',
  Usnwr = 'USNWR',
}

export enum Quarter {
  Q1 = 'Q1',
  Q2 = 'Q2',
  Q3 = 'Q3',
  Q4 = 'Q4',
}

export type Query = {
  __typename?: 'Query';
  ablationPatientList: Array<Ablation>;
  accessHistory: Array<AccessHistory>;
  activityLogs: Array<ActivityLog>;
  /** List of all AD groups */
  adGroups: Array<EntraIdGroup>;
  /** Returns AD User that matches username */
  adUser: EntraIdUser;
  /** List of user groups */
  adUserGroups: Array<EntraIdGroup>;
  /** List of all AD users */
  adUsers: Array<EntraIdUser>;
  afibPatientList: Array<Afib>;
  amiPatientList: Array<Ami>;
  application: Application;
  applications: Array<Application>;
  arrhythmiaPatientList: Array<Arrhythmia>;
  attributesCriteria: Array<CodeBasedAttributeCriteriaDto>;
  biomeDictionaries: Array<TranslatorConfig>;
  biomeDictionary: TranslatorConfig;
  bookmark: Bookmark;
  bookmarks: Array<Bookmark>;
  canCreatePerformanceManagerStrategy: Scalars['Boolean']['output'];
  cardiogenicshockPatientList: Array<Cardiogenicshock>;
  careEntities: Array<CareEntity>;
  careEntitiesCached: Array<CareEntity>;
  careEntitiesLive: Array<CareEntity>;
  careEntity: CareEntity;
  careEntityUpdateImpact: CareEntityUpdateImpact;
  casesProcessList: Array<ProcessListEntry>;
  /** Categorizes all measures based on relevance to a given question. */
  categorizedMeasures: Array<AngioscopeMeasure>;
  cathPciPatientList: Array<CathPci>;
  certificate: Certificate;
  /** Checks if a resources is granted actions in Initiatives, Dashboards, General, Initiative or Clinician enforcer for the logged in user */
  checkPolicies: Array<PolicyResponse>;
  childrenCareEntities: Array<CareEntity>;
  ciedPatientList: Array<Cied>;
  /** Resolves the dashboard a BVA answer citation should deep-link to */
  citationDashboard?: Maybe<CitationDashboard>;
  clientSubmissionStatuses: Array<ClientSubmissionStatus>;
  clinicalProgram: ClinicalProgram;
  clinicalPrograms: Array<ClinicalProgram>;
  comment: Comment;
  commentReaction?: Maybe<CommentReaction>;
  commentReactionsByComment: Array<CommentReaction>;
  comments: Array<Comment>;
  commentsByThread: Array<Comment>;
  compassData: Srog;
  /** Returns the body of a Confluence page */
  confluencePageDetail: ConfluencePage;
  /** Returns a list of all related pages of a given Confluence page */
  confluencePageOverview: Array<ConfluencePage>;
  cpmiPatientList: Array<Cpmi>;
  currentEchoFollowupOptions: Array<EchoFindingFollowupOption>;
  cvimagingPatientList: Array<CvImaging>;
  datasestVersionFields: Array<DatasetVersionField>;
  dataset: Dataset;
  datasetRelations: Array<Scalars['String']['output']>;
  datasetVersion: DatasetVersion;
  datasetVersions: Array<DatasetVersion>;
  datasets: Array<Dataset>;
  deadline: Deadline;
  deadlines: Array<Deadline>;
  developmentDimension: DevelopmentDimension;
  developmentDimensionHistory: Array<DevelopmentDimension>;
  developmentDimensions: Array<DevelopmentDimension>;
  developmentMeasure: DevelopmentMeasure;
  developmentMeasureHistory: Array<DevelopmentMeasure>;
  developmentMeasures: Array<DevelopmentMeasure>;
  developmentRoiMetric: DevelopmentRoiMetric;
  developmentRoiMetricHistory: Array<DevelopmentRoiMetric>;
  developmentRoiMetrics: Array<DevelopmentRoiMetric>;
  dictionaries: Array<Dictionary>;
  dictionary: Dictionary;
  dimension: Dimension;
  dimensionClasses: Array<Scalars['String']['output']>;
  dimensionHistory: DimensionHistory;
  dimensionSetsByMeasureId: Array<DimensionSet>;
  dimensions: Array<Dimension>;
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModules: Array<DiseaseStateModule>;
  distributionList: DistributionList;
  distributionLists: Array<DistributionList>;
  echoAttributes: Array<EchoAttributes>;
  echoFindingFields: Array<EchoFindingField>;
  echoFindingModules: Array<EchoFindingModule>;
  echoFindings: Array<EchoFinding>;
  echoFollowupOption: EchoFindingFollowupOption;
  echoFollowupOptions: Array<EchoFindingFollowupOption>;
  echoMessageTemplate: EchoMessageTemplate;
  echoMessageTemplates: Array<EchoMessageTemplate>;
  echoPatientsVolume: Array<EchoPatientVolume>;
  echoQuantifiedSeverities: Array<EchoQuantifiedSeverity>;
  echoReferringProvider: EchoReferringProvider;
  echoReferringProviders: Array<EchoReferringProvider>;
  echoStudyStatuses: Array<CaseStudyStatus>;
  echocardiogramPatientList: Array<Echocardiogram>;
  ecmoPatientList: Array<Ecmo>;
  element: Element;
  elements: Array<Element>;
  epdiPatientList: Array<Epdi>;
  expiringDeadlineForDataset?: Maybe<ExpiringDeadlineWarning>;
  /** Returns the users carrying an explicit care-entity value - the exceptions to the tenant.code default used for the CARE_ENTITY segment of ingestion filenames - one page at a time; follow nextCursor until it is null to read them all. Empty until an admin sets one. Authorized by the existing ADMIN users.read permission, and filtered to the tenants the requester holds it in. */
  explicitCareEntityUsers: ExplicitCareEntityUserPage;
  /** this query is to get the list of views the user has added to favorites for the tenant */
  favoriteViews: Array<TableauView>;
  file: File;
  fileAccessLogs: Array<ActivityLog>;
  fileLabels: Array<FileLabel>;
  files: File;
  filteredStrategies: Array<ObjectiveStrategy>;
  findAllTenantEchoModules: Array<EchoFindingModule>;
  getGridView?: Maybe<GridView>;
  getGridViews: Array<GridView>;
  heartFailurePatientList: Array<HeartFailure>;
  homepageSection: HomepageSection;
  homepageSections: Array<HomepageSection>;
  icdPatientList: Array<Icd>;
  identityProvider: IdentityProvider;
  identityProviders: Array<IdentityProvider>;
  /** returns users that have initiative (read) access on given entity / dsm within the requester's tenant i.e. PM (initiatives) application access and diseaseStateModule read access on given entity/dsm. doesn't include the root users */
  initiativeUsers: Array<User>;
  job?: Maybe<Job>;
  /** The full step tree for one job. Fetched on demand — a terminal tree never changes, so it is safe to cache. */
  jobProgressTree: JobProgressTree;
  jobs: Array<Job>;
  laaoPatientList: Array<Laao>;
  /** When the requester's care-entity/DSM permissions were last rebuilt. The table is materialised asynchronously, so views derived from it are only as fresh as this. Null when the requester has no permission rows. */
  lastCeDsmRefresh?: Maybe<Scalars['DateTime']['output']>;
  latestJobs: Array<Job>;
  loginRoute: LoginRoute;
  loginRoutes: Array<LoginRoute>;
  measureMetadata: MeasureMetadata;
  measureMetadataHistory: MeasureMetadataHistory;
  measuresByDsmCached: Array<CachedMeasureMetadata>;
  measuresMetadata: Array<MeasureMetadata>;
  mitraclipPatientList: Array<Mitraclip>;
  notifications: Array<Notification>;
  objective: Objective;
  objectiveAttachPreview: Array<ObjectiveAttachPreviewStrategy>;
  objectiveStrategies: Array<ObjectiveStrategy>;
  objectiveStrategy: ObjectiveStrategy;
  objectiveStrategyTemplate: ObjectiveStrategyTemplate;
  objectiveStrategyTemplates: Array<ObjectiveStrategyTemplate>;
  objectiveTemplate: ObjectiveTemplate;
  objectiveTemplates: Array<ObjectiveTemplate>;
  objectives: Array<Objective>;
  /** List of Organizational Units */
  organizationalUnits: Array<OrganizationalUnit>;
  outboundMessage: OutboundMessage;
  outboundMessages: Array<OutboundMessage>;
  patientListAttributes?: Maybe<PatientListAttribute>;
  patientListAvailableQuarters: Array<Scalars['String']['output']>;
  patientListFields: Array<PatientListField>;
  patientListMaxStudyDate?: Maybe<Scalars['DateTime']['output']>;
  performanceManagerStrategies: Array<PerformanceManagerStrategy>;
  pipelineElement: PipelineElement;
  pipelineElements: Array<PipelineElement>;
  /** Returns PolicyResponse[] (PolicyResponse is union type of all PolicyInput types) defined for give subjectId from given enforcer type */
  policies: Array<PolicyResponse>;
  presentation: Presentation;
  presentations: Array<Presentation>;
  publicFile: PublicFile;
  publicFileAccessLogs: Array<ActivityLog>;
  publicFiles: Array<PublicFile>;
  /** Prompts an AI model to generate details for a given question. */
  questionDetails: Array<Scalars['String']['output']>;
  recentTableauView: Array<RecentTableauView>;
  report: Report;
  reportAnchorDates: Array<ReportAnchorDate>;
  reportAttributes: ReportAttributes;
  reports: Array<Report>;
  riskAuditAttributes: RiskAuditAttributes;
  riskAuditChartsData: RiskAuditChartsData;
  riskAuditFields: Array<RiskAuditField>;
  riskAuditOutcomes: RiskAuditOutcomesResponse;
  riskAudits: Array<RiskAudit>;
  rlsAllowedCareEntityCodes: Array<Scalars['String']['output']>;
  rlsAllowedContexts: Array<RlsUserContextType>;
  roiMetric: RoiMetric;
  roiMetricHistory: RoiMetricHistory;
  roiMetrics: Array<RoiMetric>;
  role: Role;
  roles: Array<Role>;
  searchElements: Array<Scalars['String']['output']>;
  sharedPublicFiles: Array<PublicFile>;
  srog: Srog;
  strokePatientList: Array<Stroke>;
  stsPatientList: Array<Sts>;
  submission: Submission;
  submissionAccessLogs: Array<ActivityLog>;
  submissionInquiries: Array<SubmissionInquiry>;
  submissionInquiry: SubmissionInquiry;
  submissionPresentations: Array<PresentationSubmission>;
  submissions: Array<Submission>;
  tableauView: TableauView;
  tableauViews: Array<TableauView>;
  tavrPatientList: Array<Tavr>;
  tenant: Tenant;
  /** Disease state modules of the tenant in which the user (the requester when no userId is given) may read a dashboard */
  tenantDiseaseStateModules: Array<DiseaseStateModule>;
  tenantFiles: Array<File>;
  tenantOffboardingDiscovery: TenantOffboardingDiscovery;
  tenantOffboardingEligibleApprovers: Array<User>;
  /** Latest offboarding request of the tenant, in any status. */
  tenantOffboardingJob?: Maybe<TenantOffboardingJob>;
  /** One request by id; still readable after its tenant is deleted. */
  tenantOffboardingJobById: TenantOffboardingJob;
  tenantOffboardingManifest: TenantOffboardingManifest;
  /** Manifest versions of the request, newest first. */
  tenantOffboardingVersions: Array<TenantOffboardingManifestVersionInfo>;
  /** Returns all users associated with the requester’s active tenant or the tenant specified by tenantId */
  tenantUsers: Array<User>;
  /** The tenant's active workbooks the requester may read */
  tenantWorkbooks: Array<Workbook>;
  tenants: Array<Tenant>;
  thread: Thread;
  threadByEntity?: Maybe<Thread>;
  threads: Array<Thread>;
  tricuspidPatientList: Array<Tricuspid>;
  /** Returns user that matches id/username/email else returns loggedIn user */
  user: User;
  /** One user's access modifications, newest first, with the user's creation for the trail's opening line. Covers role, distribution-list, policy and user-assignment events; file sharing and edits that leave a user's roles, distribution lists, tenants and root flag untouched are not access changes. No date window: attribution is a whole-table concern, not a recent-events one. */
  userAccessChanges: UserAccessChanges;
  /** Returns a reduced audit view of users in the requester’s active tenant, with roles scoped to the requester’s care entities/DSMs */
  userAudit: Array<UserAudit>;
  userDiseaseStateModulesIds: Array<Scalars['Int']['output']>;
  userFiles: Array<File>;
  /** Returns true if user is locked, false otherwise */
  userLocked: Scalars['Boolean']['output'];
  /** Returns all tables where given userId exists */
  userRelationshipTables: Array<Scalars['String']['output']>;
  /** Returns all enabled users associated with the given notification type */
  usersByNotificationType: Scalars['Float']['output'];
  vadPatientList: Array<Vad>;
  /** Returns whether the email is valid, i.e. doesn't already exist in the db as a primary or other email for any user */
  validateEmail: Scalars['Boolean']['output'];
  /** Returns whether the username is valid, i.e. doesn't already exist in the db or AD. */
  validateUsername: Scalars['Boolean']['output'];
  vascularPatientList: Array<Vascular>;
  /** Returns a list of Youtube videos that are used to guide users */
  videoGuides: VideoGuide;
  whoami: User;
  workbook: Workbook;
  workbookGroup: WorkbookGroup;
  workbookGroups: Array<WorkbookGroup>;
  workbooks: Array<Workbook>;
};

export type QueryAblationPatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryAccessHistoryArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryActivityLogsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryAdUserArgs = {
  username: Scalars['String']['input'];
};

export type QueryAdUserGroupsArgs = {
  username: Scalars['String']['input'];
};

export type QueryAfibPatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryAmiPatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryApplicationArgs = {
  id: Scalars['String']['input'];
};

export type QueryArrhythmiaPatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryAttributesCriteriaArgs = {
  dsm?: InputMaybe<Scalars['String']['input']>;
};

export type QueryBiomeDictionaryArgs = {
  id: Scalars['String']['input'];
};

export type QueryBookmarkArgs = {
  id: Scalars['String']['input'];
};

export type QueryCanCreatePerformanceManagerStrategyArgs = {
  careEntity: Scalars['String']['input'];
  registry: Scalars['String']['input'];
};

export type QueryCardiogenicshockPatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryCareEntitiesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryCareEntitiesCachedArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryCareEntitiesLiveArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryCareEntityArgs = {
  cmsId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCareEntityUpdateImpactArgs = {
  updateCareEntityInput: UpdateCareEntityInput;
};

export type QueryCategorizedMeasuresArgs = {
  details: Array<Scalars['String']['input']>;
  question: Scalars['String']['input'];
};

export type QueryCathPciPatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryCertificateArgs = {
  identityProviderId: Scalars['String']['input'];
};

export type QueryCheckPoliciesArgs = {
  policyInputs: Array<PolicyRequest>;
};

export type QueryChildrenCareEntitiesArgs = {
  code: Scalars['String']['input'];
};

export type QueryCiedPatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryCitationDashboardArgs = {
  citationDashboardInput: CitationDashboardInput;
};

export type QueryClientSubmissionStatusesArgs = {
  maxDate: Scalars['DateTime']['input'];
  minDate: Scalars['DateTime']['input'];
  status?: InputMaybe<SubmissionStatusValue>;
};

export type QueryClinicalProgramArgs = {
  id: Scalars['Int']['input'];
};

export type QueryCommentArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCommentReactionArgs = {
  commentId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type QueryCommentReactionsByCommentArgs = {
  commentId: Scalars['String']['input'];
};

export type QueryCommentsByThreadArgs = {
  threadId: Scalars['String']['input'];
};

export type QueryCompassDataArgs = {
  careEntityCodes: Array<Scalars['String']['input']>;
  cohortIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  collapseCohorts?: InputMaybe<Scalars['Boolean']['input']>;
  dimensionClass?: InputMaybe<Scalars['String']['input']>;
  dimensionFilter?: InputMaybe<DimensionFilter>;
  dimensionType?: InputMaybe<DimensionType>;
  dsmCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  measureIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  opportunityTypes?: InputMaybe<Array<OpportunityType>>;
  preferredCohortIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  publicationSources?: InputMaybe<Array<PublicationSource>>;
  sortBy?: InputMaybe<CompassSortBy>;
  srogBuckets?: InputMaybe<Array<SrogBucket>>;
  summaryInitiativeMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  topN?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryConfluencePageDetailArgs = {
  id: Scalars['String']['input'];
};

export type QueryCpmiPatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryCurrentEchoFollowupOptionsArgs = {
  caselistModuleName?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCvimagingPatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryDatasestVersionFieldsArgs = {
  datasetVersionId?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryDatasetArgs = {
  id: Scalars['Int']['input'];
};

export type QueryDatasetRelationsArgs = {
  id: Scalars['Int']['input'];
};

export type QueryDatasetVersionArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type QueryDatasetVersionsArgs = {
  datasetId?: InputMaybe<Scalars['Int']['input']>;
  fieldId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryDatasetsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryDeadlineArgs = {
  id: Scalars['String']['input'];
};

export type QueryDevelopmentDimensionArgs = {
  dimensionId: Scalars['Int']['input'];
};

export type QueryDevelopmentDimensionHistoryArgs = {
  dimensionId: Scalars['Int']['input'];
};

export type QueryDevelopmentDimensionsArgs = {
  filter?: InputMaybe<DevelopmentEntityFilterInput>;
};

export type QueryDevelopmentMeasureArgs = {
  measureId: Scalars['Int']['input'];
};

export type QueryDevelopmentMeasureHistoryArgs = {
  measureId: Scalars['Int']['input'];
};

export type QueryDevelopmentMeasuresArgs = {
  filter?: InputMaybe<DevelopmentEntityFilterInput>;
};

export type QueryDevelopmentRoiMetricArgs = {
  roiMetricId: Scalars['String']['input'];
};

export type QueryDevelopmentRoiMetricHistoryArgs = {
  roiMetricId: Scalars['String']['input'];
};

export type QueryDevelopmentRoiMetricsArgs = {
  filter?: InputMaybe<DevelopmentEntityFilterInput>;
};

export type QueryDictionariesArgs = {
  datasetIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  elementName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DictionaryType>;
};

export type QueryDictionaryArgs = {
  datasetId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DictionaryType>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type QueryDimensionArgs = {
  id: Scalars['Int']['input'];
};

export type QueryDimensionHistoryArgs = {
  id: Scalars['Int']['input'];
  version: Scalars['String']['input'];
};

export type QueryDimensionSetsByMeasureIdArgs = {
  measureId: Scalars['Float']['input'];
};

export type QueryDimensionsArgs = {
  aeQualifying?: InputMaybe<Scalars['Boolean']['input']>;
  diseaseStateModuleId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<DimensionType>;
};

export type QueryDiseaseStateModuleArgs = {
  id: Scalars['ID']['input'];
};

export type QueryDiseaseStateModulesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryDistributionListArgs = {
  id: Scalars['String']['input'];
};

export type QueryEchoFindingFieldsArgs = {
  caselistModuleName?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEchoFindingsArgs = {
  avStenosis?: InputMaybe<Scalars['String']['input']>;
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  caselistModuleName: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeFromAnalysis?: InputMaybe<Scalars['Int']['input']>;
  latestStudyOnRecord?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryEchoFollowupOptionArgs = {
  id: Scalars['String']['input'];
};

export type QueryEchoFollowupOptionsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryEchoMessageTemplateArgs = {
  id: Scalars['String']['input'];
};

export type QueryEchoPatientsVolumeArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  caselistModuleName: Scalars['String']['input'];
};

export type QueryEchoQuantifiedSeveritiesArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  caselistModuleName: Scalars['String']['input'];
};

export type QueryEchoReferringProviderArgs = {
  id: Scalars['String']['input'];
};

export type QueryEchoStudyStatusesArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  caselistModuleName: Scalars['String']['input'];
};

export type QueryEchocardiogramPatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryEcmoPatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryElementArgs = {
  id: Scalars['String']['input'];
};

export type QueryElementsArgs = {
  dictionaryId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  sectionId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEpdiPatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryExpiringDeadlineForDatasetArgs = {
  datasetId: Scalars['Int']['input'];
};

export type QueryExplicitCareEntityUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFavoriteViewsArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  tenantId: Scalars['String']['input'];
};

export type QueryFileArgs = {
  id: Scalars['String']['input'];
};

export type QueryFileAccessLogsArgs = {
  fileId: Scalars['String']['input'];
};

export type QueryFilteredStrategiesArgs = {
  dsmId?: InputMaybe<Scalars['Int']['input']>;
  measureId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetGridViewArgs = {
  id: Scalars['String']['input'];
};

export type QueryGetGridViewsArgs = {
  gridId: Scalars['String']['input'];
};

export type QueryHeartFailurePatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryHomepageSectionArgs = {
  id: Scalars['String']['input'];
};

export type QueryIcdPatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryIdentityProviderArgs = {
  entityId: Scalars['String']['input'];
};

export type QueryIdentityProvidersArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryInitiativeUsersArgs = {
  dsmId: Scalars['Int']['input'];
  entityId: Scalars['String']['input'];
};

export type QueryJobArgs = {
  id: Scalars['String']['input'];
};

export type QueryJobProgressTreeArgs = {
  jobId: Scalars['String']['input'];
};

export type QueryJobsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  jobTypes?: InputMaybe<Array<JobType>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<JobEventType>>;
};

export type QueryLaaoPatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryLatestJobsArgs = {
  input: FindLatestJobsInput;
};

export type QueryLoginRouteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type QueryLoginRoutesArgs = {
  identityProvider?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryMeasureMetadataArgs = {
  id: Scalars['Int']['input'];
};

export type QueryMeasureMetadataHistoryArgs = {
  id: Scalars['Int']['input'];
  version: Scalars['String']['input'];
};

export type QueryMeasuresByDsmCachedArgs = {
  diseaseStateModuleId: Scalars['Int']['input'];
};

export type QueryMeasuresMetadataArgs = {
  diseaseStateModuleId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryMitraclipPatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryObjectiveArgs = {
  id: Scalars['ID']['input'];
};

export type QueryObjectiveAttachPreviewArgs = {
  input: ObjectiveAttachPreviewInput;
};

export type QueryObjectiveStrategiesArgs = {
  objectiveId: Scalars['ID']['input'];
};

export type QueryObjectiveStrategyArgs = {
  id: Scalars['ID']['input'];
};

export type QueryObjectiveStrategyTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type QueryObjectiveTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type QueryOutboundMessageArgs = {
  id: Scalars['String']['input'];
};

export type QueryOutboundMessagesArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  recipientId?: InputMaybe<Scalars['String']['input']>;
  requesterId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryPatientListAttributesArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  measureIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type QueryPatientListAvailableQuartersArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  measureIds: Array<Scalars['Int']['input']>;
  patientListType: PatientListType;
};

export type QueryPatientListFieldsArgs = {
  patientListType: Scalars['String']['input'];
};

export type QueryPatientListMaxStudyDateArgs = {
  dsmId: Scalars['Int']['input'];
  patientListType: PatientListType;
};

export type QueryPerformanceManagerStrategiesArgs = {
  careEntity: Scalars['String']['input'];
  initiativeId: Scalars['Float']['input'];
  registry: Scalars['String']['input'];
};

export type QueryPipelineElementArgs = {
  id: Scalars['String']['input'];
};

export type QueryPipelineElementsArgs = {
  dsmId?: InputMaybe<Scalars['Float']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryPoliciesArgs = {
  enforcerType: Scalars['String']['input'];
  subjects: Array<Scalars['String']['input']>;
};

export type QueryPresentationArgs = {
  id: Scalars['String']['input'];
};

export type QueryPresentationsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPublicFileArgs = {
  id: Scalars['String']['input'];
};

export type QueryPublicFileAccessLogsArgs = {
  fileId: Scalars['String']['input'];
};

export type QueryQuestionDetailsArgs = {
  question: Scalars['String']['input'];
};

export type QueryRecentTableauViewArgs = {
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
  tenantId: Scalars['String']['input'];
};

export type QueryReportArgs = {
  id: Scalars['String']['input'];
};

export type QueryReportAttributesArgs = {
  dateColumn: Scalars['String']['input'];
  diseaseStateModuleId: Scalars['Int']['input'];
};

export type QueryRiskAuditAttributesArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  diseaseStateModuleId: Scalars['Int']['input'];
};

export type QueryRiskAuditChartsDataArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  diseaseStateModuleId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  flagTypes?: InputMaybe<Array<FlagType>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryRiskAuditFieldsArgs = {
  diseaseStateModuleId: Scalars['Int']['input'];
};

export type QueryRiskAuditOutcomesArgs = {
  careEntityId: Scalars['String']['input'];
  dsmId: Scalars['Int']['input'];
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryRiskAuditsArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  diseaseStateModuleId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  flagTypes?: InputMaybe<Array<FlagType>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryRlsAllowedCareEntityCodesArgs = {
  diseaseStateModuleId: Scalars['Int']['input'];
  type?: InputMaybe<CareEntityType>;
};

export type QueryRlsAllowedContextsArgs = {
  diseaseStateModuleId: Scalars['Int']['input'];
};

export type QueryRoiMetricArgs = {
  id: Scalars['String']['input'];
};

export type QueryRoiMetricHistoryArgs = {
  id: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type QueryRoleArgs = {
  id: Scalars['String']['input'];
};

export type QueryRolesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QuerySearchElementsArgs = {
  dictionaryId: Scalars['String']['input'];
  keyword: Scalars['String']['input'];
};

export type QuerySrogArgs = {
  careEntityCode: Scalars['String']['input'];
  dsmCode?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SrogFilter>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type QueryStrokePatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryStsPatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuerySubmissionArgs = {
  id: Scalars['String']['input'];
};

export type QuerySubmissionAccessLogsArgs = {
  submissionId: Scalars['String']['input'];
};

export type QuerySubmissionInquiryArgs = {
  id: Scalars['Int']['input'];
};

export type QuerySubmissionPresentationsArgs = {
  quarters: Array<Scalars['String']['input']>;
};

export type QueryTableauViewArgs = {
  id: Scalars['Int']['input'];
};

export type QueryTableauViewsArgs = {
  measureIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type QueryTavrPatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryTenantArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryTenantDiseaseStateModulesArgs = {
  tenantId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryTenantFilesArgs = {
  category: FileCategory;
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryTenantOffboardingDiscoveryArgs = {
  id: Scalars['String']['input'];
};

export type QueryTenantOffboardingEligibleApproversArgs = {
  tenantId: Scalars['String']['input'];
};

export type QueryTenantOffboardingJobArgs = {
  tenantId: Scalars['String']['input'];
};

export type QueryTenantOffboardingJobByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryTenantOffboardingManifestArgs = {
  compareTo?: InputMaybe<Scalars['Int']['input']>;
  discoveryId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

export type QueryTenantOffboardingVersionsArgs = {
  id: Scalars['String']['input'];
};

export type QueryTenantUsersArgs = {
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryTenantWorkbooksArgs = {
  tenantId: Scalars['String']['input'];
};

export type QueryTenantsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type QueryThreadArgs = {
  id: Scalars['ID']['input'];
};

export type QueryThreadByEntityArgs = {
  entityId: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
};

export type QueryTricuspidPatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryUserArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type QueryUserAccessChangesArgs = {
  userId: Scalars['ID']['input'];
};

export type QueryUserFilesArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryUserLockedArgs = {
  username: Scalars['String']['input'];
};

export type QueryUserRelationshipTablesArgs = {
  userId: Scalars['String']['input'];
};

export type QueryUsersByNotificationTypeArgs = {
  notificationType: NotificationType;
};

export type QueryVadPatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryValidateEmailArgs = {
  email: Scalars['String']['input'];
};

export type QueryValidateUsernameArgs = {
  username: Scalars['String']['input'];
};

export type QueryVascularPatientListArgs = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measureIds: Array<Scalars['Int']['input']>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryVideoGuidesArgs = {
  maxResults?: InputMaybe<Scalars['Float']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryWorkbookArgs = {
  id: Scalars['Int']['input'];
};

export type QueryWorkbookGroupArgs = {
  id: Scalars['Int']['input'];
};

export type QueryWorkbookGroupsArgs = {
  filterInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryWorkbooksArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Range = {
  __typename?: 'Range';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  element: Element;
  id: Scalars['ID']['output'];
  unitOfMeasure?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  usualRangeMax?: Maybe<Scalars['Float']['output']>;
  usualRangeMin?: Maybe<Scalars['Float']['output']>;
  validRangeMax?: Maybe<Scalars['Float']['output']>;
  validRangeMin?: Maybe<Scalars['Float']['output']>;
};

export type RecentTableauView = {
  __typename?: 'RecentTableauView';
  /** Unique id for this recent tableau view */
  id: Scalars['ID']['output'];
  /** Tableau view the user visited */
  tableauView: TableauView;
  /** Tenant the dashboard was viewed in */
  tenant: Tenant;
  /** Tenant the dashboard was viewed in */
  tenantId: Scalars['String']['output'];
  /** The date the user visited the dashboard */
  viewedAt: Scalars['DateTime']['output'];
  /** User who visited the dashboard */
  viewedBy: User;
};

export type ReminderLog = {
  __typename?: 'ReminderLog';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  followUpDisabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  month?: Maybe<Month>;
  quarter?: Maybe<Quarter>;
  submission: Submission;
  submissionId: Scalars['String']['output'];
  type: ReminderTrigger;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export enum ReminderTrigger {
  Automated = 'Automated',
  AutomatedFollowUp = 'AutomatedFollowUp',
  Manual = 'Manual',
}

export type Report = {
  __typename?: 'Report';
  /** Creation Datetime */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dateColumn: Scalars['String']['output'];
  dateRangeType?: Maybe<DateRangeTypes>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dimensions?: Maybe<Array<Dimension>>;
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModuleId: Scalars['Int']['output'];
  distributionLists?: Maybe<Array<DistributionList>>;
  endDate?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<File>>;
  id: Scalars['ID']['output'];
  measures?: Maybe<Array<MeasureMetadata>>;
  name: Scalars['String']['output'];
  procedures?: Maybe<Array<Scalars['String']['output']>>;
  quarters?: Maybe<Array<Scalars['String']['output']>>;
  registryElements?: Maybe<Array<Element>>;
  startDate?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
  /** Modification Datetime */
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  users?: Maybe<Array<User>>;
};

export type ReportAnchorDate = {
  __typename?: 'ReportAnchorDate';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModuleId: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  displayRank: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  visibility: VisibilityType;
};

export type ReportAttributes = {
  __typename?: 'ReportAttributes';
  /** The procedures the dashboards open on, among `procedures`. Empty when they open on all of them. */
  defaultProcedures?: Maybe<Array<Scalars['String']['output']>>;
  maxDate?: Maybe<Scalars['DateTime']['output']>;
  minDate?: Maybe<Scalars['DateTime']['output']>;
  procedures?: Maybe<Array<Scalars['String']['output']>>;
  refreshDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ReportInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dateColumn: Scalars['String']['input'];
  dateRangeType?: InputMaybe<DateRangeTypes>;
  dimensions?: InputMaybe<Array<UpdateDimensionInput>>;
  diseaseStateModuleId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  measures?: InputMaybe<Array<UpdateMeasureMetadataInput>>;
  name: Scalars['String']['input'];
  procedures?: InputMaybe<Array<Scalars['String']['input']>>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  registryElements?: InputMaybe<Array<UpdateElementInput>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<UpdateTenantInput>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type RequestTenantOffboardingInput = {
  approvalTicketUrl: Scalars['String']['input'];
  /** Exactly two distinct approvers */
  approverIds: Array<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

export type RequiredPolicy = {
  __typename?: 'RequiredPolicy';
  action: Action;
  attribute?: Maybe<Scalars['String']['output']>;
  dsmId?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  objectType: EnforcerType;
  resource?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  workbookGroupId?: Maybe<Scalars['String']['output']>;
  workbookId?: Maybe<Scalars['String']['output']>;
};

export type RiskAudit = {
  __typename?: 'RiskAudit';
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  auditFlagSource?: Maybe<Scalars['String']['output']>;
  auditId: Scalars['Float']['output'];
  biomeETLVersion?: Maybe<Scalars['String']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomeUpdateDt?: Maybe<Scalars['DateTime']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityCode?: Maybe<Scalars['String']['output']>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  careEntityName?: Maybe<Scalars['String']['output']>;
  diagnosisPOACodeList?: Maybe<Scalars['String']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDate?: Maybe<Scalars['DateTime']['output']>;
  dischargeQuarter?: Maybe<Scalars['String']['output']>;
  dischargeYear?: Maybe<Scalars['String']['output']>;
  diseaseStateModule?: Maybe<DiseaseStateModule>;
  diseaseStateModuleId?: Maybe<Scalars['String']['output']>;
  drgCode?: Maybe<Scalars['String']['output']>;
  encounterId?: Maybe<Scalars['String']['output']>;
  etlRefresh?: Maybe<Scalars['DateTime']['output']>;
  flagType?: Maybe<FlagType>;
  icd10TriggerCode?: Maybe<Scalars['String']['output']>;
  keyField?: Maybe<Scalars['String']['output']>;
  keyFieldValue?: Maybe<Scalars['String']['output']>;
  mrn?: Maybe<Scalars['String']['output']>;
  mrnOriginal?: Maybe<Scalars['String']['output']>;
  netRevenue?: Maybe<Scalars['Float']['output']>;
  pciIndication?: Maybe<Scalars['String']['output']>;
  pciStatus?: Maybe<Scalars['String']['output']>;
  physician?: Maybe<Scalars['String']['output']>;
  procedure?: Maybe<Scalars['String']['output']>;
  procedureDate?: Maybe<Scalars['DateTime']['output']>;
  procedureGroup?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  reviewTriggerDescription?: Maybe<Scalars['String']['output']>;
  riskReview?: Maybe<Scalars['String']['output']>;
  riskValue?: Maybe<Scalars['String']['output']>;
  surgicalQuarter?: Maybe<Scalars['String']['output']>;
  surgicalYear?: Maybe<Scalars['String']['output']>;
  tenantCode?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  trails: Array<RiskAuditTrail>;
  visitId?: Maybe<Scalars['Float']['output']>;
  visitTiming?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

export type RiskAuditAttributes = {
  __typename?: 'RiskAuditAttributes';
  availableQuarters: Array<Scalars['String']['output']>;
  biomeLatestRefreshDate: Scalars['DateTime']['output'];
  maxStudyDate: Scalars['DateTime']['output'];
};

export type RiskAuditChartsData = {
  __typename?: 'RiskAuditChartsData';
  auditFlagSummary: Array<AuditFlagSummary>;
  auditFlagTypes: Array<RiskAuditFlagType>;
  auditStatuses: Array<CaseStudyStatus>;
};

export type RiskAuditField = {
  __typename?: 'RiskAuditField';
  category: RiskAuditFieldCategory;
  common: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description: Scalars['String']['output'];
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModuleId: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  displayRank: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phi: Scalars['Boolean']['output'];
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['String']['output']>;
  tenantName?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  visibility: VisibilityType;
};

export enum RiskAuditFieldCategory {
  Biome = 'BIOME',
  PatientStudyDemographics = 'PATIENT_STUDY_DEMOGRAPHICS',
  RiskAuditVariables = 'RISK_AUDIT_VARIABLES',
}

export type RiskAuditFlagType = {
  __typename?: 'RiskAuditFlagType';
  count: Scalars['Int']['output'];
  riskValue: Scalars['String']['output'];
};

export type RiskAuditOutcomesResponse = {
  __typename?: 'RiskAuditOutcomesResponse';
  outcomes: Array<RiskOutcomeTrackingOutput>;
  quarters: Array<Scalars['String']['output']>;
};

export type RiskAuditTrail = {
  __typename?: 'RiskAuditTrail';
  auditTask?: Maybe<RiskAudit>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  diseaseStateModuleId: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  latestStudyOnRecord: Scalars['Boolean']['output'];
  notes: Scalars['String']['output'];
  /** Tracks the status of audit trail */
  status: RiskAuditTrailStatus;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type RiskAuditTrailInput = {
  auditTask: UpdateRiskAuditInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  diseaseStateModuleId: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  latestStudyOnRecord?: InputMaybe<Scalars['Boolean']['input']>;
  notes: Scalars['String']['input'];
  /** Tracks the status of audit trail */
  status: RiskAuditTrailStatus;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  updateById?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['Int']['input'];
};

export enum RiskAuditTrailStatus {
  ReviewAcceptedAndUpdated = 'ReviewAcceptedAndUpdated',
  ReviewRejected = 'ReviewRejected',
  ReviewRequired = 'ReviewRequired',
}

export type RiskMetric = {
  __typename?: 'RiskMetric';
  columnName: Scalars['String']['output'];
  developmentMeasures?: Maybe<Array<DevelopmentMeasure>>;
  diseaseStateModule: DiseaseStateModule;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  measureMetadatas?: Maybe<Array<MeasureMetadata>>;
};

export type RiskMetricDeletionActionInput = {
  replacementRiskMetricId?: InputMaybe<Scalars['ID']['input']>;
  riskMetricId: Scalars['ID']['input'];
};

export type RiskOutcomeTrackingOutput = {
  __typename?: 'RiskOutcomeTrackingOutput';
  aggLevel?: Maybe<Scalars['String']['output']>;
  auditId: Scalars['Float']['output'];
  biomeUpdateDt?: Maybe<Scalars['String']['output']>;
  calibration?: Maybe<Scalars['Float']['output']>;
  careEntityCode?: Maybe<Scalars['String']['output']>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  expected?: Maybe<Scalars['Float']['output']>;
  measureId?: Maybe<Scalars['Float']['output']>;
  measureName?: Maybe<Scalars['String']['output']>;
  observed?: Maybe<Scalars['Float']['output']>;
  oer?: Maybe<Scalars['Float']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  procedure?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  recordTiming?: Maybe<Scalars['String']['output']>;
  registry?: Maybe<Scalars['String']['output']>;
  tenantCode?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
};

export enum RlsUserContextType {
  Clinician = 'Clinician',
  Hospital = 'Hospital',
  Region = 'Region',
  System = 'System',
}

export type RoiMetric = {
  __typename?: 'RoiMetric';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  diseaseStateModule: DiseaseStateModule;
  fieldName: Scalars['String']['output'];
  higherIsBetter: Scalars['Boolean']['output'];
  history: Array<RoiMetricHistory>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  legacyDescription?: Maybe<Scalars['String']['output']>;
  pipelineElement?: Maybe<PipelineElement>;
  pipelineElementId?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

export type RoiMetricHistory = {
  __typename?: 'RoiMetricHistory';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  fieldName: Scalars['String']['output'];
  higherIsBetter: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  legacyDescription?: Maybe<Scalars['String']['output']>;
  pipelineElementId?: Maybe<Scalars['String']['output']>;
  roiMetricId: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  version: Scalars['String']['output'];
};

export type Role = {
  __typename?: 'Role';
  careEntities?: Maybe<Array<CareEntity>>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description: Scalars['String']['output'];
  diseaseStateModules?: Maybe<Array<DiseaseStateModule>>;
  id: Scalars['ID']['output'];
  identityProviders: Array<IdentityProvider>;
  jobs?: Maybe<Array<Job>>;
  name: Scalars['String']['output'];
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
  type: RoleType;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  users?: Maybe<Array<User>>;
};

export enum RoleType {
  AdminConsoleReporting = 'ADMIN_CONSOLE_REPORTING',
  BiomePk = 'BIOME_PK',
  BiomeUs = 'BIOME_US',
  Collaborator = 'COLLABORATOR',
  Custom = 'CUSTOM',
  EchoSurveillanceModerator = 'ECHO_SURVEILLANCE_MODERATOR',
  EchoSurveillant = 'ECHO_SURVEILLANT',
  SuperUser = 'SUPER_USER',
  TenantAdmin = 'TENANT_ADMIN',
  WorkflowAuthorizationSpecialist = 'WORKFLOW_AUTHORIZATION_SPECIALIST',
  WorkflowCareCoordinator = 'WORKFLOW_CARE_COORDINATOR',
  WorkflowClinicalLead = 'WORKFLOW_CLINICAL_LEAD',
  WorkflowReportingViewer = 'WORKFLOW_REPORTING_VIEWER',
}

export enum Scope {
  Global = 'GLOBAL',
  Hidden = 'HIDDEN',
  Tenant = 'TENANT',
  User = 'USER',
}

export type Section = {
  __typename?: 'Section';
  cardinality: CardinalityType;
  children?: Maybe<Array<Section>>;
  containerClass?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dictionary: Dictionary;
  dictionaryId: Scalars['String']['output'];
  elements: Array<Element>;
  hideFromReports: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  parent?: Maybe<Section>;
  parentId?: Maybe<Scalars['ID']['output']>;
  sectionCode: Scalars['String']['output'];
  sectionDisplayName: Scalars['String']['output'];
  sectionType: SectionType;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type SectionInput = {
  id: Scalars['ID']['input'];
};

export enum SectionType {
  RepeatSection = 'RepeatSection',
  Section = 'Section',
}

export type Selection = {
  __typename?: 'Selection';
  code?: Maybe<Scalars['String']['output']>;
  codeSystem?: Maybe<Scalars['String']['output']>;
  codeSystemName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  displayOrder?: Maybe<Scalars['Int']['output']>;
  element: Element;
  id: Scalars['ID']['output'];
  parentChildValidations?: Maybe<Array<ParentChildValidation>>;
  selectionDefinition?: Maybe<Scalars['String']['output']>;
  selectionName: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type SendInquiryInput = {
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  message: Scalars['String']['input'];
  recipientEmail: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type SendInquiryResponse = {
  __typename?: 'SendInquiryResponse';
  success: Scalars['Boolean']['output'];
  supportEmailId?: Maybe<Scalars['String']['output']>;
};

export type Slide = {
  __typename?: 'Slide';
  configuredDashboard?: Maybe<TableauView>;
  configuredDashboardId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  defaultCropConfig: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<File>;
  imageConfig?: Maybe<SlideImageConfig>;
  imageFetchedAt?: Maybe<Scalars['DateTime']['output']>;
  imageStatus: SlideImageStatus;
  isNative?: Maybe<Scalars['Boolean']['output']>;
  order: Scalars['Int']['output'];
  presentation: Presentation;
  presentationId: Scalars['String']['output'];
  shareableLink?: Maybe<Scalars['String']['output']>;
  slideType: SlideType;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type SlideImageConfig = {
  __typename?: 'SlideImageConfig';
  height?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export enum SlideImageStatus {
  NonApplicable = 'NonApplicable',
  PendingRefresh = 'PendingRefresh',
  Ready = 'Ready',
  RefreshFailed = 'RefreshFailed',
  Unavailable = 'Unavailable',
}

export enum SlideTemplate {
  AppComponent = 'AppComponent',
  Placeholder = 'Placeholder',
  Section = 'Section',
}

export enum SlideType {
  Compass = 'Compass',
  Dashboard = 'Dashboard',
  Echo = 'Echo',
  InitiativeDetail = 'InitiativeDetail',
  Kb = 'Kb',
  Oe = 'Oe',
  Placeholder = 'Placeholder',
  Pm = 'Pm',
  RiskAudit = 'RiskAudit',
  Section = 'Section',
  VariationAndBenchmarking = 'VariationAndBenchmarking',
}

export enum SortType {
  Alphabetical = 'ALPHABETICAL',
  BiomeSpecified = 'BIOME_SPECIFIED',
  Custom = 'CUSTOM',
  MetricPerformance = 'METRIC_PERFORMANCE',
  QualifyingCases = 'QUALIFYING_CASES',
}

export type Srog = {
  __typename?: 'Srog';
  Gain: Array<SrogSummaryDto>;
  Opportunity: Array<SrogSummaryDto>;
  Regression: Array<SrogSummaryDto>;
  Strength: Array<SrogSummaryDto>;
};

export enum SrogBucket {
  Gain = 'Gain',
  Opportunity = 'Opportunity',
  Regression = 'Regression',
  Strength = 'Strength',
}

export type SrogFilter = {
  buckets?: InputMaybe<Array<SrogBucket>>;
  cohortId?: InputMaybe<Scalars['Float']['input']>;
  perspectives?: InputMaybe<Array<OpportunityType>>;
  preference?: InputMaybe<OpportunityPreference>;
  trends?: InputMaybe<Array<OpportunityTrend>>;
};

export type SrogSummaryDto = {
  __typename?: 'SrogSummaryDto';
  ace?: Maybe<Scalars['Boolean']['output']>;
  aggregated?: Maybe<Scalars['Boolean']['output']>;
  atBestPerformance?: Maybe<Scalars['Boolean']['output']>;
  averageLOS?: Maybe<Scalars['Float']['output']>;
  averageROI?: Maybe<Scalars['Float']['output']>;
  bestLOS?: Maybe<Scalars['Float']['output']>;
  bestROI?: Maybe<Scalars['Float']['output']>;
  childGains?: Maybe<Scalars['Float']['output']>;
  childOpportunities?: Maybe<Scalars['Float']['output']>;
  childRegressions?: Maybe<Scalars['Float']['output']>;
  childStrengths?: Maybe<Scalars['Float']['output']>;
  cohortId?: Maybe<Scalars['Float']['output']>;
  cohortName?: Maybe<Scalars['String']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  dimType: DimType;
  dimensions?: Maybe<Scalars['String']['output']>;
  distanceSort?: Maybe<Scalars['Float']['output']>;
  eligibleCases?: Maybe<Scalars['Int']['output']>;
  formattedPerformance?: Maybe<Scalars['String']['output']>;
  hospital: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  measure?: Maybe<MeasureMetadata>;
  measureId?: Maybe<Scalars['Float']['output']>;
  metricWanted: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numerator?: Maybe<Scalars['Float']['output']>;
  numeratorIfBest?: Maybe<Scalars['Float']['output']>;
  numeratorIfMedian?: Maybe<Scalars['Float']['output']>;
  numeratorImpactIfAverage?: Maybe<Scalars['Float']['output']>;
  numeratorImpactIfBest?: Maybe<Scalars['Float']['output']>;
  opportunities?: Maybe<Array<OpportunityPercentileEntry>>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  percentOfBest?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  rareEvent?: Maybe<Scalars['Float']['output']>;
  registry: Scalars['String']['output'];
  srogBucket: SrogBucket;
  srogStrength?: Maybe<Scalars['Float']['output']>;
  summaryInitiativeMeasure?: Maybe<Scalars['Boolean']['output']>;
  summedAverageROI?: Maybe<Scalars['Float']['output']>;
  system: Scalars['String']['output'];
  systemSortOrder?: Maybe<Scalars['Int']['output']>;
  /** Number of child entities (in case of an aggregated entity) that were assessed in the SROG */
  totalChildCareEntities?: Maybe<Scalars['Int']['output']>;
  trendToUse?: Maybe<OpportunityTrend>;
  units?: Maybe<Scalars['String']['output']>;
  valueX?: Maybe<Scalars['String']['output']>;
  valueY?: Maybe<Scalars['String']['output']>;
};

export type StrategyBoardPolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['String']['input'];
  eft?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type StrategyParticipant = {
  __typename?: 'StrategyParticipant';
  createdAt: Scalars['DateTime']['output'];
  /** Free text username/email for external participants not in User table */
  externalUsername?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role: ParticipantRole;
  strategy: ObjectiveStrategy;
  strategyId: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type Stroke = {
  __typename?: 'Stroke';
  Status?: Maybe<Scalars['String']['output']>;
  aSAHClippedorCoiled?: Maybe<Scalars['String']['output']>;
  adminAdmissionDayOfWeek?: Maybe<Scalars['String']['output']>;
  adminDataZipCode?: Maybe<Scalars['String']['output']>;
  adminDischargeDayOfWeek?: Maybe<Scalars['String']['output']>;
  adminMatch?: Maybe<Scalars['Float']['output']>;
  admitSource?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  ageGroup?: Maybe<Scalars['String']['output']>;
  ahastr13Elligible?: Maybe<Scalars['String']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  aneurysmalSAH?: Maybe<Scalars['String']['output']>;
  arrivalDayOfWeek?: Maybe<Scalars['String']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  arrivalShift?: Maybe<Scalars['String']['output']>;
  bedDays?: Maybe<Scalars['Float']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  caseType?: Maybe<Scalars['String']['output']>;
  clinicianAFirstName?: Maybe<Scalars['String']['output']>;
  clinicianALastName?: Maybe<Scalars['String']['output']>;
  compReperf?: Maybe<Scalars['String']['output']>;
  conditionGrouper?: Maybe<Scalars['String']['output']>;
  daysToReadmission?: Maybe<Scalars['Int']['output']>;
  delayEligibilityReasonsAny?: Maybe<Scalars['String']['output']>;
  delayMedicalReasonAny?: Maybe<Scalars['String']['output']>;
  delayMins?: Maybe<Scalars['String']['output']>;
  delayReason?: Maybe<Scalars['String']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  dischargeDisposition?: Maybe<Scalars['String']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  drgCode?: Maybe<Scalars['String']['output']>;
  drgName?: Maybe<Scalars['String']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  edpatientYN?: Maybe<Scalars['String']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  ivThrombolyisStarted?: Maybe<Scalars['String']['output']>;
  ivtPATiming?: Maybe<Scalars['String']['output']>;
  lastKnownWellTimingBand?: Maybe<Scalars['String']['output']>;
  locationOfStrokeSymptoms?: Maybe<Scalars['String']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  methodPatientArrival?: Maybe<Scalars['String']['output']>;
  modifiedRankinScale?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  nihssTotalScoreBucket?: Maybe<Scalars['String']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  overall?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  payor?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  procedureEvent?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  sedationType?: Maybe<Scalars['String']['output']>;
  strokeEtiology?: Maybe<Scalars['String']['output']>;
  strokeRelatedDiagnosis?: Maybe<Scalars['String']['output']>;
  treatmentType?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
};

export type Sts = {
  __typename?: 'Sts';
  aLOSPostProcMedSurgNumerator?: Maybe<Scalars['Float']['output']>;
  adminAdmitSource?: Maybe<Scalars['String']['output']>;
  adminMatch?: Maybe<Scalars['Float']['output']>;
  admissionDayOfWeek?: Maybe<Scalars['String']['output']>;
  admitSource?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  ageGroup?: Maybe<Scalars['String']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  anyBloodProduct?: Maybe<Scalars['Int']['output']>;
  anyReOperative?: Maybe<Scalars['String']['output']>;
  arrivalDayOfWeek?: Maybe<Scalars['String']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  biomeConditionGroup?: Maybe<Scalars['String']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomePayor?: Maybe<Scalars['String']['output']>;
  cabgValve?: Maybe<Scalars['String']['output']>;
  cardiacPresentationOnAdmit?: Maybe<Scalars['String']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  cathPCIBeforeSurg?: Maybe<Scalars['String']['output']>;
  clinicianAFirstName?: Maybe<Scalars['String']['output']>;
  clinicianALastName?: Maybe<Scalars['String']['output']>;
  complicationList?: Maybe<Scalars['String']['output']>;
  contributionMargin?: Maybe<Scalars['Float']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDayOfWeek?: Maybe<Scalars['String']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  dischargeLocation?: Maybe<Scalars['String']['output']>;
  drgCode?: Maybe<Scalars['Int']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  ejectionFractionBucket?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  initialICUDaysNumerator?: Maybe<Scalars['Float']['output']>;
  isAnyBloodIntraOp?: Maybe<Scalars['String']['output']>;
  isoValves?: Maybe<Scalars['String']['output']>;
  los?: Maybe<Scalars['Float']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  numOfDistalAnastomoses?: Maybe<Scalars['String']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  orEntryTimeBucket?: Maybe<Scalars['String']['output']>;
  orExitTimeBucket?: Maybe<Scalars['String']['output']>;
  otherProcList?: Maybe<Scalars['String']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  postOpLOSNumerator?: Maybe<Scalars['Float']['output']>;
  preOpHgbNumerator?: Maybe<Scalars['Float']['output']>;
  preOpLOSNumerator?: Maybe<Scalars['Float']['output']>;
  predRiskMortalityStrata?: Maybe<Scalars['String']['output']>;
  procedure?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  procedureOther?: Maybe<Scalars['String']['output']>;
  procedureSummary?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionConditionGroupLevel2?: Maybe<Scalars['String']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  registryReadmissionReason?: Maybe<Scalars['String']['output']>;
  rfHematocritNumerator?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stsComplication?: Maybe<Scalars['Int']['output']>;
  stsComplicationWithWithout?: Maybe<Scalars['String']['output']>;
  stsLowMedPredRiskOpMort?: Maybe<Scalars['String']['output']>;
  stsPredictedMortality?: Maybe<Scalars['Float']['output']>;
  stsReadmitDt?: Maybe<Scalars['DateTime']['output']>;
  surgeryDayOfWeek?: Maybe<Scalars['String']['output']>;
  surgeryTimeOfDay?: Maybe<Scalars['String']['output']>;
  ventilatorHourBucket?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
};

export type StsAudit = {
  __typename?: 'StsAudit';
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  auditFlagSource?: Maybe<Scalars['String']['output']>;
  auditId: Scalars['Float']['output'];
  biomeETLVersion?: Maybe<Scalars['String']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomeUpdateDt?: Maybe<Scalars['DateTime']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityCode?: Maybe<Scalars['String']['output']>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  careEntityName?: Maybe<Scalars['String']['output']>;
  diagnosisPOACodeList?: Maybe<Scalars['String']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDate?: Maybe<Scalars['DateTime']['output']>;
  dischargeQuarter?: Maybe<Scalars['String']['output']>;
  dischargeYear?: Maybe<Scalars['String']['output']>;
  diseaseStateModule?: Maybe<DiseaseStateModule>;
  diseaseStateModuleId?: Maybe<Scalars['String']['output']>;
  drgCode?: Maybe<Scalars['String']['output']>;
  encounterId?: Maybe<Scalars['String']['output']>;
  etlRefresh?: Maybe<Scalars['DateTime']['output']>;
  flagType?: Maybe<FlagType>;
  icd10TriggerCode?: Maybe<Scalars['String']['output']>;
  keyField?: Maybe<Scalars['String']['output']>;
  keyFieldValue?: Maybe<Scalars['String']['output']>;
  mrn?: Maybe<Scalars['String']['output']>;
  mrnOriginal?: Maybe<Scalars['String']['output']>;
  netRevenue?: Maybe<Scalars['Float']['output']>;
  pciIndication?: Maybe<Scalars['String']['output']>;
  pciStatus?: Maybe<Scalars['String']['output']>;
  physician?: Maybe<Scalars['String']['output']>;
  procedure?: Maybe<Scalars['String']['output']>;
  procedureDate?: Maybe<Scalars['DateTime']['output']>;
  procedureGroup?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  reviewTriggerDescription?: Maybe<Scalars['String']['output']>;
  riskReview?: Maybe<Scalars['String']['output']>;
  riskValue?: Maybe<Scalars['String']['output']>;
  surgicalQuarter?: Maybe<Scalars['String']['output']>;
  surgicalYear?: Maybe<Scalars['String']['output']>;
  tenantCode?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  trails: Array<StsAuditTrail>;
  visitId?: Maybe<Scalars['Float']['output']>;
  visitTiming?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

export type StsAuditTrail = {
  __typename?: 'StsAuditTrail';
  auditTask?: Maybe<StsAudit>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  diseaseStateModuleId: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  latestStudyOnRecord: Scalars['Boolean']['output'];
  notes: Scalars['String']['output'];
  /** Tracks the status of audit trail */
  status: RiskAuditTrailStatus;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export enum Subject {
  DistributionLists = 'DISTRIBUTION_LISTS',
  Roles = 'ROLES',
  Users = 'USERS',
}

export type Submission = {
  __typename?: 'Submission';
  aggregate: Scalars['Boolean']['output'];
  beats?: Maybe<Array<Beat>>;
  cadence: Scalars['String']['output'];
  careEntity: CareEntity;
  careEntityId: Scalars['String']['output'];
  ccEmails?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<Submission>>;
  clientDataFiles?: Maybe<Array<ClientDataFile>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataset: Dataset;
  datasetId: Scalars['Int']['output'];
  daysAfterDeadline: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  mrnCrosswalkRequired: Scalars['Boolean']['output'];
  mrnHarvestRequired: Scalars['Boolean']['output'];
  parent?: Maybe<Submission>;
  parentId?: Maybe<Scalars['String']['output']>;
  reminderLogs?: Maybe<Array<ReminderLog>>;
  sendReminders: Scalars['Boolean']['output'];
  submitNationalReport: Scalars['Boolean']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type SubmissionInput = {
  id: Scalars['ID']['input'];
};

export type SubmissionInquiry = {
  __typename?: 'SubmissionInquiry';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export enum SubmissionPriority {
  HighPriority = 'HighPriority',
  MediumPriority = 'MediumPriority',
}

export enum SubmissionReleaseState {
  Delivered = 'Delivered',
  MeetingRequested = 'MeetingRequested',
  MeetingScheduled = 'MeetingScheduled',
  PendingAdditionalRelease = 'PendingAdditionalRelease',
}

export type SubmissionStatusTrail = {
  __typename?: 'SubmissionStatusTrail';
  careEntity: CareEntity;
  careEntityId: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  dataReviewDate?: Maybe<Scalars['DateTime']['output']>;
  dataReviewMeeting: Scalars['Boolean']['output'];
  dataset: Dataset;
  datasetId: Scalars['Int']['output'];
  done: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isLatest: Scalars['Boolean']['output'];
  jiraLink?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<SubmissionPriority>;
  skeletonGenerated: Scalars['Boolean']['output'];
  skeletonRequired: Scalars['Boolean']['output'];
  status?: Maybe<SubmissionReleaseState>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export enum SubmissionStatusValue {
  Future = 'Future',
  Overdue = 'Overdue',
  Received = 'Received',
}

export enum SummaryCalculationType {
  Annualized = 'Annualized',
  Custom = 'Custom',
  Standard = 'Standard',
}

export type SupportEmail = {
  __typename?: 'SupportEmail';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  issueKey?: Maybe<Scalars['String']['output']>;
};

export enum SupportedApps {
  Ae = 'AE',
  Echo = 'ECHO',
  Oe = 'OE',
  Pm = 'PM',
  Reportbuilder = 'REPORTBUILDER',
  Riskaudit = 'RISKAUDIT',
}

export type TableauView = {
  __typename?: 'TableauView';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  primaryMeasureIds?: Maybe<Array<Scalars['Int']['output']>>;
  recentTableauViews?: Maybe<Array<RecentTableauView>>;
  renderInMenu: Scalars['Boolean']['output'];
  secondaryMeasureIds?: Maybe<Array<Scalars['Int']['output']>>;
  slides?: Maybe<Array<Slide>>;
  sortOrder: Scalars['Float']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  workbook: Workbook;
  workbookId: Scalars['Float']['output'];
};

export enum Tags {
  Clinical = 'Clinical',
  Financial = 'Financial',
  Phi = 'Phi',
}

export type Tavr = {
  __typename?: 'Tavr';
  adminMatch?: Maybe<Scalars['Float']['output']>;
  admissionDayOfWeek?: Maybe<Scalars['String']['output']>;
  admitSourceName?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  ageGroup?: Maybe<Scalars['String']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  anesthesiaType?: Maybe<Scalars['String']['output']>;
  anyReadmission?: Maybe<Scalars['String']['output']>;
  arrivalDayOfWeek?: Maybe<Scalars['String']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  biomeConditionGroup?: Maybe<Scalars['String']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomePayor?: Maybe<Scalars['String']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  clinicianALastName?: Maybe<Scalars['String']['output']>;
  clinicianBLastName?: Maybe<Scalars['String']['output']>;
  complicationList?: Maybe<Scalars['String']['output']>;
  contributionMargin?: Maybe<Scalars['Float']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDayOfWeek?: Maybe<Scalars['String']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  dischargeLocation?: Maybe<Scalars['String']['output']>;
  dischargeStatus?: Maybe<Scalars['String']['output']>;
  drgCode?: Maybe<Scalars['String']['output']>;
  drgName?: Maybe<Scalars['String']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  los?: Maybe<Scalars['Float']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  netRevenue?: Maybe<Scalars['Float']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  postProcedureAorticRegurgitation?: Maybe<Scalars['String']['output']>;
  predictedRiskOfMortality?: Maybe<Scalars['String']['output']>;
  procedureDayOfWeek?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  procedureGroup?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  readmissionType?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  registryReadmissionReason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tavrValvesVendors?: Maybe<Scalars['String']['output']>;
  tvtAccessSite?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
};

export type TavrAudit = {
  __typename?: 'TavrAudit';
  DRGCode?: Maybe<Scalars['String']['output']>;
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  auditFlagSource?: Maybe<Scalars['String']['output']>;
  auditId: Scalars['Float']['output'];
  biomeETLVersion?: Maybe<Scalars['String']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomeUpdateDt?: Maybe<Scalars['DateTime']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityCode?: Maybe<Scalars['String']['output']>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  careEntityName?: Maybe<Scalars['String']['output']>;
  diagnosisPOACodeList?: Maybe<Scalars['String']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDate?: Maybe<Scalars['DateTime']['output']>;
  dischargeQuarter?: Maybe<Scalars['String']['output']>;
  dischargeYear?: Maybe<Scalars['String']['output']>;
  diseaseStateModule?: Maybe<DiseaseStateModule>;
  diseaseStateModuleId?: Maybe<Scalars['String']['output']>;
  drgCode?: Maybe<Scalars['String']['output']>;
  encounterId?: Maybe<Scalars['String']['output']>;
  etlRefresh?: Maybe<Scalars['DateTime']['output']>;
  flagType?: Maybe<FlagType>;
  icd10TriggerCode?: Maybe<Scalars['String']['output']>;
  keyField?: Maybe<Scalars['String']['output']>;
  keyFieldValue?: Maybe<Scalars['String']['output']>;
  mrn?: Maybe<Scalars['String']['output']>;
  mrnOriginal?: Maybe<Scalars['String']['output']>;
  netRevenue?: Maybe<Scalars['Float']['output']>;
  pciIndication?: Maybe<Scalars['String']['output']>;
  pciStatus?: Maybe<Scalars['String']['output']>;
  physician?: Maybe<Scalars['String']['output']>;
  procedure?: Maybe<Scalars['String']['output']>;
  procedureDate?: Maybe<Scalars['DateTime']['output']>;
  procedureGroup?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  reviewTriggerDescription?: Maybe<Scalars['String']['output']>;
  riskReview?: Maybe<Scalars['String']['output']>;
  riskValue?: Maybe<Scalars['String']['output']>;
  surgicalQuarter?: Maybe<Scalars['String']['output']>;
  surgicalYear?: Maybe<Scalars['String']['output']>;
  tenantCode?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  trails: Array<TavrAuditTrail>;
  visitId?: Maybe<Scalars['Float']['output']>;
  visitTiming?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

export type TavrAuditTrail = {
  __typename?: 'TavrAuditTrail';
  auditTask?: Maybe<TavrAudit>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  diseaseStateModuleId: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  latestStudyOnRecord: Scalars['Boolean']['output'];
  notes: Scalars['String']['output'];
  /** Tracks the status of audit trail */
  status: RiskAuditTrailStatus;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** Tenant/Client */
export type Tenant = {
  __typename?: 'Tenant';
  active: Scalars['Boolean']['output'];
  aggregationTenant: Scalars['Boolean']['output'];
  applicationNotices?: Maybe<Array<ApplicationNotice>>;
  banner?: Maybe<File>;
  careEntities?: Maybe<Array<CareEntity>>;
  /** Schema name where audit, echo and cases data is available for tenant. If null, defaults to <tenantCode>_cases */
  casesSchema?: Maybe<Scalars['String']['output']>;
  clinicalOnly: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  contractedDisplayPHI: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  deliverableBlinded: Scalars['Boolean']['output'];
  dictionaries?: Maybe<Array<Dictionary>>;
  disableBiomedataLogin: Scalars['Boolean']['output'];
  disableHomepage: Scalars['Boolean']['output'];
  distributionLists?: Maybe<Array<DistributionList>>;
  documents?: Maybe<Array<File>>;
  echoFindingFields?: Maybe<Array<EchoFindingField>>;
  echoFollowupOptions?: Maybe<Array<EchoFindingFollowupOption>>;
  echoModules?: Maybe<Array<EchoFindingModule>>;
  encryptionKeys?: Maybe<Array<Scalars['String']['output']>>;
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  identityProvider?: Maybe<IdentityProvider>;
  /** IT contact email for the tenant. */
  itContact?: Maybe<Scalars['String']['output']>;
  jobs?: Maybe<Array<Job>>;
  logo?: Maybe<File>;
  name: Scalars['String']['output'];
  objectives?: Maybe<Array<Objective>>;
  /** Active offboarding request for this tenant, if any. */
  offboardingJob?: Maybe<TenantOffboardingJob>;
  organizationalUnit?: Maybe<Scalars['String']['output']>;
  presentations?: Maybe<Array<Presentation>>;
  projectSponsor?: Maybe<User>;
  projectSponsorId?: Maybe<Scalars['String']['output']>;
  riskAuditFields?: Maybe<Array<RiskAuditField>>;
  roles?: Maybe<Array<Role>>;
  rollupMode?: Maybe<AggregationRollupMode>;
  /** Restrict this tenant to a specific subdomain alias. */
  subdomain?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use clinicalOnly, which is this flag inverted. */
  submitsCostData: Scalars['Boolean']['output'];
  tokens?: Maybe<Array<Token>>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  users?: Maybe<Array<User>>;
  usesAnubisUpload: Scalars['Boolean']['output'];
  /** Workbooks the tenant sees, with all of their dashboards */
  workbooks?: Maybe<Array<Workbook>>;
};

export type TenantOffboardingApprover = {
  __typename?: 'TenantOffboardingApprover';
  approvedVersion?: Maybe<Scalars['Int']['output']>;
  approver?: Maybe<User>;
  approverId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  status: TenantOffboardingApproverStatus;
  tenantOffboardingJobId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum TenantOffboardingApproverStatus {
  Approved = 'Approved',
  Cleared = 'Cleared',
  Pending = 'Pending',
  Rejected = 'Rejected',
}

export type TenantOffboardingDeletion = {
  __typename?: 'TenantOffboardingDeletion';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  jobId?: Maybe<Scalars['String']['output']>;
  /** Kept entries of the version it ran against, same-target entries included */
  keptSources: Array<TenantOffboardingKeptSource>;
  outcome: TenantOffboardingDeletionOutcome;
  startedBy?: Maybe<User>;
  startedById?: Maybe<Scalars['String']['output']>;
  tenantOffboardingJobId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  validationFindings: Array<TenantOffboardingValidationFinding>;
  version: Scalars['Int']['output'];
};

export enum TenantOffboardingDeletionOutcome {
  Completed = 'Completed',
  Failed = 'Failed',
  ManifestChanged = 'ManifestChanged',
  Running = 'Running',
  ValidationFailed = 'ValidationFailed',
}

export type TenantOffboardingDiscovery = {
  __typename?: 'TenantOffboardingDiscovery';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  /** Entries of the compared version this discovery found gone; 0 until it finishes */
  goneCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  jobId?: Maybe<Scalars['String']['output']>;
  resultVersion?: Maybe<Scalars['Int']['output']>;
  status: TenantOffboardingDiscoveryStatus;
  tenantOffboardingJobId: Scalars['String']['output'];
  trigger: TenantOffboardingDiscoveryTrigger;
  triggeredBy?: Maybe<User>;
  triggeredById?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum TenantOffboardingDiscoveryStatus {
  Failed = 'Failed',
  NewVersion = 'NewVersion',
  NoChanges = 'NoChanges',
  Running = 'Running',
}

export enum TenantOffboardingDiscoveryTrigger {
  Approval = 'Approval',
  Cascade = 'Cascade',
  Deletion = 'Deletion',
  Rediscover = 'Rediscover',
  Request = 'Request',
}

export type TenantOffboardingJob = {
  __typename?: 'TenantOffboardingJob';
  approvalTicketUrl?: Maybe<Scalars['String']['output']>;
  approvers: Array<TenantOffboardingApprover>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledBy?: Maybe<User>;
  cancelledById?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  /** A deletion may have removed data, so a cancel leaves the tenant disabled. */
  deletionStarted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isCascade: Scalars['Boolean']['output'];
  latestDeletion?: Maybe<TenantOffboardingDeletion>;
  latestDiscovery?: Maybe<TenantOffboardingDiscovery>;
  latestVersion?: Maybe<Scalars['Int']['output']>;
  owner?: Maybe<User>;
  ownerId?: Maybe<Scalars['String']['output']>;
  status: TenantOffboardingJobStatus;
  tenantCode: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['String']['output']>;
  tenantWasActive?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum TenantOffboardingJobStatus {
  Approved = 'Approved',
  Cancelled = 'Cancelled',
  Destroyed = 'Destroyed',
  Destroying = 'Destroying',
  Failed = 'Failed',
  PendingApproval = 'PendingApproval',
  Rejected = 'Rejected',
  ValidationFailed = 'ValidationFailed',
}

export type TenantOffboardingKeptSource = {
  __typename?: 'TenantOffboardingKeptSource';
  container?: Maybe<Scalars['String']['output']>;
  datasource?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  leaf: Scalars['String']['output'];
  name: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  target: Scalars['String']['output'];
};

export type TenantOffboardingManifest = {
  __typename?: 'TenantOffboardingManifest';
  comparedToVersion?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  entries: Array<TenantOffboardingManifestEntry>;
  goneCount?: Maybe<Scalars['Int']['output']>;
  newCount?: Maybe<Scalars['Int']['output']>;
  version: Scalars['Int']['output'];
};

export type TenantOffboardingManifestEntry = {
  __typename?: 'TenantOffboardingManifestEntry';
  category: Scalars['String']['output'];
  /** Set only when the manifest is compared */
  change?: Maybe<ManifestEntryChange>;
  container?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  datasource?: Maybe<Scalars['String']['output']>;
  /** Stable across versions */
  key: Scalars['String']['output'];
  leaf: Scalars['String']['output'];
  name: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  target: Scalars['String']['output'];
  treePath: Array<Scalars['String']['output']>;
};

export type TenantOffboardingManifestVersionInfo = {
  __typename?: 'TenantOffboardingManifestVersionInfo';
  comparedToVersion?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  entryCount: Scalars['Int']['output'];
  goneCount?: Maybe<Scalars['Int']['output']>;
  newCount?: Maybe<Scalars['Int']['output']>;
  /** Null when no discovery is recorded for the version */
  trigger?: Maybe<TenantOffboardingDiscoveryTrigger>;
  triggeredBy?: Maybe<User>;
  version: Scalars['Int']['output'];
};

export type TenantOffboardingValidationFinding = {
  __typename?: 'TenantOffboardingValidationFinding';
  category: Scalars['String']['output'];
  error: Scalars['String']['output'];
  leftoverCount?: Maybe<Scalars['Int']['output']>;
  subStep: Scalars['String']['output'];
  target: Scalars['String']['output'];
};

export type TenantPolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  eft?: InputMaybe<Scalars['String']['input']>;
  objectType: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type Thread = {
  __typename?: 'Thread';
  comments: Array<Comment>;
  /** Total number of comments in this thread */
  commentsCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  /** Thread description */
  description?: Maybe<Scalars['String']['output']>;
  /** Generic entity ID this thread belongs to */
  entityId: Scalars['String']['output'];
  /** Generic entity type this thread belongs to */
  entityType: Scalars['String']['output'];
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  /** Whether thread is locked (no editing allowed) */
  isLocked: Scalars['Boolean']['output'];
  /** Whether thread is private (internal only) */
  isPrivate: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
  /** Thread title/name */
  title: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
};

/** JWT Token */
export type Token = {
  __typename?: 'Token';
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  revokedAt: Scalars['DateTime']['output'];
  status: TokenStatus;
  subject: User;
  subjectId: Scalars['String']['output'];
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
  /** JWT Token in hash format */
  token: Scalars['String']['output'];
  type: TokenType;
  updateAt: Scalars['DateTime']['output'];
};

export enum TokenStatus {
  Active = 'ACTIVE',
  Revoked = 'REVOKED',
}

export enum TokenType {
  Access = 'ACCESS',
  Email = 'EMAIL',
  Impersonate = 'IMPERSONATE',
  Longliving = 'LONGLIVING',
  PasswordChange = 'PASSWORD_CHANGE',
  Refresh = 'REFRESH',
}

export type Transformation = {
  __typename?: 'Transformation';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  delimiter?: Maybe<Scalars['String']['output']>;
  derivative?: Maybe<Element>;
  derivativeCode?: Maybe<Scalars['String']['output']>;
  derivativeId?: Maybe<Scalars['String']['output']>;
  derivativeValue?: Maybe<Scalars['String']['output']>;
  derivativeValueCode?: Maybe<Scalars['String']['output']>;
  exactMatch?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  reference?: Maybe<Element>;
  referenceCode: Scalars['String']['output'];
  referenceId: Scalars['String']['output'];
  translation: Translation;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  valueMap?: Maybe<Scalars['JSON']['output']>;
};

export type Translation = {
  __typename?: 'Translation';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source?: Maybe<Element>;
  sourceId?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Element>;
  targetId?: Maybe<Scalars['String']['output']>;
  transformation?: Maybe<Transformation>;
  transformationId?: Maybe<Scalars['String']['output']>;
  translatorConfig: TranslatorConfig;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  valueMap?: Maybe<Scalars['JSON']['output']>;
};

export type TranslatorConfig = {
  __typename?: 'TranslatorConfig';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataFeed?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  source: Dictionary;
  target: Dictionary;
  translations: Array<Translation>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type Tricuspid = {
  __typename?: 'Tricuspid';
  adminMatch?: Maybe<Scalars['Float']['output']>;
  admissionDayOfWeek?: Maybe<Scalars['String']['output']>;
  admitSourceName?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  ageGroup?: Maybe<Scalars['String']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  anesthesiaType?: Maybe<Scalars['String']['output']>;
  anyReadmission?: Maybe<Scalars['String']['output']>;
  arrivalDayOfWeek?: Maybe<Scalars['String']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  biomeConditionGroup?: Maybe<Scalars['String']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomePayor?: Maybe<Scalars['String']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  clinicianALastName?: Maybe<Scalars['String']['output']>;
  clinicianBLastName?: Maybe<Scalars['String']['output']>;
  contributionMargin?: Maybe<Scalars['Float']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDayOfWeek?: Maybe<Scalars['String']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  dischargeLocation?: Maybe<Scalars['String']['output']>;
  dischargeStatus?: Maybe<Scalars['String']['output']>;
  drgCode?: Maybe<Scalars['String']['output']>;
  drgName?: Maybe<Scalars['String']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  los?: Maybe<Scalars['Float']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  netRevenue?: Maybe<Scalars['Float']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  postProcedureAorticRegurgitation?: Maybe<Scalars['String']['output']>;
  predictedRiskOfMortality?: Maybe<Scalars['String']['output']>;
  procedureDayOfWeek?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  procedureGroup?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  registryReadmissionReason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tavrValvesVendors?: Maybe<Scalars['String']['output']>;
  tvtAccessSite?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
};

export enum TriggerGranularity {
  PerDsm = 'PerDsm',
  PerPipeline = 'PerPipeline',
}

export type TriggerablePipeline = {
  __typename?: 'TriggerablePipeline';
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  pipelineName: Scalars['String']['output'];
  pipelineType: DagsterTriggerPipelineType;
  supportedDsms?: Maybe<Array<DiseaseStateModule>>;
  triggerGranularity: TriggerGranularity;
  triggers?: Maybe<Array<DagsterTrigger>>;
  updateAt: Scalars['DateTime']['output'];
};

export type UpdateBookmarkInput = {
  category?: InputMaybe<BookmarkCategory>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<UpdateUserInput>>;
};

export type UpdateCareEntityInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  aggregated?: InputMaybe<Scalars['Boolean']['input']>;
  alternateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  anonymousCode?: InputMaybe<Scalars['String']['input']>;
  business?: InputMaybe<Scalars['String']['input']>;
  children?: InputMaybe<Array<UpdateCareEntityInput>>;
  city?: InputMaybe<Scalars['String']['input']>;
  cmsId?: InputMaybe<Scalars['String']['input']>;
  cmsIdNotAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  datasets?: InputMaybe<Array<UpdateDatasetInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  diseaseStateModules?: InputMaybe<Array<UpdateDiseaseStateModuleInput>>;
  /** DSMs this care entity participates in but neither reviews nor pushes. Absent leaves existing exclusions untouched; empty clears them; present is authoritative. */
  excludedDsms?: InputMaybe<Array<UpdateDiseaseStateModuleInput>>;
  id: Scalars['ID']['input'];
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  includeInBenchmarks?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceMonth?: InputMaybe<Scalars['Int']['input']>;
  isEngagementEntity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Per-member DSM scoping for this aggregate. Absent leaves scoping untouched; present is authoritative for this parent. Ignored on a nested child input. */
  memberDsms?: InputMaybe<Array<CareEntityMemberDsmInput>>;
  monthlySponsorTouchbase?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noOfBeds?: InputMaybe<Scalars['Int']['input']>;
  onboardingCompletedOn?: InputMaybe<Scalars['DateTime']['input']>;
  parents?: InputMaybe<Array<UpdateCareEntityInput>>;
  physicianChampion?: InputMaybe<Scalars['String']['input']>;
  projectSponsor?: InputMaybe<Scalars['String']['input']>;
  pushOnlyDsms?: InputMaybe<Array<UpdateDiseaseStateModuleInput>>;
  reasonForNoCmsId?: InputMaybe<Scalars['String']['input']>;
  reviewDsms?: InputMaybe<Array<UpdateDiseaseStateModuleInput>>;
  shortDisplayName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  submissions?: InputMaybe<Array<SubmissionInput>>;
  supportedApps?: InputMaybe<Array<SupportedApps>>;
  teaching?: InputMaybe<Scalars['Boolean']['input']>;
  tenants?: InputMaybe<Array<UpdateTenantInput>>;
  type?: InputMaybe<CareEntityType>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  usGeoRegion?: InputMaybe<UsGeoRegion>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClinicalProgramInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateCommentInput = {
  /** The comment content */
  content?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Track if comment was edited */
  isEdited?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent comment ID for nested replies */
  parentId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  /** Thread ID this comment belongs to */
  threadId?: InputMaybe<Scalars['String']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDatasetInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  crosswalkRequired?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isCrosswalkSource?: InputMaybe<Scalars['Boolean']['input']>;
  isDropAndLoad?: InputMaybe<Scalars['Boolean']['input']>;
  isRegistry?: InputMaybe<Scalars['Boolean']['input']>;
  isTenantLevel?: InputMaybe<Scalars['Boolean']['input']>;
  managingSociety?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if the dataset supports the report builder feature. */
  supportsReportBuilder?: InputMaybe<Scalars['Boolean']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateDatasetVersionFieldInput = {
  datasetVersion: UpdateDatasetVersionInput;
  fieldId: Scalars['Int']['input'];
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDatasetVersionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dataset?: InputMaybe<UpdateDatasetInput>;
  datasetVersionFields?: InputMaybe<Array<UpdateDatasetVersionFieldInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  versionNumber?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateDeadlineInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  id: Scalars['ID']['input'];
  monthIncluded?: InputMaybe<Scalars['String']['input']>;
  monthSubmissionDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  quarterIncluded?: InputMaybe<Scalars['String']['input']>;
  quarterSubmissionDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateDevelopmentDimensionInput = {
  aeQualifying?: InputMaybe<Scalars['Boolean']['input']>;
  allMeasures?: InputMaybe<Scalars['Boolean']['input']>;
  class?: InputMaybe<Scalars['String']['input']>;
  codeVersion?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensionId: Scalars['Int']['input'];
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  documentation?: InputMaybe<Scalars['JSON']['input']>;
  excludeValues?: InputMaybe<Array<Scalars['String']['input']>>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  hideFromReports?: InputMaybe<Scalars['Boolean']['input']>;
  isGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  jiraLink?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  legacyDescription?: InputMaybe<Scalars['String']['input']>;
  multiProcTableId?: InputMaybe<Scalars['String']['input']>;
  oeQualifying?: InputMaybe<Scalars['Boolean']['input']>;
  pipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  requirements?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sourceContinuousField?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<EntityState>;
  stateHistory?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EntityStatus>;
  type?: InputMaybe<DimensionType>;
  updateBy?: InputMaybe<UpdateUserInput>;
  valueMap?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateDevelopmentMeasureInput = {
  accessCategory?: InputMaybe<AccessCategory>;
  adjustment?: InputMaybe<Array<Scalars['String']['input']>>;
  aggregationFn?: InputMaybe<Array<Scalars['String']['input']>>;
  aggregationType?: InputMaybe<SummaryCalculationType>;
  annualMeasureBaseId?: InputMaybe<Scalars['String']['input']>;
  benchmarkExtraction?: InputMaybe<Scalars['Boolean']['input']>;
  codeVersion?: InputMaybe<Scalars['String']['input']>;
  commonMeasureDisplayName?: InputMaybe<Scalars['String']['input']>;
  commonMeasureQualifying?: InputMaybe<Scalars['Boolean']['input']>;
  costComponentMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dataTypeRequired?: InputMaybe<MeasureInputDataType>;
  denominatorColumnName?: InputMaybe<Scalars['String']['input']>;
  denominatorDocumentation?: InputMaybe<Scalars['JSON']['input']>;
  denominatorPipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  developedOn?: InputMaybe<Scalars['DateTime']['input']>;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  excludedCohortIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** The updateAt the client loaded. A measure saved since then is rejected with a conflict; omitted, the last write wins. */
  expectedUpdateAt?: InputMaybe<Scalars['DateTime']['input']>;
  family?: InputMaybe<MeasureFamily>;
  hideFromReports?: InputMaybe<Scalars['Boolean']['input']>;
  higherIsBetter?: InputMaybe<Scalars['Boolean']['input']>;
  includeColumnName?: InputMaybe<Scalars['String']['input']>;
  includeDocumentation?: InputMaybe<Scalars['JSON']['input']>;
  includePipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  isBenchmark?: InputMaybe<Scalars['Boolean']['input']>;
  jiraLink?: InputMaybe<Scalars['String']['input']>;
  losROIQualifying?: InputMaybe<Scalars['Boolean']['input']>;
  measureId: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  ncdrMeasureName?: InputMaybe<Scalars['String']['input']>;
  numeratorColumnName?: InputMaybe<Scalars['String']['input']>;
  numeratorDocumentation?: InputMaybe<Scalars['JSON']['input']>;
  numeratorPipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  numeratorUnit?: InputMaybe<Scalars['String']['input']>;
  opportunityType?: InputMaybe<Array<OpportunityType>>;
  outcomeType?: InputMaybe<MeasureOutcomeType>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  publicationSource?: InputMaybe<Array<PublicationSource>>;
  rareEvent?: InputMaybe<Scalars['Boolean']['input']>;
  registryMeasureId?: InputMaybe<Scalars['Int']['input']>;
  reportRowId?: InputMaybe<Scalars['Int']['input']>;
  requirements?: InputMaybe<Scalars['String']['input']>;
  riskAdjusted?: InputMaybe<Scalars['Boolean']['input']>;
  riskMetricDocumentation?: InputMaybe<Scalars['JSON']['input']>;
  riskMetricId?: InputMaybe<Scalars['String']['input']>;
  riskMetricPipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  roiCalcType?: InputMaybe<SummaryCalculationType>;
  /** Requires family and must differ from it; cleared when family is cleared. */
  secondaryFamily?: InputMaybe<MeasureFamily>;
  state?: InputMaybe<EntityState>;
  stateHistory?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EntityStatus>;
  summaryCohortId?: InputMaybe<Scalars['Float']['input']>;
  summaryInitiativeMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  tableName?: InputMaybe<Scalars['String']['input']>;
  testCapture?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  validationSource?: InputMaybe<Scalars['String']['input']>;
  volumeMeasure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDevelopmentRoiMetricInput = {
  codeVersion?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  documentation?: InputMaybe<Scalars['JSON']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  higherIsBetter?: InputMaybe<Scalars['Boolean']['input']>;
  jiraLink?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  legacyDescription?: InputMaybe<Scalars['String']['input']>;
  pipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  roiMetricId: Scalars['ID']['input'];
  state?: InputMaybe<EntityState>;
  stateHistory?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EntityStatus>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateDictionaryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dataFeed?: InputMaybe<CreateDictionaryInput>;
  dataset?: InputMaybe<UpdateDatasetInput>;
  feedDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  sections?: InputMaybe<Array<CreateSectionInput>>;
  tenants?: InputMaybe<Array<UpdateTenantInput>>;
  type?: InputMaybe<DictionaryType>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDictionaryPayloadInput = {
  dataset: UpdateDatasetInput;
  type: DictionaryType;
  version: Scalars['String']['input'];
};

export type UpdateDimensionInput = {
  aeQualifying?: InputMaybe<Scalars['Boolean']['input']>;
  allMeasures?: InputMaybe<Scalars['Boolean']['input']>;
  class?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensionValueSortOrder?: InputMaybe<
    Array<UpdateNestedDimensionValueSortOrderInput>
  >;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  excludeValues?: InputMaybe<Array<Scalars['String']['input']>>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  hideFromReports?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  isGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  legacyDescription?: InputMaybe<Scalars['String']['input']>;
  multiProcTableId?: InputMaybe<Scalars['String']['input']>;
  oeQualifying?: InputMaybe<Scalars['Boolean']['input']>;
  pipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  requirements?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<SortType>;
  sourceContinuousField?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DimensionType>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  valueMap?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateDiseaseStateModuleInput = {
  adjustment?: InputMaybe<Array<Scalars['String']['input']>>;
  aggregationFn?: InputMaybe<Array<Scalars['String']['input']>>;
  careEntities?: InputMaybe<Array<UpdateCareEntityInput>>;
  clinicalProgram?: InputMaybe<UpdateClinicalProgramInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  criticalDatasets?: InputMaybe<Array<UpdateDatasetInput>>;
  datasets?: InputMaybe<Array<UpdateDatasetInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  hideRiskAuditCharts?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  multiProcTableDeletionActions?: InputMaybe<
    Array<MultiProcTableDeletionActionInput>
  >;
  multiProcTables?: InputMaybe<Array<DiseaseStateModuleMultiProcTableInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  primaryDataset?: InputMaybe<UpdateDatasetInput>;
  riskMetricDeletionActions?: InputMaybe<Array<RiskMetricDeletionActionInput>>;
  riskMetrics?: InputMaybe<Array<DiseaseStateModuleRiskMetricInput>>;
  summaryCohortId?: InputMaybe<Scalars['Float']['input']>;
  supportedApps?: InputMaybe<Array<SupportedApps>>;
  tableName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateDistributionListInput = {
  allowedFiles?: InputMaybe<Array<UpdateFileInput>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<UpdateTenantInput>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  users?: InputMaybe<Array<UpdateUserInput>>;
};

export type UpdateEchoFollowupOptionInput = {
  careEntities?: InputMaybe<Array<UpdateCareEntityInput>>;
  caselistModule?: InputMaybe<UpdateEchoModuleInput>;
  caselistModuleName?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayRank?: InputMaybe<Scalars['Float']['input']>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<FollowupOptionScope>;
  tenant?: InputMaybe<UpdateTenantInput>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantName?: InputMaybe<Scalars['String']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  updateById?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEchoMessageTemplateInput = {
  common?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<UpdateTenantInput>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  updateById?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEchoModuleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayRank?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEchoReferringProviderInput = {
  contact?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Boolean']['input']>;
  tenant?: InputMaybe<UpdateTenantInput>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateElementInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeSystemName?: InputMaybe<Scalars['String']['input']>;
  codingInstructions?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dataSource?: InputMaybe<ElementDataSourceType>;
  dataType?: InputMaybe<ElementDataType>;
  dbDataType?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  definition?: InputMaybe<CreateDefinitionInput>;
  elementReference?: InputMaybe<Scalars['String']['input']>;
  hideFromReports?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isBaseElement?: InputMaybe<Scalars['Boolean']['input']>;
  isDynamicList?: InputMaybe<Scalars['Boolean']['input']>;
  isFollowupElement?: InputMaybe<Scalars['Boolean']['input']>;
  isHarvested?: InputMaybe<Scalars['Boolean']['input']>;
  isIdentifier?: InputMaybe<Scalars['Boolean']['input']>;
  missingData?: InputMaybe<ElementMissingDataAction>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentChildValidations?: InputMaybe<Array<CreateParentChildValidationInput>>;
  phi?: InputMaybe<Scalars['Boolean']['input']>;
  precision?: InputMaybe<Scalars['String']['input']>;
  ranges?: InputMaybe<Array<CreateRangeInput>>;
  role?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<UpdateSectionInput>;
  sectionId?: InputMaybe<Scalars['String']['input']>;
  selectionType?: InputMaybe<ElementSelectionType>;
  selections?: InputMaybe<Array<CreateSelectionInput>>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  targetValue?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  vendorInstruction?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEntraIdUserInput = {
  adGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  passwordNeverExpires?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userPrincipalName?: InputMaybe<Scalars['String']['input']>;
  /** Unique username */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFileInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  distributionLists?: InputMaybe<Array<UpdateDistributionListInput>>;
  extension?: InputMaybe<Scalars['String']['input']>;
  fileLabel?: InputMaybe<UpdateFileLabelInput>;
  fileUsers?: InputMaybe<Array<FileUserInput>>;
  historicPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  phi?: InputMaybe<Scalars['Boolean']['input']>;
  report?: InputMaybe<UpdateReportInput>;
  reportId?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<UpdateTenantInput>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  updateById?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<UpdateUserInput>>;
};

export type UpdateFileLabelInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  files?: InputMaybe<Array<FileInput>>;
  id: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateGridViewInput = {
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  columnModel?: InputMaybe<Scalars['JSON']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  externalFilters?: InputMaybe<Scalars['JSON']['input']>;
  filterModel?: InputMaybe<Scalars['JSON']['input']>;
  gridId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  moduleId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scope>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHomepageSectionInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  id: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateIdentityProviderInput = {
  authnContext?: InputMaybe<Scalars['String']['input']>;
  certificate?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  defaultRoles?: InputMaybe<Array<UpdateRoleInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  emailAttribute?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entryPoint?: InputMaybe<Scalars['String']['input']>;
  firstNameAttribute?: InputMaybe<Scalars['String']['input']>;
  forceAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  groupAccessType?: InputMaybe<IdentityProviderGroupAccessType>;
  id: Scalars['ID']['input'];
  identifierFormat?: InputMaybe<Scalars['String']['input']>;
  lastNameAttribute?: InputMaybe<Scalars['String']['input']>;
  logoutUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provisionUsers?: InputMaybe<Scalars['Boolean']['input']>;
  securityGroup?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<UpdateTenantInput>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  updateUsers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateLoginRouteInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  identityProvider?: InputMaybe<UpdateIdentityProviderInput>;
};

export type UpdateMeasureMetadataInput = {
  accessCategory?: InputMaybe<AccessCategory>;
  adjustment?: InputMaybe<Array<Scalars['String']['input']>>;
  aggregationFn?: InputMaybe<Array<Scalars['String']['input']>>;
  aggregationType?: InputMaybe<SummaryCalculationType>;
  annualMeasureBaseId?: InputMaybe<Scalars['String']['input']>;
  benchmarkExtraction?: InputMaybe<Scalars['Boolean']['input']>;
  children?: InputMaybe<Array<UpdateMeasureMetadataInput>>;
  commonMeasureDisplayName?: InputMaybe<Scalars['String']['input']>;
  commonMeasureQualifying?: InputMaybe<Scalars['Boolean']['input']>;
  costComponentMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dataTypeRequired?: InputMaybe<MeasureInputDataType>;
  denominatorColumnName?: InputMaybe<Scalars['String']['input']>;
  denominatorPipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  developedOn?: InputMaybe<Scalars['DateTime']['input']>;
  dimensionSets?: InputMaybe<Array<CreateNestedDimensionSetInput>>;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  excludedCohortIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** The updateAt the client loaded. A measure saved since then is rejected with a conflict; omitted, the last write wins. */
  expectedUpdateAt?: InputMaybe<Scalars['DateTime']['input']>;
  family?: InputMaybe<MeasureFamily>;
  hideFromReports?: InputMaybe<Scalars['Boolean']['input']>;
  higherIsBetter?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  includeColumnName?: InputMaybe<Scalars['String']['input']>;
  includePipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  isBenchmark?: InputMaybe<Scalars['Boolean']['input']>;
  losROIQualifying?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ncdrMeasureName?: InputMaybe<Scalars['String']['input']>;
  numeratorColumnName?: InputMaybe<Scalars['String']['input']>;
  numeratorPipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  numeratorUnit?: InputMaybe<Scalars['String']['input']>;
  objects?: InputMaybe<Array<CreateObjectMeasureInput>>;
  opportunityType?: InputMaybe<Array<OpportunityType>>;
  outcomeType?: InputMaybe<MeasureOutcomeType>;
  parent?: InputMaybe<UpdateMeasureMetadataInput>;
  publicationSource?: InputMaybe<Array<PublicationSource>>;
  rareEvent?: InputMaybe<Scalars['Boolean']['input']>;
  registryMeasureId?: InputMaybe<Scalars['Int']['input']>;
  reportRowId?: InputMaybe<Scalars['Int']['input']>;
  requirements?: InputMaybe<Scalars['String']['input']>;
  riskAdjusted?: InputMaybe<Scalars['Boolean']['input']>;
  riskMetricId?: InputMaybe<Scalars['String']['input']>;
  riskMetricPipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  roiCalcType?: InputMaybe<SummaryCalculationType>;
  roiMetrics?: InputMaybe<Array<UpdateRoiMetricInput>>;
  /** Requires family and must differ from it; cleared when family is cleared. */
  secondaryFamily?: InputMaybe<MeasureFamily>;
  subjects?: InputMaybe<Array<CreateSubjectMeasureInput>>;
  summaryCohortId?: InputMaybe<Scalars['Float']['input']>;
  summaryInitiativeMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  tableName?: InputMaybe<Scalars['String']['input']>;
  tableauViews?: InputMaybe<Array<CreateMeasureTableauViewInput>>;
  testCapture?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  validationSource?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  volumeMeasure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateNestedDimensionValueSortOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  sortOrder: Scalars['Int']['input'];
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  valueLabel: Scalars['String']['input'];
};

export type UpdateNotificationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotificationType>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  users?: InputMaybe<Array<UpdateUserInput>>;
};

export type UpdateObjectiveInput = {
  attachStrategyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  careEntity?: InputMaybe<UpdateCareEntityInput>;
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  cohortIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  diseaseStateModuleId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  /** Source: Perf Api initiative list */
  initiativeId?: InputMaybe<Scalars['Float']['input']>;
  measures?: InputMaybe<Array<UpdateMeasureMetadataInput>>;
  /** Title of the objective, populate based on measure & cohort in case of Opportunity objective */
  name?: InputMaybe<Scalars['String']['input']>;
  participants?: InputMaybe<Array<CreateObjectiveParticipantInput>>;
  strategies?: InputMaybe<Array<UpdateObjectiveStrategyInput>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tenant?: InputMaybe<UpdateTenantInput>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  updateById?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateObjectiveStrategyInput = {
  associations?: InputMaybe<Scalars['String']['input']>;
  checkpointDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objective?: InputMaybe<UpdateObjectiveInput>;
  participants?: InputMaybe<Array<CreateObjectiveParticipantInput>>;
  physicianChampions?: InputMaybe<Array<CreateObjectiveParticipantInput>>;
  processSponsors?: InputMaybe<Array<CreateObjectiveParticipantInput>>;
  resources?: InputMaybe<Array<UpdateStrategyResourceInput>>;
  showInPerformanceMonitor?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ObjectiveStrategyStatus>;
  template?: InputMaybe<UpdateObjectiveStrategyTemplateInput>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateObjectiveStrategyTemplateInput = {
  allDiseaseStateModules?: InputMaybe<Scalars['Boolean']['input']>;
  allMeasures?: InputMaybe<Scalars['Boolean']['input']>;
  /** Saved strategy whose attachments are copied onto the new template */
  copyAttachmentsFromStrategyId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  diseaseStateModuleId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  measures?: InputMaybe<Array<UpdateMeasureMetadataInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  resources?: InputMaybe<Array<UpdateStrategyResourceInput>>;
  strategies?: InputMaybe<Array<UpdateObjectiveStrategyInput>>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateObjectiveTemplateInput = {
  cohortIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  diseaseStateModuleId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  measures?: InputMaybe<Array<UpdateMeasureMetadataInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  strategyTemplateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdatePipelineElementInput = {
  biomeDictionaryElements?: InputMaybe<Array<UpdateElementInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dataframe?: InputMaybe<Scalars['String']['input']>;
  documentation?: InputMaybe<Documentation>;
  id: Scalars['ID']['input'];
  pipelineMetadata?: InputMaybe<UpdatePipelineMetadataInput>;
  qualifiedName?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdatePipelineMetadataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  id: Scalars['ID']['input'];
  isLatest?: InputMaybe<Scalars['Boolean']['input']>;
  pipelineElements?: InputMaybe<Array<UpdatePipelineElementInput>>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePresentationInput = {
  clonedFor?: InputMaybe<Array<Scalars['String']['input']>>;
  clonesGenerated?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  cropConfig?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  diseaseStateModuleId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  imagesRefreshedAt?: InputMaybe<Scalars['DateTime']['input']>;
  latestJobId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overwriteManualCropConfig?: InputMaybe<Scalars['Boolean']['input']>;
  presentationType?: InputMaybe<PresentationType>;
  refreshJobId?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<UpdateTenantInput>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateReportInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dateColumn?: InputMaybe<Scalars['String']['input']>;
  dateRangeType?: InputMaybe<DateRangeTypes>;
  dimensions?: InputMaybe<Array<UpdateDimensionInput>>;
  diseaseStateModuleId?: InputMaybe<Scalars['Int']['input']>;
  distributionLists?: InputMaybe<Array<UpdateDistributionListInput>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  measures?: InputMaybe<Array<UpdateMeasureMetadataInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  procedures?: InputMaybe<Array<Scalars['String']['input']>>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  registryElements?: InputMaybe<Array<UpdateElementInput>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<UpdateTenantInput>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  users?: InputMaybe<Array<UpdateUserInput>>;
};

export type UpdateRiskAuditInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  auditId: Scalars['Float']['input'];
  biomeETLVersion?: InputMaybe<Scalars['String']['input']>;
  biomeEncounterId: Scalars['Float']['input'];
  biomeUpdateDt?: InputMaybe<Scalars['DateTime']['input']>;
  careEntity?: InputMaybe<UpdateCareEntityInput>;
  careEntityCode?: InputMaybe<Scalars['String']['input']>;
  careEntityId?: InputMaybe<Scalars['String']['input']>;
  careEntityName?: InputMaybe<Scalars['String']['input']>;
  diagnosisPOACodeList?: InputMaybe<Scalars['String']['input']>;
  dischargeDate?: InputMaybe<Scalars['DateTime']['input']>;
  dischargeQuarter?: InputMaybe<Scalars['String']['input']>;
  dischargeYear?: InputMaybe<Scalars['String']['input']>;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  diseaseStateModuleId?: InputMaybe<Scalars['String']['input']>;
  encounterId?: InputMaybe<Scalars['String']['input']>;
  keyField?: InputMaybe<Scalars['String']['input']>;
  keyFieldValue?: InputMaybe<Scalars['String']['input']>;
  mrn?: InputMaybe<Scalars['String']['input']>;
  procedure?: InputMaybe<Scalars['String']['input']>;
  procedureDate?: InputMaybe<Scalars['DateTime']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  registryId?: InputMaybe<Scalars['String']['input']>;
  reviewTriggerDescription?: InputMaybe<Scalars['String']['input']>;
  riskReview?: InputMaybe<Scalars['String']['input']>;
  riskValue?: InputMaybe<Scalars['String']['input']>;
  surgicalQuarter?: InputMaybe<Scalars['String']['input']>;
  surgicalYear?: InputMaybe<Scalars['String']['input']>;
  tenantCode?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  trails?: InputMaybe<Array<UpdateRiskAuditTrailInput>>;
  visitId?: InputMaybe<Scalars['Float']['input']>;
  visitTiming?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateRiskAuditTrailInput = {
  auditTask?: InputMaybe<UpdateRiskAuditInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  diseaseStateModuleId?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  latestStudyOnRecord?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Tracks the status of audit trail */
  status?: InputMaybe<RiskAuditTrailStatus>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  updateById?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRoiMetricInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  higherIsBetter?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  legacyDescription?: InputMaybe<Scalars['String']['input']>;
  pipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateRoleInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tenant: UpdateTenantInput;
  type?: InputMaybe<RoleType>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  users?: InputMaybe<Array<UpdateUserInput>>;
};

export type UpdateSectionInput = {
  cardinality?: InputMaybe<CardinalityType>;
  containerClass?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dictionary?: InputMaybe<UpdateDictionaryInput>;
  elements?: InputMaybe<Array<CreateElementInput>>;
  hideFromReports?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  parent?: InputMaybe<SectionInput>;
  parentSection?: InputMaybe<Scalars['String']['input']>;
  sectionCode?: InputMaybe<Scalars['String']['input']>;
  sectionDisplayName?: InputMaybe<Scalars['String']['input']>;
  sectionType?: InputMaybe<SectionType>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateSelectionInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeSystemName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  element?: InputMaybe<UpdateElementInput>;
  id: Scalars['ID']['input'];
  selectionDefinition?: InputMaybe<Scalars['String']['input']>;
  selectionName?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateSlideInput = {
  configuredDashboard?: InputMaybe<UpdateTableauViewInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  defaultCropConfig?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<UpdateFileInput>;
  imageConfig?: InputMaybe<ImageConfigInput>;
  imageFetchedAt?: InputMaybe<Scalars['DateTime']['input']>;
  imageStatus?: InputMaybe<SlideImageStatus>;
  isNative?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  presentation?: InputMaybe<UpdatePresentationInput>;
  presentationId?: InputMaybe<Scalars['String']['input']>;
  shareableLink?: InputMaybe<Scalars['String']['input']>;
  slideType?: InputMaybe<SlideType>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateStrategyResourceInput = {
  displayText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  url: Scalars['String']['input'];
};

export type UpdateSubmissionInput = {
  aggregate?: InputMaybe<Scalars['Boolean']['input']>;
  cadence?: InputMaybe<Scalars['String']['input']>;
  careEntity?: InputMaybe<UpdateCareEntityInput>;
  ccEmails?: InputMaybe<Scalars['String']['input']>;
  children?: InputMaybe<Array<UpdateSubmissionInput>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dataset?: InputMaybe<UpdateDatasetInput>;
  daysAfterDeadline?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  mrnCrosswalkRequired?: InputMaybe<Scalars['Boolean']['input']>;
  mrnHarvestRequired?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  sendReminders?: InputMaybe<Scalars['Boolean']['input']>;
  submitNationalReport?: InputMaybe<Scalars['Boolean']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  user?: InputMaybe<UpdateUserInput>;
};

export type UpdateTableauViewInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  primaryMeasureIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  renderInMenu?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryMeasureIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  workbook?: InputMaybe<UpdateWorkbookInput>;
};

export type UpdateTenantInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  aggregationTenant?: InputMaybe<Scalars['Boolean']['input']>;
  banner?: InputMaybe<FileInput>;
  careEntities?: InputMaybe<Array<UpdateCareEntityInput>>;
  casesSchema?: InputMaybe<Scalars['String']['input']>;
  clinicalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  contractedDisplayPHI?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  deliverableBlinded?: InputMaybe<Scalars['Boolean']['input']>;
  disableBiomedataLogin?: InputMaybe<Scalars['Boolean']['input']>;
  disableHomepage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Care entities of this tenant to clear Is Engagement Entity on. Their tenant link and DSM lists are left untouched. */
  disengagedCareEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  documents?: InputMaybe<Array<FileInput>>;
  echoModules?: InputMaybe<Array<UpdateEchoModuleInput>>;
  encryptionKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  /** IT contact email for the tenant. */
  itContact?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationalUnit?: InputMaybe<Scalars['String']['input']>;
  projectSponsor?: InputMaybe<UpdateUserInput>;
  projectSponsorId?: InputMaybe<Scalars['String']['input']>;
  rollupMode?: InputMaybe<AggregationRollupMode>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  usesAnubisUpload?: InputMaybe<Scalars['Boolean']['input']>;
  /** Replaces the workbooks the tenant sees */
  workbooks?: InputMaybe<Array<UpdateWorkbookInput>>;
};

export type UpdateThreadInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTranslationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  id: Scalars['ID']['input'];
  source?: InputMaybe<UpdateElementInput>;
  target?: InputMaybe<UpdateElementInput>;
  transformation?: InputMaybe<CreateTransformationInput>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  valueMap?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateTranslatorConfigInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dataFeed?: InputMaybe<CreateTranslatorConfigPayloadInput>;
  feedDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  source?: InputMaybe<UpdateDictionaryInput>;
  target?: InputMaybe<UpdateDictionaryInput>;
  translations?: InputMaybe<Array<CreateTranslationInput>>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserAccountInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<Array<UpdateNotificationInput>>;
  otherEmails?: InputMaybe<Array<OtherEmailInput>>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  adGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedFiles?: InputMaybe<Array<UpdateFileInput>>;
  careEntityCode?: InputMaybe<Scalars['String']['input']>;
  ccOnboardingEmail?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<CreateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  disableBiomedataLogin?: InputMaybe<Scalars['Boolean']['input']>;
  distributionLists?: InputMaybe<Array<UpdateDistributionListInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  enableSftp?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Time when the user was enabled. This is used to keep certain items on the UI disabled until this change is synced to Azure AD. */
  enabledTime?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  homepage?: InputMaybe<CreateBookmarkInput>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<Array<UpdateNotificationInput>>;
  organizationalUnit?: InputMaybe<Scalars['String']['input']>;
  otherEmails?: InputMaybe<Array<OtherEmailInput>>;
  passwordNeverExpires?: InputMaybe<Scalars['Boolean']['input']>;
  permanentAccount?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<UpdateRoleInput>>;
  root?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<UserStatus>;
  submissions?: InputMaybe<Array<UpdateSubmissionInput>>;
  submitsData?: InputMaybe<Scalars['Boolean']['input']>;
  tenant?: InputMaybe<UpdateTenantInput>;
  tenantPolicies?: InputMaybe<Array<TenantPolicyInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  twoFactor?: InputMaybe<Scalars['Boolean']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  /** Unique username */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkbookGroupInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  renderAsLink?: InputMaybe<Scalars['Boolean']['input']>;
  renderInMenu?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  workbooks?: InputMaybe<Array<UpdateWorkbookInput>>;
};

export type UpdateWorkbookInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  id: Scalars['Int']['input'];
  measureIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  tableauUri?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Tags>>;
  /** Active tenants that see this workbook and its dashboards; links to disabled tenants are left unchanged. */
  tenants?: InputMaybe<Array<UpdateTenantInput>>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  workbookGroup?: InputMaybe<UpdateWorkbookGroupInput>;
};

export enum UsGeoRegion {
  Canada = 'Canada',
  EastSouthCentral = 'EastSouthCentral',
  GreatLakes = 'GreatLakes',
  GreatPlains = 'GreatPlains',
  MiddleAtlantic = 'MiddleAtlantic',
  Mountain = 'Mountain',
  NewEngland = 'NewEngland',
  Pacific = 'Pacific',
  SouthAtlantic = 'SouthAtlantic',
  WestSouthCentral = 'WestSouthCentral',
}

export type User = {
  __typename?: 'User';
  adGroups?: Maybe<Array<Scalars['String']['output']>>;
  bookmarks?: Maybe<Array<Bookmark>>;
  /** Explicit care-entity value used for the CARE_ENTITY segment of this user's ingestion filenames. Null means "use tenant.code", which is the case for very nearly every user. */
  careEntityCode?: Maybe<Scalars['String']['output']>;
  ccOnboardingEmail?: Maybe<Scalars['String']['output']>;
  clientDataFiles?: Maybe<ClientDataFile>;
  /** Creation Datetime */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Additional details about the user account */
  description?: Maybe<Scalars['String']['output']>;
  disableBiomedataLogin: Scalars['Boolean']['output'];
  distributionLists?: Maybe<Array<DistributionList>>;
  email: Scalars['String']['output'];
  enableSftp: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  /** Time when the user was enabled. This is used to keep certain items on the UI disabled until this change is synced to Azure AD. */
  enabledTime?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<Array<FileDistributionList>>;
  firstName: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  homepage?: Maybe<Bookmark>;
  /** Auto increment ID */
  id: Scalars['ID']['output'];
  identityStore?: Maybe<Scalars['String']['output']>;
  initialPasswordResetDate?: Maybe<Scalars['DateTime']['output']>;
  jobs?: Maybe<Array<Job>>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  logins?: Maybe<Array<UserLogin>>;
  notificationLogs?: Maybe<Array<NotificationLogs>>;
  notifications?: Maybe<Array<Notification>>;
  organizationalUnit?: Maybe<Scalars['String']['output']>;
  otherEmails?: Maybe<Array<OtherEmail>>;
  passwordNeverExpires: Scalars['Boolean']['output'];
  permanentAccount: Scalars['Boolean']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  recentTableauViews?: Maybe<Array<RecentTableauView>>;
  roles?: Maybe<Array<Role>>;
  root: Scalars['Boolean']['output'];
  sponsoredTenants?: Maybe<Array<Tenant>>;
  /** Tracks the status of user account activation */
  status?: Maybe<UserStatus>;
  submissions?: Maybe<Array<Submission>>;
  submitsData: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  tokens?: Maybe<Array<Token>>;
  twoFactor?: Maybe<Scalars['Boolean']['output']>;
  /** Modification Datetime */
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  userLastLogin?: Maybe<UserLastLogin>;
  /** Unique username */
  username: Scalars['String']['output'];
};

export type UserAccessChange = {
  __typename?: 'UserAccessChange';
  changedByName?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  event?: Maybe<AccessChangeEvent>;
  id: Scalars['ID']['output'];
  otherAccessFields?: Maybe<Scalars['String']['output']>;
  roleNames: Array<Scalars['String']['output']>;
};

export type UserAccessChanges = {
  __typename?: 'UserAccessChanges';
  changes: Array<UserAccessChange>;
  userCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  userCreatedByName?: Maybe<Scalars['String']['output']>;
};

export type UserAudit = {
  __typename?: 'UserAudit';
  accessModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  allowedCareEntityDsms: Array<CareEntityDsmPair>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataRefreshEmailsEnabled: Scalars['Boolean']['output'];
  distributionLists: Array<UserAuditDistributionList>;
  echoSummaryEmailsEnabled: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  lastLoginDate?: Maybe<Scalars['DateTime']['output']>;
  lastRefreshedAt?: Maybe<Scalars['DateTime']['output']>;
  riskAuditEmailsEnabled: Scalars['Boolean']['output'];
  roles: Array<UserAuditRole>;
  submitsData: Scalars['Boolean']['output'];
  userId: Scalars['ID']['output'];
  username: Scalars['String']['output'];
};

export type UserAuditDistributionList = {
  __typename?: 'UserAuditDistributionList';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UserAuditRole = {
  __typename?: 'UserAuditRole';
  careEntityIds: Array<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  dsmIds: Array<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: RoleType;
};

export type UserLastLogin = {
  __typename?: 'UserLastLogin';
  lastLoginDate: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type UserLogin = {
  __typename?: 'UserLogin';
  /** Auto Generated ID */
  id: Scalars['ID']['output'];
  identityProvider: IdentityProvider;
  ipAddress: Scalars['String']['output'];
  loginDate: Scalars['DateTime']['output'];
  user: User;
  userAgent: Scalars['String']['output'];
};

export type UserPolicyInput = {
  action: Scalars['String']['input'];
  attribute: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  eft?: InputMaybe<Scalars['String']['input']>;
  objectType: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export enum UserStatus {
  Activated = 'ACTIVATED',
  Initiated = 'INITIATED',
  Pending = 'PENDING',
}

export type Vad = {
  __typename?: 'Vad';
  admin7DayReadmission?: Maybe<Scalars['String']['output']>;
  admin7DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin14DayReadmission?: Maybe<Scalars['String']['output']>;
  admin14DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin30DayReadmission?: Maybe<Scalars['String']['output']>;
  admin30DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  adminInOutCode?: Maybe<Scalars['String']['output']>;
  adminMatch?: Maybe<Scalars['Float']['output']>;
  admissionUnit?: Maybe<Scalars['String']['output']>;
  admitDayOfWeek?: Maybe<Scalars['String']['output']>;
  admitSourceName?: Maybe<Scalars['String']['output']>;
  admitType?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  ageGroup?: Maybe<Scalars['String']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  anyVADProcedure?: Maybe<Scalars['String']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  attribute?: Maybe<Scalars['String']['output']>;
  bedDays?: Maybe<Scalars['Float']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomePayor?: Maybe<Scalars['String']['output']>;
  cardiacArrest?: Maybe<Scalars['String']['output']>;
  cardiacUS?: Maybe<Scalars['String']['output']>;
  cardioMEMS?: Maybe<Scalars['String']['output']>;
  cardioShock?: Maybe<Scalars['String']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  cath?: Maybe<Scalars['String']['output']>;
  chfAcute?: Maybe<Scalars['String']['output']>;
  chfAcuteOnChronic?: Maybe<Scalars['String']['output']>;
  chfChronicUspec?: Maybe<Scalars['String']['output']>;
  ckdStageIVorV?: Maybe<Scalars['String']['output']>;
  clinicianAFirstName?: Maybe<Scalars['String']['output']>;
  clinicianALastName?: Maybe<Scalars['String']['output']>;
  clinicianName?: Maybe<Scalars['String']['output']>;
  cmi?: Maybe<Scalars['String']['output']>;
  conditionGrouperL2?: Maybe<Scalars['String']['output']>;
  ctScan?: Maybe<Scalars['String']['output']>;
  daysToReadmission?: Maybe<Scalars['String']['output']>;
  daysToReadmissionBins?: Maybe<Scalars['String']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDayOfWeek?: Maybe<Scalars['String']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  dischargeMDName?: Maybe<Scalars['String']['output']>;
  dischargeStatus?: Maybe<Scalars['String']['output']>;
  dischargeUnit?: Maybe<Scalars['String']['output']>;
  distanceFromHospital?: Maybe<Scalars['String']['output']>;
  distanceInMilesBucket?: Maybe<Scalars['String']['output']>;
  drgCodeName?: Maybe<Scalars['String']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  elixhauserIndex?: Maybe<Scalars['Int']['output']>;
  elixhauserRiskBuckets?: Maybe<Scalars['String']['output']>;
  encounterId?: Maybe<Scalars['Float']['output']>;
  endStageRenal?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  heartTransplant?: Maybe<Scalars['String']['output']>;
  heartTransplantType?: Maybe<Scalars['String']['output']>;
  hypovolShock?: Maybe<Scalars['String']['output']>;
  icdDxCodeCategory?: Maybe<Scalars['String']['output']>;
  icuDaysNumerator?: Maybe<Scalars['Int']['output']>;
  icuUtilizationAny?: Maybe<Scalars['String']['output']>;
  inDirectCost?: Maybe<Scalars['Float']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  losLess1?: Maybe<Scalars['String']['output']>;
  losLess2?: Maybe<Scalars['String']['output']>;
  mdcName?: Maybe<Scalars['String']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  medicare?: Maybe<Scalars['String']['output']>;
  mitraClip?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mortality?: Maybe<Scalars['Int']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  multiVisit?: Maybe<Scalars['Int']['output']>;
  netRevenue?: Maybe<Scalars['Float']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  otherShock?: Maybe<Scalars['String']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  overall?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  primaryProcPostLOSMore2?: Maybe<Scalars['String']['output']>;
  primaryProcPreLOSLess1?: Maybe<Scalars['String']['output']>;
  principalDiagnosisICDCodeName?: Maybe<Scalars['String']['output']>;
  principalProcedureICDCodeName?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  procedureMDName?: Maybe<Scalars['String']['output']>;
  pulmonaryEmbol?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  rawAdmitSourceName?: Maybe<Scalars['String']['output']>;
  rawDischargeStatus?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionAdmitDayOfWeek?: Maybe<Scalars['String']['output']>;
  readmissionAdmitSourceName?: Maybe<Scalars['String']['output']>;
  readmissionAdmitType?: Maybe<Scalars['String']['output']>;
  readmissionConditionGrouperL2?: Maybe<Scalars['String']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDischargeStatus?: Maybe<Scalars['String']['output']>;
  readmissionDrgName?: Maybe<Scalars['String']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  readmissionICDPrimaryProcedure?: Maybe<Scalars['String']['output']>;
  readmissionInOutCode?: Maybe<Scalars['String']['output']>;
  readmissionReason?: Maybe<Scalars['String']['output']>;
  readmissionSummaryPayorClass?: Maybe<Scalars['String']['output']>;
  readmissionWithWithout?: Maybe<Scalars['String']['output']>;
  referringMDRole?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  renalFailAcute?: Maybe<Scalars['String']['output']>;
  respArrest?: Maybe<Scalars['String']['output']>;
  respFailAcute?: Maybe<Scalars['String']['output']>;
  sepsis?: Maybe<Scalars['String']['output']>;
  tavr?: Maybe<Scalars['String']['output']>;
  transplantType?: Maybe<Scalars['String']['output']>;
  vadPoa?: Maybe<Scalars['String']['output']>;
  vadPrimaryProcedure?: Maybe<Scalars['String']['output']>;
  vadProcedureType?: Maybe<Scalars['String']['output']>;
  ventrFibrillation?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
  visitsPerEpisode?: Maybe<Scalars['Int']['output']>;
};

export enum ValidationStatus {
  Error = 'Error',
  Failed = 'Failed',
  InProgress = 'InProgress',
  ManualOverride = 'ManualOverride',
  Pending = 'Pending',
  Success = 'Success',
}

export type Vascular = {
  __typename?: 'Vascular';
  admin7DayReadmission?: Maybe<Scalars['String']['output']>;
  admin7DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin14DayReadmission?: Maybe<Scalars['String']['output']>;
  admin14DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  admin30DayReadmission?: Maybe<Scalars['String']['output']>;
  admin30DayReturnEDVisit?: Maybe<Scalars['String']['output']>;
  adminInOutCode?: Maybe<Scalars['String']['output']>;
  adminMatch?: Maybe<Scalars['Float']['output']>;
  admissionUnit?: Maybe<Scalars['String']['output']>;
  admitSourceName?: Maybe<Scalars['String']['output']>;
  admitType?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  anchorDt?: Maybe<Scalars['DateTime']['output']>;
  arrivalDt?: Maybe<Scalars['DateTime']['output']>;
  bedDays?: Maybe<Scalars['Float']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomePayor?: Maybe<Scalars['String']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  clinicianAFirstName?: Maybe<Scalars['String']['output']>;
  clinicianALastName?: Maybe<Scalars['String']['output']>;
  clinicianName?: Maybe<Scalars['String']['output']>;
  cmi?: Maybe<Scalars['String']['output']>;
  conditionGrouperL2?: Maybe<Scalars['String']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  directCost?: Maybe<Scalars['Float']['output']>;
  dischargeDt?: Maybe<Scalars['DateTime']['output']>;
  dischargeMDName?: Maybe<Scalars['String']['output']>;
  dischargeUnit?: Maybe<Scalars['String']['output']>;
  drgCodeName?: Maybe<Scalars['String']['output']>;
  dsm: DiseaseStateModule;
  dsmId?: Maybe<Scalars['Int']['output']>;
  elixhauserIndex?: Maybe<Scalars['Int']['output']>;
  encounterId?: Maybe<Scalars['Float']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  icdDxCodeCategory?: Maybe<Scalars['String']['output']>;
  icuDaysNumerator?: Maybe<Scalars['Int']['output']>;
  inDirectCost?: Maybe<Scalars['Float']['output']>;
  include?: Maybe<Scalars['Int']['output']>;
  measureId: Scalars['Int']['output'];
  measureName?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  mortality?: Maybe<Scalars['Int']['output']>;
  mrn?: Maybe<Scalars['Float']['output']>;
  mrnoriginal?: Maybe<Scalars['String']['output']>;
  multiVisit?: Maybe<Scalars['Int']['output']>;
  netRevenue?: Maybe<Scalars['Float']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  patZip?: Maybe<Scalars['String']['output']>;
  principalDiagnosisICDCodeName?: Maybe<Scalars['String']['output']>;
  principalProcedureICDCodeName?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  procedureMDName?: Maybe<Scalars['String']['output']>;
  quarter?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  rawAdmitSourceName?: Maybe<Scalars['String']['output']>;
  rawDischargeStatus?: Maybe<Scalars['String']['output']>;
  readmissionAdmitDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionDischargeDate?: Maybe<Scalars['DateTime']['output']>;
  readmissionICDPrimaryDiagnosis?: Maybe<Scalars['String']['output']>;
  readmissionWithWithout?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  vascularCodeType?: Maybe<Scalars['String']['output']>;
  vascularPrimaryProcInOutCode?: Maybe<Scalars['String']['output']>;
  visitId: Scalars['Int']['output'];
  visitsPerEpisode?: Maybe<Scalars['Int']['output']>;
};

export type Video = {
  __typename?: 'Video';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type VideoGuide = {
  __typename?: 'VideoGuide';
  nextPageToken?: Maybe<Scalars['String']['output']>;
  prevPageToken?: Maybe<Scalars['String']['output']>;
  totalResults: Scalars['Float']['output'];
  videos: Array<Video>;
};

export enum VisibilityType {
  Default = 'DEFAULT',
  Hidden = 'HIDDEN',
  Visible = 'VISIBLE',
}

export type Workbook = {
  __typename?: 'Workbook';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description: Scalars['String']['output'];
  diseaseStateModule?: Maybe<DiseaseStateModule>;
  diseaseStateModuleId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  measureIds?: Maybe<Array<Scalars['Int']['output']>>;
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  /** Legacy Tableau contentUrl of the workbook, e.g. Cath-FaceSheet in .../views/Cath-FaceSheet/OEBleedingEvents */
  tableauUri: Scalars['String']['output'];
  tableauViews?: Maybe<Array<TableauView>>;
  tags?: Maybe<Array<Tags>>;
  tenants?: Maybe<Array<Tenant>>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  workbookGroup?: Maybe<WorkbookGroup>;
  workbookGroupId?: Maybe<Scalars['Int']['output']>;
};

export type WorkbookGroup = {
  __typename?: 'WorkbookGroup';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description: Scalars['String']['output'];
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModuleId: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  renderAsLink: Scalars['Boolean']['output'];
  renderInMenu: Scalars['Boolean']['output'];
  sortOrder: Scalars['Float']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  workbooks?: Maybe<Array<Workbook>>;
};
